const reportPartsExampleMap = {
  preview_default: {
    success: true,
    data: {
      parts: [
        {
          type: 'risks',
          status: 'Calculated',
          data: {
            totalScore: null,
            score: {
              sof: [
                {
                  _id: '1',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
                {
                  _id: '2',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
                {
                  _id: '3',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
              ],
              uof: [
                {
                  _id: '1',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
                {
                  _id: '2',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
                {
                  _id: '3',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
              ],
            },
            owner: {
              status: 'Identified',
              owner: 'Secondeye Solution',
              description: '',
              type: {},
              tags: [
                {
                  _id: '1',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
                {
                  _id: '2',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
              ],
              entityData: {
                id: '682af0473be18468d7f0579d',
                name: 'Binance x',
                owner: 'Binance x',
                type: {},
                logo: 'logo-data',
              },
              clusterData: {
                _id: '61e2d2c92b94237d8aecb9d8',
                cluster: 34203831,
                addressCount: 9197146,
                address: '11122HJJZWxk2mtTjitrEWRFAfPjEpYeDc',
                owner: 'Binance x',
                description: '',
                updatedAt: '2024-10-02T08:04:28.613Z',
                prevAddress: '12AnyuG898JojxA17T63e6wQcXm7SwBzCN',
                entity: '65a8e2c98bc257cd15e58c41',
                entityData: {
                  logo: 'logo-data',
                  id: '65a8e2c98bc257cd15e58c41',
                  name: 'Binance x',
                  owner: 'Binance x',
                },
                tags: [
                  {
                    _id: '1',
                    name: 'sanction',
                    score: 100,
                    meta: '',
                  },
                  {
                    _id: '2',
                    name: 'sanction',
                    score: 100,
                    meta: '',
                  },
                ],
                type: {},
                meta: [],
                clusterSize: 9197146,
                conflict: false,
              },
            },
          },
        },
        {
          type: 'tier2',
          status: 'TIER2 Found',
          data: {
            labelBarsSof: [
              {
                directTx:
                  '0x899f1bb885d288721a25fd032d9879d97f845d15e6d779ff61e14422a44ef13b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'marketplace',
                  score: 40,
                  id: '6604a0ed8d004d1f88b8a4b2',
                  type: 'marketplace',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 4006994793500000000,
                amountCur: 15483.224738277662,
                currency: '',
                tx_hash:
                  '0x899f1bb885d288721a25fd032d9879d97f845d15e6d779ff61e14422a44ef13b',
                address: '0x00000000006c3852cbef3e08e8df289169ede581',
                directStamp: 1664531087,
                timestamp: 1664531087,
                listType: 'Known sources',
                share: 0.9,
                amountDec: 0.78625,
                deepDepthShare: 0.8,
                generalShare: 0.1,
                price: null,
                originalShare: 0.9,
              },
              {
                directTx:
                  '0x41ec849a95f3a8526876d300d26ad1b017c7fed6c2a33e9c2be2335c9ae21d37',
                directionUp: false,
                token: '',
                funds: {
                  name: 'smart contract',
                  score: 50,
                  default: true,
                  type: 'smart contract',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 1.411005876372823e24,
                amountCur: 37406.67052986267,
                currency: '',
                tx_hash:
                  '0x41ec849a95f3a8526876d300d26ad1b017c7fed6c2a33e9c2be2335c9ae21d37',
                address: '0x0000000000000068f116a894984e2db1123eb395',
                directStamp: 1742201411,
                timestamp: 1742201411,
                listType: 'Unknown sources',
                share: 0.1,
                amountDec: 0.46305,
                deepDepthShare: 0.1,
                generalShare: 0.0,
                price: null,
                originalShare: 0.1,
              },
            ],
            labelBarsUof: [
              {
                directTx:
                  '0x899f1bb885d288721a25fd032d9879d97f845d15e6d779ff61e14422a44ef13b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'marketplace',
                  score: 40,
                  id: '6604a0ed8d004d1f88b8a4b2',
                  type: 'marketplace',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 4006994793500000000,
                amountCur: 15483.224738277662,
                currency: '',
                tx_hash:
                  '0x899f1bb885d288721a25fd032d9879d97f845d15e6d779ff61e14422a44ef13b',
                address: '0x00000000006c3852cbef3e08e8df289169ede581',
                directStamp: 1664531087,
                timestamp: 1664531087,
                listType: 'Known sources',
                share: 0.9,
                amountDec: 0.78625,
                deepDepthShare: 0.9,
                generalShare: 0.0,
                price: null,
                originalShare: 0.9,
              },
              {
                directTx:
                  '0x41ec849a95f3a8526876d300d26ad1b017c7fed6c2a33e9c2be2335c9ae21d37',
                directionUp: true,
                token: '',
                funds: {
                  name: 'smart contract',
                  score: 50,
                  default: true,
                  type: 'smart contract',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 1.411005876372823e24,
                amountCur: 37406.67052986267,
                currency: '',
                tx_hash:
                  '0x41ec849a95f3a8526876d300d26ad1b017c7fed6c2a33e9c2be2335c9ae21d37',
                address: '0x0000000000000068f116a894984e2db1123eb395',
                directStamp: 1742201411,
                timestamp: 1742201411,
                listType: 'Unknown sources',
                share: 0.1,
                amountDec: 0.46305,
                deepDepthShare: 0.1,
                generalShare: 0.0,
                price: null,
                originalShare: 0.1,
              },
            ],
            evaluatedSofTxs: 1000,
            evaluatedUofTxs: 1000,
            currencies: {},
            sources: [],
          },
        },
        {
          type: 'sof',
          status: 'SOF Found',
          data: {
            sources: [
              {
                directTx:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 11442705.346663631,
                amountCur: 13476.182447314022,
                currency: '',
                tx_hash:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                address:
                  'bc1pc6plmlxyg2qjfe6wfv3jqgvdcsx47jh7j0p3tjkeg9ec6232lfeqe6cn6t',
                cluster: 3310,
                directStamp: 1700648582,
                timestamp: 1700648582,
                listType: 'Risky sources',
                share: 0.4614294814495864,
                amountDec: 0.11442705346663631,
              },
              {
                directTx:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 3779283,
                amountCur: 4450.897378291937,
                currency: '',
                tx_hash:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1688055567,
                timestamp: 1688055567,
                listType: 'Known sources',
                share: 0.15240037579484655,
                amountDec: 0.03779283,
              },
            ],
            currencies: {},
          },
        },
        {
          type: 'uof',
          status: 'UOF Found',
          data: {
            sources: [
              {
                directTx:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 11442705.346663631,
                amountCur: 13476.182447314022,
                currency: '',
                tx_hash:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                address:
                  'bc1pc6plmlxyg2qjfe6wfv3jqgvdcsx47jh7j0p3tjkeg9ec6232lfeqe6cn6t',
                cluster: 3310,
                directStamp: 1700648582,
                timestamp: 1700648582,
                listType: 'Risky sources',
                share: 0.4614294814495864,
                amountDec: 0.11442705346663631,
              },
              {
                directTx:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 3779283,
                amountCur: 4450.897378291937,
                currency: '',
                tx_hash:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1688055567,
                timestamp: 1688055567,
                listType: 'Known sources',
                share: 0.15240037579484655,
                amountDec: 0.03779283,
              },
              {
                directTx:
                  'b8355ff67b1c230df717c54e5b097b502cb45f5a250080822a2bdce1ae456fe6',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 1011094.2419558349,
                amountCur: 1190.775263648501,
                currency: '',
                tx_hash:
                  'b8355ff67b1c230df717c54e5b097b502cb45f5a250080822a2bdce1ae456fe6',
                address: null,
                cluster: 3310,
                directStamp: 1732382148,
                timestamp: 1732382148,
                listType: 'Risky sources',
                share: 0.04077258634457243,
                amountDec: 0.01011094241955835,
              },
            ],
            currencies: {},
          },
        },
        {
          type: 'full',
          status: 'All information',
          data: {
            entityBarsSof: [
              {
                directTx:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                  type: 'Suspended exchange',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 19277593.01064663,
                amountCur: 22703.403844291628,
                currency: '',
                tx_hash:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                address:
                  'bc1pc6plmlxyg2qjfe6wfv3jqgvdcsx47jh7j0p3tjkeg9ec6232lfeqe6cn6t',
                cluster: 3310,
                directStamp: 1700648582,
                timestamp: 1700648582,
                listType: 'Risky sources',
                share: 0.7,
                amountDec: 0.11442705346663631,
                deepDepthShare: 0.7,
                generalShare: 0.0,
                price: null,
                originalShare: 0.7,
              },
              {
                directTx:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 4660671.890667313,
                amountCur: 5488.917421439482,
                currency: '',
                tx_hash:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1688055567,
                timestamp: 1688055567,
                listType: 'Known sources',
                share: 0.2,
                amountDec: 0.03779283,
                deepDepthShare: 0.1,
                generalShare: 0.1,
                price: null,
                originalShare: 0.2,
              },
              {
                directTx:
                  '4e2d99e9dbb7e10777eea046908c7f6c32110004efafbd777b0b93cb581646ee',
                directionUp: false,
                token: '',
                funds: {
                  name: 'maximum depth reached',
                  score: 50,
                  id: '61e08b592536c394af97d392',
                  default: true,
                  type: 'maximum depth reached',
                },
                owner: 'maximum depth reached',
                depth: 20,
                amount: 246433.15057320998,
                amountCur: 290.226655111703,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1706898546,
                timestamp: 1706898546,
                listType: 'Unknown sources',
                share: 0.0099,
                amountDec: 0.1,
                deepDepthShare: 0.1,
                generalShare: 0,
                price: null,
                originalShare: 0.1,
              },
            ],
            entityBarsUof: [
              {
                directTx:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                  type: 'Suspended exchange',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 19277593.01064663,
                amountCur: 22703.403844291628,
                currency: '',
                tx_hash:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                address:
                  'bc1pc6plmlxyg2qjfe6wfv3jqgvdcsx47jh7j0p3tjkeg9ec6232lfeqe6cn6t',
                cluster: 3310,
                directStamp: 1700648582,
                timestamp: 1700648582,
                listType: 'Risky sources',
                share: 0.7,
                amountDec: 0.11442705346663631,
                deepDepthShare: 0.7,
                generalShare: 0.0,
                price: null,
                originalShare: 0.7,
              },
              {
                directTx:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 4660671.890667313,
                amountCur: 5488.917421439482,
                currency: '',
                tx_hash:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1688055567,
                timestamp: 1688055567,
                listType: 'Known sources',
                share: 0.3,
                amountDec: 0.03779283,
                deepDepthShare: 0.2,
                generalShare: 0.1,
                price: null,
                originalShare: 0.3,
              },
            ],
          },
        },
      ],
      createdAt: '2025-07-30T16:55:08.308Z',
    },
  },
  risksPreview_default: {
    success: true,
    data: {
      parts: [
        {
          type: 'risks',
          status: 'Calculated',
          data: {
            totalScore: null,
            score: {
              sof: [
                {
                  _id: '1',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
                {
                  _id: '2',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
                {
                  _id: '3',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
              ],
              uof: [
                {
                  _id: '1',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
                {
                  _id: '2',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
                {
                  _id: '3',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
              ],
            },
            owner: {
              status: 'Identified',
              owner: 'Secondeye Solution',
              description: '',
              type: {},
              tags: [
                {
                  _id: '1',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
                {
                  _id: '2',
                  name: 'sanction',
                  score: 100,
                  meta: '',
                },
              ],
              entityData: {
                id: '682af0473be18468d7f0579d',
                name: 'Binance x',
                owner: 'Binance x',
                type: {},
                logo: 'logo-data',
              },
              clusterData: {
                _id: '61e2d2c92b94237d8aecb9d8',
                cluster: 34203831,
                addressCount: 9197146,
                address: '11122HJJZWxk2mtTjitrEWRFAfPjEpYeDc',
                owner: 'Binance x',
                description: '',
                updatedAt: '2024-10-02T08:04:28.613Z',
                prevAddress: '12AnyuG898JojxA17T63e6wQcXm7SwBzCN',
                entity: '65a8e2c98bc257cd15e58c41',
                entityData: {
                  logo: 'logo-data',
                  id: '65a8e2c98bc257cd15e58c41',
                  name: 'Binance x',
                  owner: 'Binance x',
                },
                tags: [
                  {
                    _id: '1',
                    name: 'sanction',
                    score: 100,
                    meta: '',
                  },
                  {
                    _id: '2',
                    name: 'sanction',
                    score: 100,
                    meta: '',
                  },
                ],
                type: {},
                meta: [],
                clusterSize: 9197146,
                conflict: false,
              },
            },
          },
        },
      ],
      createdAt: '2025-07-30T16:55:08.308Z',
    },
  },
  risks_default: {
    success: true,
    data: {
      coin: 'btc',
      address: '1NE2NiGhhbkFPSEyNWwj7hKGhGDedBtSrQ',
      decimals: 8,
      parts: [
        {
          type: 'address',
          status: 'Identified',
          data: {
            balance: 0,
            price: null,
            priceTimestamp: 1753894097552,
            numberOfTxs: 17578,
            numberOfTxsBySources: 2000,
            firstSeen: 1560526432,
            lastSeen: 1644501778,
            totalReceived: 12462923073,
            totalReceivedPrice: 14677702.524915382,
            totalReceivedPriceTimestamp: 1753894097552,
            totalSent: 12462923073,
            totalSentPrice: 14677702.524915382,
            totalSentPriceTimestamp: 1753894097552,
            totalTxReceived: 14713,
            totalTxSent: 2865,
            tokens: {
              BTC: {
                symbol: 'BTC',
                decimals: 8,
                address: '',
              },
            },
          },
        },
        {
          type: 'risks',
          status: 'Calculated',
          data: {
            totalScore: 35,
            score: {
              sof: [
                {
                  name: 'Darknet',
                  amount: 1456210.507941348,
                  price: 1714.9929052778834,
                  score: 100,
                  share: 0.009387493834893006,
                  generalShare: 0,
                  deepDepthShare: 0.009387493834893006,
                  depth: 11,
                },
                {
                  name: 'Ponzi scheme',
                  amount: 77382,
                  price: 91.13351419488475,
                  score: 90,
                  share: 0.00049884480572705,
                  generalShare: 0,
                  deepDepthShare: 0.00049884480572705,
                  depth: 4,
                },
                {
                  name: 'Ransomware',
                  amount: 240839.41391388146,
                  price: 283.63885847624044,
                  score: 80,
                  share: 0.001552576705762151,
                  generalShare: 0.000041412756901946585,
                  deepDepthShare: 0.0015111639488602044,
                  depth: 2,
                },
                {
                  name: 'Scam',
                  amount: 1638655.3382884583,
                  price: 1929.859909700381,
                  score: 80,
                  share: 0.010563628542582245,
                  generalShare: 0.0019818092930013035,
                  deepDepthShare: 0.00858181924958094,
                  depth: 1,
                },
                {
                  name: 'Sextortion',
                  amount: 99194.61998316881,
                  price: 116.82244331100662,
                  score: 80,
                  share: 0.0006394603516925435,
                  generalShare: 0.0002770024359269306,
                  deepDepthShare: 0.00036245791576561287,
                  depth: 10,
                },
              ],
              uof: [
                {
                  name: 'Low-risk exchange',
                  amount: 1915030663.194625,
                  price: 2255349.7470715004,
                  score: 33,
                  share: 1.0000000000000009,
                  generalShare: 1.0000000000000009,
                  deepDepthShare: 0,
                  depth: 1,
                },
              ],
            },
            owner: {
              status: 'Identified',
              owner: 'Secondeye Solution',
              description: '',
              type: {},
              tags: [
                {
                  _id: '65d4bf5ba07400f0cd0469c7',
                  name: 'ofac sanctions',
                  score: 100,
                  meta: '',
                },
              ],
              meta: [
                {
                  address: '1NE2NiGhhbkFPSEyNWwj7hKGhGDedBtSrQ',
                  tagId: '65d4bf5ba07400f0cd0469c7',
                  metadata: '',
                  name: 'ofac sanctions',
                  score: 100,
                },
              ],
              entityData: {
                id: '682af0473be18468d7f0579d',
                name: 'Secondeye Solution',
                owner: 'Secondeye Solution',
                type: {},
              },
              clusterData: {
                _id: '61e2d2c92b94237d8aecb9d8',
                cluster: 34203831,
                addressCount: 9197146,
                address: '11122HJJZWxk2mtTjitrEWRFAfPjEpYeDc',
                owner: 'Binance',
                description: '',
                updatedAt: '2024-10-02T08:04:28.613Z',
                prevAddress: '12AnyuG898JojxA17T63e6wQcXm7SwBzCN',
                entity: '65a8e2c98bc257cd15e58c41',
                entityData: {
                  logo: 'data:application/octet-stream;base64,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',
                  id: '65a8e2c98bc257cd15e58c41',
                  name: 'Binance',
                  owner: 'Binance',
                },
                tags: [],
                type: {
                  _id: '61766e49820e13d2b95ded4e',
                  name: 'Low-risk exchange',
                  defScore: 30,
                  score: 33,
                  profileId: '673630bb78f9486e82b9a16c',
                  id: '61766e49820e13d2b95ded4e',
                },
                meta: [],
                clusterSize: 9197146,
                conflict: false,
              },
            },
          },
        },
      ],
      createdAt: '2025-07-30T16:55:08.308Z',
    },
  },
  tier2_default: {
    success: true,
    data: {
      coin: 'eth',
      address: '0x44473b3356906d6ae34299ddf53020f131fa0835',
      decimals: 18,
      parts: [
        {
          type: 'address',
          status: 'Identified',
          data: {
            addressType: 'address',
            balance: 0.000054496458353205,
            price: 0.2105769923863171,
            priceTimestamp: 1753948157145,
            numberOfTxs: 494,
            numberOfTxsBySources: 483,
            firstSeen: 1653789029,
            lastSeen: 1753323083,
            totalTxReceived: 243,
            totalTxSent: 251,
            tokens: {
              '': {
                address: '',
                symbol: 'ETH',
                decimals: 18,
                supported: true,
                unknownContract: true,
              },
              '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73': {
                address: '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73',
                name: 'Virtual Protocol',
                symbol: 'VIRTUAL',
                decimals: 18,
                supported: true,
              },
              '0x6982508145454ce325ddbe47a25d4ec3d2311933': {
                address: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                name: 'Pepe',
                symbol: 'PEPE',
                decimals: 18,
                icon: 'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAACKFBMVEVek0tdkkpflEthmE1moFFglUxjm05imU5lnU9lnlBHcThGbjdnoVJknE9KdjtFbDdoo1NZjEZBZjRNeT1rp1VVhUNTgUJOfD1CaDRRgEBQfT9KdDpJczpckEk2Vio0UyhYikZXiEVWh0RMeDw9YTAxTiYrRSGIJhhtqldgl0xUhEJEgkFEazY/ZDI5XC04WSwnQR1urVhaq1ZdqVVqpVRWolFbj0dJjEU8dztXbDZDazQ7Xi8zUSlYPiEjOxtaLBmKIxdsEw1eEwxpEgx1tl1YU1pvrllkqVZgp1RZp1NfpFJinE9OTk9Tm05OnE1NgD47ND5PaTVEdjM+aDNVZDM6UjFeWS8tXi47aCpUUipaTikxUCYzVyUuSCR4QyQxXyAcFx4oSB0sVxx0MRwfKRwmShkkRhgcPBCMFRBLGQ9kEAx/Dgx2DQsNMQL////+9f/18PfW2NXI0MW/wL+mpaeZqZOUlZOJhYqDlXxwaXN0gW9ud2xzjmppbWdkXWZ4u19nsVlxsFllh1hgrVdcclRFnU5Xlk1ZlUxRlUtZfUtOk0pRaElKh0RKZUA/fT9PiDlEczlTcDlCXTgybjVHfDNCcDFcXjFjXTFJWCwwOSw8cig1XScyVCZGTCZ/QSVDPiBxNR5pMx5sNB14MBwcHBw4NBqCKhqUKRqeKBogMRl0KRiaIhdfJRVlIxV/IRVkHhJ3GBFXGxCGFRBQFw8RHA0GAAwLGQYBAQHwHWUjAAACo0lEQVQ4y3XSVXPbQBQFYK1WjJZkZm7imMLMzMzMXGZmZmZm5v69OkrHqev0vuhhvzl7NWeR+KA4ivx/AMHnSDaeACQPeT5ZAsolWgUrq9c6WQ+jQBL8c07rZR2CohLDCnpJZ2Xw1ERA2GSc5qArJ9UnafmsIyYLnRCBUrJJA5mQKFrCYULPWExGif9bYIwVI4NeCZIIFPyyIljsdo6IC4CZgxQOdJosGsO0VYolneYIs7C2KCnJqRCgGslsUgys6HboCYijwZCWAH8CRBMGAKZ3+BwOe9TPFBVWIXa/z19ogyqg9CIGEMwQZe9el3J0E8t9FiczKN4YLWE1KuBFHYEgnFDSvWPv1Pc3+3ZeHe8YmvrZfWZWR6nAzHIgdhGZKu9u+1F9cNfGLctHm8ba9mw6MMqpwOgi1S9NTkz77jzfvnnbzP7qX2NNW4938OqBRaMuy5F8wGq6Fz13YUZuHfcOGWf7UoAKcFyt2uCEFDTr0EvT9zG6wE4bolZstVR0xZFob54WIhTmYlmMQFMYxqb1dKrZq4jofPGgtSWjQShQKBLEUt3wcPv8KRgHjXnlc/PFt7ouN9dn12fW1dXWHjvx/klzHCB4Q/uXpa/llR9Kiwd6bnblX8nPL/12EltrFOCZuf2flja8/Pi5vLJyoaKiYmGx9CyZ8Kg0GWn9b+fevX61ITZlZWWLPdk4kiCQGLk9UPz08eSzyZGRh48uatUbEgiWmd2Sm5t2/nRe77W0lYqSB8Ubtek1ggytkdU3lSygoERCNW7CKUv0eoJjjBE/6/GVME6jaz1BKSwWdniLht0pNtlGJgOgMSrooJdNCZjS3eJ6e+KokYoMHwrECqUVM5WckAUcFFdQWKQxBA0eAUeTfsIsih6eM4SMYb2XEgLwN2WMcSPeECwqAAAAAElFTkSuQmCC',
                supported: true,
              },
              '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2': {
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                name: 'Wrapped Ether',
                symbol: 'WETH',
                decimals: 18,
                icon: 'iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAFjklEQVR42q2We0xURxTGz727d/eyLC7IIiwU2QdQtrVG8FF5VKVVMDS1CJaikLap0RhpsIAiVYRqKC8DBlRqUogvHv4hr4ogGgkhpo2hVMAKxJJKLWltoxI0sSDUr5mRNUqqVOUkk8zenXt+93xnzpkhmsIUgqAVSTAT0RIi+oSI1hJRDBEFSIJitpJEBU2HKQTBjYjiiOi0QeGA1yUXhMomRNj54l3ZFyGq2fBT6ocVJJQQ0XJJUEgvw1tFRB1zVLOwTReCJtePAGMOYCnEX4ZtaNStRYH8Dj4UfGEgNVREUJJwgoj8XgSWphFU2KoLwTXPZMD7IGDJQdnM97GEnOBOEvysfghcHIiwoGWIXhIOq8EIImJjwF5tl/g8sAw7QcJRlyjAnAdY9qJxVjwCyAkqZwfEb9uMw7UncOnKZfz86y989F+/hu/bL6KsrAxr1qyxgWtEUZwy2o91oowj+oewUWMmktSLoFWo8WnaFlz6qRtT2cjICM40n8H8+fMZ9LpGo1n1NJg3Ed3OdloOmPNx3/glNqv8YTdDi0MVh/G8dvPmTSQkJDDoLYVCsWwyTCCiHYFqT9yevQMw56JYuxIOGnscOVGOF7WxsTFs2LCBQX8gIpfHga4aQfqtaGYE34VXXknEDBKRWZiDl7WhoSEsXbqUQfcTkdIGfPtVSY8/eXT5WCdbMSd0MUbuj2I67Pz589BoNAzqbwNmrrV/A/ApwVXPRNgTobr1DKbTIiMjGTBLkiQeZZFJckSbYQOOaN+DaZ4V3zY2oLi4GK2trSgvL0dFRQU6Ozuxe/dunDx5EkVFRUhLS+Nr2H87d+7ko6qqCoWFhaipqUFLSwv27NmDO3fuoLKyElqtdlCr1bqRLCj36hQyjLITPEiLz75IwdmzZ+Hs7MyTbjQa4e/vj/T0dF5jycnJMBgMfM7yExcXZ6s9bNy4Efb29lixYgVSUlL4s97eXoyOjsLHxweiKHqTSEJBgsMi5OtX8gVFJQf4DrNYLAgMDIRer8fcuXMRHBzMXkBJSQlMJhOCgoJw6tQp7pDlKDw8HDdu3IDZbIaXlxcCAgI4nCnDbKI2w5mk30RqrBg3ZcGf1Mg7WsIXREVFwdXVlUnBnatUKg6tq6uDp6cn3NzckJqainv37sHR0RExMTH8PavVClmW+Ue4uLigvb2dPw8NDWXAeAbcQgIhfWYo3iQtckr38wW7du3iETPnTCI237RpE9ra2rikTE6Wp4GBATg5OSE6OppL5+vry/9bv349B3d0dHB/ISEhzMcHDGjRCeoHrioH7jQn92H91dbW8t8LFy7E9u3b+by0tBR9fX2Pcubt7Y36+no+Zyqw1saUYFFOFP0jSdkzIlrAgGq9qKlcpjbCKjrjtbcWYOjWbd6emGTnzp3jX8l25eDgIIaHh5GRkYGkpCTk5uaiv78f2dnZOH78OMbHx5GXl4djx46hqamJ71zmp6urC+7u7uOyLHvZajF4juSKz+VFcCY1Lnb9OK11yBRSKpWn1Wq1xgYUiejActkCb9IgM/+raYMxRVhaJq4lT5ikFMQ6vcLuH5PbK+jp650WYFZWFgRBuCyKout/HVNmgYROlmy269jXvYw1NzdDp9Ox6NZNBmknauQoEfUS0QMGXb16Ne7evftCsAsXLsDDw4PBsifDZhBRo22rTx4RERHo7u5+Llh1dbUNdmjivH3C5j0NZhusq2RmZqKnp+eZoIaGBsTGxrJ3/iai1KddL54ZIeuftjnrIvHx8bzu9u3bx0+GgoICJCYmIiwsjOWLpeKgJElBU12gbDmsmsjhs8Bj7P5DRH8Q0WUiaiGir4koVqVS+f/f6yGrw8XskJyI9joR/f74EATBNr/KLslE9B0R1bPmT0RbWdvSaDTOU4H+Bc/z92HCspq3AAAAAElFTkSuQmCC',
                supported: true,
              },
              ETH: {
                symbol: 'ETH',
                decimals: 18,
                address: '',
              },
            },
          },
        },
        {
          type: 'risks',
          status: 'Calculated',
          data: {
            totalScore: 53,
            score: {
              sof: [
                {
                  name: 'High-risk exchange',
                  amount: 8000000000000000,
                  price: 30.91239302510495,
                  score: 70,
                  share: 0.0004625322752335843,
                  generalShare: 0,
                  deepDepthShare: 0.0004625322752335843,
                  depth: 2,
                },
              ],
              uof: [
                {
                  name: 'High-risk exchange',
                  amount: 76369620159299360,
                  price: 295.09596419278,
                  score: 70,
                  share: 0.004726321696351675,
                  generalShare: 0,
                  deepDepthShare: 0.004726321696351675,
                  depth: 2,
                },
              ],
            },
            owner: {
              status: 'Not Identified',
              type: {},
              tags: [],
              meta: [],
              clusterData: {},
            },
          },
        },
        {
          type: 'tier2',
          status: 'TIER2 Found',
          data: {
            labelBarsSof: [
              {
                directTx:
                  '0x899f1bb885d288721a25fd032d9879d97f845d15e6d779ff61e14422a44ef13b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'NFT marketplace',
                  score: 40,
                  id: '6604a0ed8d004d1f88b8a4b2',
                  type: 'NFT marketplace',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 4006994793500000000,
                amountCur: 15483.224738277662,
                currency: '',
                tx_hash:
                  '0x899f1bb885d288721a25fd032d9879d97f845d15e6d779ff61e14422a44ef13b',
                address: '0x00000000006c3852cbef3e08e8df289169ede581',
                directStamp: 1664531087,
                timestamp: 1664531087,
                listType: 'Known sources',
                share: 0.2316,
                amountDec: 0.78625,
                deepDepthShare: 0.035880074003229255,
                generalShare: 0.19579047833260593,
                price: null,
                originalShare: 0.23167055233583522,
              },
              {
                directTx:
                  '0x41ec849a95f3a8526876d300d26ad1b017c7fed6c2a33e9c2be2335c9ae21d37',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unknown smart contract',
                  score: 50,
                  default: true,
                  type: 'unknown smart contract',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 9656480046197920000,
                amountCur: 37313.113303394246,
                currency: '',
                tx_hash:
                  '0x41ec849a95f3a8526876d300d26ad1b017c7fed6c2a33e9c2be2335c9ae21d37',
                address: '0x0000000000000068f116a894984e2db1123eb395',
                directStamp: 1742201411,
                timestamp: 1742201411,
                listType: 'Unknown sources',
                share: 0.5583,
                amountDec: 0.46305,
                deepDepthShare: 0.0034272485264120506,
                generalShare: 0.554876962288042,
                price: null,
                originalShare: 0.5583042108144541,
              },
              {
                directTx:
                  '0x459e9b02296996aa0f6cb980d2f9796192eafda7da6be750bf8ec1f1b5b51454',
                directionUp: false,
                token: '',
                funds: {
                  name: 'wrapped token',
                  score: 10,
                  id: '65ea5850e72f728fbc45010e',
                  type: 'wrapped token',
                },
                owner: 'Wrapped Ether',
                entity: '682afaa11a39a7022034af45',
                depth: 1,
                amount: 1953066538981177000,
                amountCur: 7546.745057145952,
                currency: '',
                tx_hash:
                  '0x459e9b02296996aa0f6cb980d2f9796192eafda7da6be750bf8ec1f1b5b51454',
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                inputAmounts: [
                  {
                    amount: 230000000000000000,
                    currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                    amountCur: 871.3121730986122,
                    amountDec: 0.23,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 230000000000000000,
                    amountCur: 888.7312994717673,
                    amountDec: 0.23,
                  },
                ],
                directStamp: 1744733507,
                timestamp: 1744733507,
                listType: 'Swap',
                share: 0.1129,
                amountDec: 0.23,
                deepDepthShare: 0.008658864366777519,
                generalShare: 0.10426067437791571,
                price: null,
                originalShare: 0.11291953874469322,
              },
              {
                directTx:
                  '0x201fe0a9a1cc5ca88f2e8ab549fbf15f37bc26d36a776a7942387c4ec41589e9',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'Crypto.com',
                entity: '65abc6368bc257cd152c00e9',
                depth: 1,
                amount: 1143612428571428600,
                amountCur: 4418.974607549346,
                currency: '',
                tx_hash:
                  '0x201fe0a9a1cc5ca88f2e8ab549fbf15f37bc26d36a776a7942387c4ec41589e9',
                address: '0x46340b20830761efd32832a74d7169b29feb9758',
                directStamp: 1693846727,
                timestamp: 1693846727,
                listType: 'Known sources',
                share: 0.0661,
                amountDec: 0.19,
                deepDepthShare: 0.008956499756137873,
                generalShare: 0.05716320756543062,
                price: null,
                originalShare: 0.06611970732156848,
              },
              {
                directTx:
                  '0x9a188bbfac46dcf5ed4cefa6d49aa2d182bd1300639e58418ccf01fb8518c2e8',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Cross-chain protocol',
                  score: 60,
                  id: '61c5f810c004380117d443d5',
                  type: 'Cross-chain protocol',
                },
                owner: 'Across Protocol',
                entity: '65dd3ad48bc257cd15c51b27',
                depth: 1,
                amount: 216497881166959740,
                amountCur: 836.5584489669407,
                currency: '',
                tx_hash:
                  '0x9a188bbfac46dcf5ed4cefa6d49aa2d182bd1300639e58418ccf01fb8518c2e8',
                address: '0x5c7bcd6e7de5423a257d81b442095a1a6ced35c5',
                directStamp: 1738982795,
                timestamp: 1738982795,
                listType: 'Risky sources',
                share: 0.0125,
                amountDec: 0.09889913099979605,
                deepDepthShare: 0.005665479242134941,
                generalShare: 0.006851677952790565,
                price: null,
                originalShare: 0.012517157194925506,
              },
              {
                directTx:
                  '0x55ca1d0ea7fb07d014649c51662334f334f2d29f4e07a8387a69fd9085320847',
                directionUp: false,
                token: '',
                funds: {
                  name: 'MEV bot',
                  score: 50,
                  id: '637e329fca61b25b03cf5037',
                  type: 'MEV bot',
                },
                owner: 'MEV Bot 0x74d631',
                entity: '682af8b01a39a702203497b6',
                depth: 1,
                amount: 137422510941575060,
                amountCur: 531.0073335903442,
                currency: '',
                tx_hash:
                  '0x55ca1d0ea7fb07d014649c51662334f334f2d29f4e07a8387a69fd9085320847',
                address: '0x74de5d4fcbf63e00296fd95d33236b9794016631',
                inputAmounts: [
                  {
                    amount: 5.943396e25,
                    currency: '0x18c1074845c389907762a71242bfe271c9da2d9c',
                  },
                ],
                outputAmounts: [
                  {
                    amount: 74582008814593900,
                    amountCur: 288.1885461348211,
                    amountDec: 0.0745820088145939,
                  },
                ],
                directStamp: 1686986171,
                timestamp: 1686986171,
                listType: 'Swap',
                share: 0.0079,
                amountDec: 0.0745820088145939,
                deepDepthShare: 0,
                generalShare: 0.007945293331764854,
                price: null,
                originalShare: 0.007945293331764854,
              },
              {
                directTx:
                  '0xb28e63fa9649ab1c363a385b5a5275b9fe98777331515b4a376ca01d862519f8',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unknown wallet / otc / service',
                  score: 50,
                  default: true,
                  type: 'unknown wallet / otc / service',
                },
                owner: 'unknown wallet / otc / service',
                depth: 1,
                amount: 71376716914832300,
                amountCur: 275.8031407641191,
                currency: '',
                tx_hash:
                  '0xb28e63fa9649ab1c363a385b5a5275b9fe98777331515b4a376ca01d862519f8',
                address: '0xf70da97812cb96acdf810712aa562db8dfa3dbef',
                directStamp: 1745291567,
                timestamp: 1745291567,
                listType: 'Unknown sources',
                share: 0.0041,
                amountDec: 0.027704580975743413,
                deepDepthShare: 0,
                generalShare: 0.004126754409165107,
                price: null,
                originalShare: 0.004126754409165107,
              },
              {
                directTx:
                  '0xe0b58b2abbeda86b7a60917233482fcd955473f8f01d9b3e75d052f93bcda144',
                directionUp: false,
                token: '',
                funds: {
                  name: 'DEX',
                  score: 50,
                  id: '66049d278d004d1f88b515cd',
                  type: 'DEX',
                },
                owner: 'Hop Exchange',
                entity: '667abeefb8f819d6d0a619e5',
                depth: 3,
                amount: 11967940829092432,
                amountCur: 46.24471132626321,
                currency: '',
                tx_hash:
                  '0xcaa8fd5a2f93718726d3fab0398cbb7b78fffe903f6e67eb3314369401a55c5b',
                address: '0xb8901acb165ed027e32754e0ffe830802919727f',
                directStamp: 1708374347,
                timestamp: 1708326635,
                listType: 'Known sources',
                share: 0.0006,
                amountDec: 0.011967940829092432,
                deepDepthShare: 0.000691944862692629,
                generalShare: 0,
                price: null,
                originalShare: 0.000691944862692629,
              },
              {
                directTx:
                  '0xcb5fdaf14a71c25abaf9cd10a6d5708f922b14425bb0d81d8dea2133eca5c0a4',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                  type: 'small transactions',
                },
                owner: 'small transactions',
                depth: 2,
                amount: 90365928308363490,
                amountCur: 349.1783864933236,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1701838631,
                timestamp: {
                  minimum: 1701185627,
                  maximum: 1701747215,
                },
                listType: 'Unknown sources',
                share: 0.0052,
                amountDec: 0.010526510505908531,
                deepDepthShare: 0.0011568099811182279,
                generalShare: 0.004067834821889563,
                price: null,
                originalShare: 0.005224644803007791,
              },
              {
                directTx:
                  '0x8e3e3acf75ff973ea259bb023d690e461f399ce82d62520d458c27060e56303e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'High-risk exchange',
                  score: 70,
                  id: '61766f47820e1372d85ded59',
                  type: 'High-risk exchange',
                },
                owner: 'ChangeNOW',
                entity: '6603e884a6a313bd816dba8e',
                depth: 2,
                amount: 8000000000000000,
                amountCur: 30.91239302510495,
                currency: '',
                tx_hash:
                  '0x1cfff699ad72f1b7e7a552f196edc44c4b1d989ea28d633881756ba856078c81',
                address: '0x077d360f11d220e4d5d831430c81c26c9be7c4a4',
                directStamp: 1707845075,
                timestamp: 1707844187,
                listType: 'Risky sources',
                share: 0.0004,
                amountDec: 0.008,
                deepDepthShare: 0.0004625322752335843,
                generalShare: 0,
                price: null,
                originalShare: 0.0004625322752335843,
              },
              {
                directTx:
                  '0x17fae9c733155c441c529a24929189678f2fbbc12a4218a6012600b943c02eed',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Service',
                  score: 30,
                  id: '617bc29abc4783e21affa642',
                  type: 'Service',
                },
                owner: 'ENS Domains',
                entity: '682af8381a39a70220348a18',
                depth: 1,
                amount: 305516524664082,
                amountCur: 1.1805308607600342,
                currency: '',
                tx_hash:
                  '0x17fae9c733155c441c529a24929189678f2fbbc12a4218a6012600b943c02eed',
                address: '0x283af0b28c62c092c9727f1ee09c02ca627eb7f5',
                directStamp: 1677460607,
                timestamp: 1677460607,
                listType: 'Known sources',
                share: 0,
                amountDec: 0.000305516524664082,
                deepDepthShare: 0,
                generalShare: 0.000017663906659291915,
                price: null,
                originalShare: 0.000017663906659291915,
              },
            ],
            labelBarsUof: [
              {
                directTx:
                  '0x7d6942018c15960f1ad963ede6ec9ef22200cc71b450d75d1cf591672e2f340f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'NFT marketplace',
                  score: 40,
                  id: '6604a0ed8d004d1f88b8a4b2',
                  type: 'NFT marketplace',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 2597300660456794600,
                amountCur: 10036.09735255064,
                currency: '',
                tx_hash:
                  '0x7d6942018c15960f1ad963ede6ec9ef22200cc71b450d75d1cf591672e2f340f',
                address: '0x00000000006c3852cbef3e08e8df289169ede581',
                directStamp: 1664545751,
                timestamp: 1664545751,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Known sources',
                share: 0.1607,
                amountDec: 0.8,
                deepDepthShare: 0.017475957550540197,
                generalShare: 0.14326437922028107,
                price: null,
                originalShare: 0.16074033677082125,
              },
              {
                directTx:
                  '0xe44038dbf7d98b59988b048233486cdb5860f1876023cac375159b8866b8373b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown smart contract',
                  score: 50,
                  default: true,
                  type: 'unknown smart contract',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 11103133817435927000,
                amountCur: 42903.054546864136,
                currency: '',
                tx_hash:
                  '0xe44038dbf7d98b59988b048233486cdb5860f1876023cac375159b8866b8373b',
                address: '0x0000000000000068f116a894984e2db1123eb395',
                directStamp: 1742395859,
                timestamp: 1742395859,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Unknown sources',
                share: 0.6871,
                amountDec: 0.43,
                deepDepthShare: 0.014345299921366718,
                generalShare: 0.6727994331463333,
                price: null,
                originalShare: 0.6871447330677001,
              },
              {
                directTx:
                  '0x62b11c2c7c573915648cd7943aa1c310e32303b74de90e6adf023110e22f0d28',
                directionUp: true,
                token: '',
                funds: {
                  name: 'wrapped token',
                  score: 10,
                  id: '65ea5850e72f728fbc45010e',
                  type: 'wrapped token',
                },
                owner: 'Wrapped Ether',
                entity: '682afaa11a39a7022034af45',
                depth: 1,
                amount: 505219650348281000,
                amountCur: 1952.1935494465201,
                currency: '',
                tx_hash:
                  '0x62b11c2c7c573915648cd7943aa1c310e32303b74de90e6adf023110e22f0d28',
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                inputAmounts: [
                  {
                    amount: 230000000000000000,
                    amountCur: 888.7312994717673,
                    amountDec: 0.23,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 230000000000000000,
                    currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                    amountCur: 871.3121730986122,
                    amountDec: 0.23,
                  },
                ],
                directStamp: 1744070159,
                timestamp: 1744070159,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Swap',
                share: 0.0312,
                amountDec: 0.23,
                deepDepthShare: 0,
                generalShare: 0.0312667601316271,
                price: null,
                originalShare: 0.0312667601316271,
              },
              {
                directTx:
                  '0x0ebd8a2f69a478de89d44f829ead2a498e725a24ac67123e90260e4efd73b2db',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown wallet / otc / service',
                  score: 50,
                  default: true,
                  type: 'unknown wallet / otc / service',
                },
                owner: 'unknown wallet / otc / service',
                depth: 2,
                amount: 314908000000000000,
                amountCur: 1216.819982843719,
                currency: '',
                tx_hash:
                  '0xd262b9f0f81b2f224bb38e31262451f140c03954d975adbaf12c041b1b529a66',
                address: '0xeba88149813bec1cccccfdb0dacefaaa5de94cb1',
                directStamp: 1744733651,
                timestamp: 1744733747,
                'address-1': '0x35a507c63c9e3177025b7a1e727f2e7fbb6af4b8',
                listType: 'Unknown sources',
                share: 0.0194,
                amountDec: 0.19995,
                deepDepthShare: 0.016703920142040304,
                generalShare: 0.002784935631369999,
                price: null,
                originalShare: 0.019488855773410304,
              },
              {
                directTx:
                  '0x01511a85ac8674e3265ff8ed07e7c5ddcd691dd2ed32040517d625b7bd57bdeb',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'Crypto.com',
                entity: '65abc6368bc257cd152c00e9',
                depth: 2,
                amount: 668000000000000000,
                amountCur: 2581.184817596263,
                currency: '',
                tx_hash:
                  '0xd72b470d45ca7a73150258506be5ea3da7848b46783046711e3afc5491d8370a',
                address: '0xcffad3200574698b78f32232aa9d63eabd290703',
                directStamp: 1688194691,
                timestamp: 1688530103,
                'address-1': '0x77ef13a157a3177d44f06d34c5aca28f61874967',
                listType: 'Known sources',
                share: 0.0413,
                amountDec: 0.157,
                deepDepthShare: 0.04134082226122576,
                generalShare: 0,
                price: null,
                originalShare: 0.04134082226122576,
              },
              {
                directTx:
                  '0xb21b52e645c9866f1a4fa4b8065df3ab687e180fc690e26ba4cb3fa931e3cacf',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Cross-chain protocol',
                  score: 60,
                  id: '61c5f810c004380117d443d5',
                  type: 'Cross-chain protocol',
                },
                owner: 'Socket.tech',
                entity: '65dd42288bc257cd15c624ab',
                depth: 2,
                amount: 208895124728877760,
                amountCur: 807.1810245809239,
                currency: '',
                tx_hash:
                  '0xa46e73e8a50fae734d4c1be8b17a771eabe6ee87a8e5f49654e599cf4a15608d',
                address: '0x3a23f943181408eac424116af7b7790c94cb97a5',
                directStamp: 1712716415,
                timestamp: 1712716487,
                'address-1': '0x856ab40c16b68ffa2ba912974a00a45bac43e69d',
                listType: 'Risky sources',
                share: 0.0129,
                amountDec: 0.09576217320898289,
                deepDepthShare: 0.008410203888598264,
                generalShare: 0.004517784468666887,
                price: null,
                originalShare: 0.012927988357265153,
              },
              {
                directTx:
                  '0x14adef8c8e3fcc7916749eb5967fa6bdf4c3472c4823bfa45e552b8f54cbd131',
                directionUp: true,
                token: '',
                funds: {
                  name: 'dApps',
                  score: 50,
                  id: '66049d908d004d1f88b561f9',
                  type: 'dApps',
                },
                owner: 'Base (by Coinbase)',
                entity: '682af82a1a39a70220347f58',
                depth: 2,
                amount: 424555676617511600,
                amountCur: 1640.503992079985,
                currency: '',
                tx_hash:
                  '0x481164c459d0a0463b813bb67580d44c8d0ad78bf44b3778849aa66b35112187',
                address: '0x49048044d57e1c92a77f79988d21fa8faf74e97e',
                directStamp: 1693976783,
                timestamp: 1693976843,
                'address-1': '0xb85dcbdadae8d2ccd532f80a86880f7f7877a919',
                listType: 'Known sources',
                share: 0.0262,
                amountDec: 0.049,
                deepDepthShare: 0.005480485759381936,
                generalShare: 0.020794186047562654,
                price: null,
                originalShare: 0.02627467180694459,
              },
              {
                directTx:
                  '0xb36aea9fd79894536ccaf73cbd127016c76956e0d85c82a211575d0fff24c77c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'High-risk exchange',
                  score: 70,
                  id: '61766f47820e1372d85ded59',
                  type: 'High-risk exchange',
                },
                owner: 'ChangeNOW',
                entity: '6603e884a6a313bd816dba8e',
                depth: 2,
                amount: 76369620159299380,
                amountCur: 295.09596419278006,
                currency: '',
                tx_hash:
                  '0x78d17356afcf6322c78206e5d0001cbf2ff49baccedde75bbac1a698bd204133',
                address: '0x077d360f11d220e4d5d831430c81c26c9be7c4a4',
                directStamp: 1711566359,
                timestamp: 1711566491,
                'address-1': '0xc65c55b2ea33fcb3d393f9ef0e1bfe67798b68f0',
                listType: 'Risky sources',
                share: 0.0047,
                amountDec: 0.048878,
                deepDepthShare: 0.004726321696351675,
                generalShare: 0,
                price: null,
                originalShare: 0.004726321696351675,
              },
              {
                directTx:
                  '0xd7d097d7ce922bbcc9e8dadf7a83c3842a3508c3e29cf0851d1692e6a377600a',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Online wallet',
                  score: 60,
                  id: '61767102820e13ff395ded5f',
                  type: 'Online wallet',
                },
                owner: 'MetaMask',
                entity: '667abef6b8f819d6d0a61a11',
                depth: 1,
                amount: 50000000000000000,
                amountCur: 193.20245640690592,
                currency: '',
                tx_hash:
                  '0xd7d097d7ce922bbcc9e8dadf7a83c3842a3508c3e29cf0851d1692e6a377600a',
                address: '0x881d40237659c251811cec9c364ef91dc08d300c',
                inputAmounts: [
                  {
                    amount: 30000000000000000,
                    amountCur: 115.92147384414356,
                    amountDec: 0.03,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 1.4427173822532351e28,
                    currency: '0x2f573070e6090b3264fe707e2c9f201716f123c7',
                  },
                ],
                directStamp: 1688792531,
                timestamp: 1688792531,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Swap',
                share: 0.003,
                amountDec: 0.03,
                deepDepthShare: 0,
                generalShare: 0.0030943729237444427,
                price: null,
                originalShare: 0.0030943729237444427,
              },
              {
                directTx:
                  '0x042d40bf48977d7917044f9e876a031a641ed9f0acaff357d2f02a2355e3dadf',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                  type: 'small transactions',
                },
                owner: 'small transactions',
                depth: 1,
                amount: 157924666762290140,
                amountCur: 610.2286709143303,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1659231967,
                timestamp: {
                  minimum: 1659237039,
                  maximum: 1659241593,
                },
                listType: 'Unknown sources',
                share: 0.0097,
                amountDec: 0.028399,
                deepDepthShare: 0.0012601587513062745,
                generalShare: 0.008513397505105614,
                price: null,
                originalShare: 0.00977355625641189,
              },
              {
                directTx:
                  '0x9f934ba4efb800e6aecb1e45a8452e3f8fad059999a3bd7fe5bbda7847b9a0bc',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 30,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Coinbase',
                entity: '682aefde3be18468d7f0500a',
                depth: 4,
                amount: 29493507176617844,
                amountCur: 113.96436069154554,
                currency: '',
                tx_hash:
                  '0xfc51fd9157845d4022ea7a2a2c242996d8a0648bcf26c7eeff2603a2f19885bc',
                address: '0xa9d1e08c7793af67e9d92fe308d5697fb81d3e43',
                directStamp: 1685504735,
                timestamp: 1686689171,
                'address-1': '0x068068fee8521a94275ed6e9059a3d5b9492c9e3',
                listType: 'Known sources',
                share: 0.0018,
                amountDec: 0.024993507176617843,
                deepDepthShare: 0.0018252782006717733,
                generalShare: 0,
                price: null,
                originalShare: 0.0018252782006717733,
              },
              {
                directTx:
                  '0x59c25368ec3376382dc24b7a6ea360fe2d859f699151c24833d60b2f61fa678d',
                directionUp: true,
                token: '',
                funds: {
                  name: 'DEX',
                  score: 50,
                  id: '66049d278d004d1f88b515cd',
                  type: 'DEX',
                },
                owner: 'Uniswap',
                entity: '6603e89ea6a313bd816dbb0f',
                depth: 2,
                amount: 18511061132255000,
                amountCur: 71.52764962900136,
                currency: '',
                tx_hash:
                  '0x07caad8f8549be229014dfc2442e7134c2ca92cdeca8cce17f42a9100d8d74cf',
                address: '0x68b3465833fb72a70ecdf485e0e4c7bd8665fc45',
                inputAmounts: [
                  {
                    amount: 18511061132255000,
                    amountCur: 71.52764962900136,
                    amountDec: 0.018511061132255,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 19191008636,
                    currency: '0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b',
                    amountCur: 27.14577274773372,
                    amountDec: 191.91008636,
                  },
                ],
                directStamp: 1653821009,
                timestamp: 1653821355,
                'address-1': '0xc0c603c330cfed4963fee36b3b49fae2e706a3db',
                listType: 'Swap',
                share: 0.0011,
                amountDec: 0.018511061132255,
                deepDepthShare: 0.0011456025271485606,
                generalShare: 0,
                price: null,
                originalShare: 0.0011456025271485606,
              },
              {
                directTx:
                  '0x17fae9c733155c441c529a24929189678f2fbbc12a4218a6012600b943c02eed',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Service',
                  score: 30,
                  id: '617bc29abc4783e21affa642',
                  type: 'Service',
                },
                owner: 'ENS Domains',
                entity: '682af8381a39a70220348a18',
                depth: 1,
                amount: 3360681771304902,
                amountCur: 12.985839468360377,
                currency: '',
                tx_hash:
                  '0x17fae9c733155c441c529a24929189678f2fbbc12a4218a6012600b943c02eed',
                address: '0x283af0b28c62c092c9727f1ee09c02ca627eb7f5',
                directStamp: 1677460607,
                timestamp: 1677460607,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Known sources',
                share: 0.0002,
                amountDec: 0.003360681771304902,
                deepDepthShare: 0,
                generalShare: 0.00020798405356894806,
                price: null,
                originalShare: 0.00020798405356894806,
              },
              {
                directTx:
                  '0x3a1a64089e04781da4a1ad17fa847f19ec8d0568d5d9c17ef9de7c88081a642f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                  type: 'unhosted wallet',
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 690223417815052,
                amountCur: 2.667057195828764,
                currency: '',
                tx_hash:
                  '0x3a1a64089e04781da4a1ad17fa847f19ec8d0568d5d9c17ef9de7c88081a642f',
                address: '0xa7bc237f6621d1e89009a078bf18c95d6d7c2c5d',
                directStamp: 1753323083,
                timestamp: 1753323083,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Unknown sources',
                share: 0,
                amountDec: 0.000690223417815052,
                deepDepthShare: 0,
                generalShare: 0.00004271617310842489,
                price: null,
                originalShare: 0.00004271617310842489,
              },
            ],
            evaluatedSofTxs: 236,
            evaluatedUofTxs: 248,
            currencies: {},
            sources: [],
          },
        },
      ],
      createdAt: '2025-07-31T08:34:12.748Z',
    },
  },
  tier2_all: {
    success: true,
    data: {
      coin: 'eth',
      address: '0x44473b3356906d6ae34299ddf53020f131fa0835',
      decimals: 18,
      parts: [
        {
          type: 'address',
          status: 'Identified',
          data: {
            addressType: 'address',
            balance: 0.000054496458353205,
            price: 0.2105769923863171,
            priceTimestamp: 1753948157145,
            numberOfTxs: 566,
            numberOfTxsBySources: 503,
            firstSeen: 1653789029,
            lastSeen: 1753323083,
            totalTxReceived: 279,
            totalTxSent: 287,
            tokens: {
              '': {
                address: '',
                symbol: 'ETH',
                decimals: 18,
                supported: true,
                unknownContract: true,
              },
              '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73': {
                address: '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73',
                name: 'Virtual Protocol',
                symbol: 'VIRTUAL',
                decimals: 18,
                supported: true,
              },
              '0x6982508145454ce325ddbe47a25d4ec3d2311933': {
                address: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                name: 'Pepe',
                symbol: 'PEPE',
                decimals: 18,
                icon: 'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAACKFBMVEVek0tdkkpflEthmE1moFFglUxjm05imU5lnU9lnlBHcThGbjdnoVJknE9KdjtFbDdoo1NZjEZBZjRNeT1rp1VVhUNTgUJOfD1CaDRRgEBQfT9KdDpJczpckEk2Vio0UyhYikZXiEVWh0RMeDw9YTAxTiYrRSGIJhhtqldgl0xUhEJEgkFEazY/ZDI5XC04WSwnQR1urVhaq1ZdqVVqpVRWolFbj0dJjEU8dztXbDZDazQ7Xi8zUSlYPiEjOxtaLBmKIxdsEw1eEwxpEgx1tl1YU1pvrllkqVZgp1RZp1NfpFJinE9OTk9Tm05OnE1NgD47ND5PaTVEdjM+aDNVZDM6UjFeWS8tXi47aCpUUipaTikxUCYzVyUuSCR4QyQxXyAcFx4oSB0sVxx0MRwfKRwmShkkRhgcPBCMFRBLGQ9kEAx/Dgx2DQsNMQL////+9f/18PfW2NXI0MW/wL+mpaeZqZOUlZOJhYqDlXxwaXN0gW9ud2xzjmppbWdkXWZ4u19nsVlxsFllh1hgrVdcclRFnU5Xlk1ZlUxRlUtZfUtOk0pRaElKh0RKZUA/fT9PiDlEczlTcDlCXTgybjVHfDNCcDFcXjFjXTFJWCwwOSw8cig1XScyVCZGTCZ/QSVDPiBxNR5pMx5sNB14MBwcHBw4NBqCKhqUKRqeKBogMRl0KRiaIhdfJRVlIxV/IRVkHhJ3GBFXGxCGFRBQFw8RHA0GAAwLGQYBAQHwHWUjAAACo0lEQVQ4y3XSVXPbQBQFYK1WjJZkZm7imMLMzMzMXGZmZmZm5v69OkrHqev0vuhhvzl7NWeR+KA4ivx/AMHnSDaeACQPeT5ZAsolWgUrq9c6WQ+jQBL8c07rZR2CohLDCnpJZ2Xw1ERA2GSc5qArJ9UnafmsIyYLnRCBUrJJA5mQKFrCYULPWExGif9bYIwVI4NeCZIIFPyyIljsdo6IC4CZgxQOdJosGsO0VYolneYIs7C2KCnJqRCgGslsUgys6HboCYijwZCWAH8CRBMGAKZ3+BwOe9TPFBVWIXa/z19ogyqg9CIGEMwQZe9el3J0E8t9FiczKN4YLWE1KuBFHYEgnFDSvWPv1Pc3+3ZeHe8YmvrZfWZWR6nAzHIgdhGZKu9u+1F9cNfGLctHm8ba9mw6MMqpwOgi1S9NTkz77jzfvnnbzP7qX2NNW4938OqBRaMuy5F8wGq6Fz13YUZuHfcOGWf7UoAKcFyt2uCEFDTr0EvT9zG6wE4bolZstVR0xZFob54WIhTmYlmMQFMYxqb1dKrZq4jofPGgtSWjQShQKBLEUt3wcPv8KRgHjXnlc/PFt7ouN9dn12fW1dXWHjvx/klzHCB4Q/uXpa/llR9Kiwd6bnblX8nPL/12EltrFOCZuf2flja8/Pi5vLJyoaKiYmGx9CyZ8Kg0GWn9b+fevX61ITZlZWWLPdk4kiCQGLk9UPz08eSzyZGRh48uatUbEgiWmd2Sm5t2/nRe77W0lYqSB8Ubtek1ggytkdU3lSygoERCNW7CKUv0eoJjjBE/6/GVME6jaz1BKSwWdniLht0pNtlGJgOgMSrooJdNCZjS3eJ6e+KokYoMHwrECqUVM5WckAUcFFdQWKQxBA0eAUeTfsIsih6eM4SMYb2XEgLwN2WMcSPeECwqAAAAAElFTkSuQmCC',
                supported: true,
              },
              '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2': {
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                name: 'Wrapped Ether',
                symbol: 'WETH',
                decimals: 18,
                icon: 'iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAFjklEQVR42q2We0xURxTGz727d/eyLC7IIiwU2QdQtrVG8FF5VKVVMDS1CJaikLap0RhpsIAiVYRqKC8DBlRqUogvHv4hr4ogGgkhpo2hVMAKxJJKLWltoxI0sSDUr5mRNUqqVOUkk8zenXt+93xnzpkhmsIUgqAVSTAT0RIi+oSI1hJRDBEFSIJitpJEBU2HKQTBjYjiiOi0QeGA1yUXhMomRNj54l3ZFyGq2fBT6ocVJJQQ0XJJUEgvw1tFRB1zVLOwTReCJtePAGMOYCnEX4ZtaNStRYH8Dj4UfGEgNVREUJJwgoj8XgSWphFU2KoLwTXPZMD7IGDJQdnM97GEnOBOEvysfghcHIiwoGWIXhIOq8EIImJjwF5tl/g8sAw7QcJRlyjAnAdY9qJxVjwCyAkqZwfEb9uMw7UncOnKZfz86y989F+/hu/bL6KsrAxr1qyxgWtEUZwy2o91oowj+oewUWMmktSLoFWo8WnaFlz6qRtT2cjICM40n8H8+fMZ9LpGo1n1NJg3Ed3OdloOmPNx3/glNqv8YTdDi0MVh/G8dvPmTSQkJDDoLYVCsWwyTCCiHYFqT9yevQMw56JYuxIOGnscOVGOF7WxsTFs2LCBQX8gIpfHga4aQfqtaGYE34VXXknEDBKRWZiDl7WhoSEsXbqUQfcTkdIGfPtVSY8/eXT5WCdbMSd0MUbuj2I67Pz589BoNAzqbwNmrrV/A/ApwVXPRNgTobr1DKbTIiMjGTBLkiQeZZFJckSbYQOOaN+DaZ4V3zY2oLi4GK2trSgvL0dFRQU6Ozuxe/dunDx5EkVFRUhLS+Nr2H87d+7ko6qqCoWFhaipqUFLSwv27NmDO3fuoLKyElqtdlCr1bqRLCj36hQyjLITPEiLz75IwdmzZ+Hs7MyTbjQa4e/vj/T0dF5jycnJMBgMfM7yExcXZ6s9bNy4Efb29lixYgVSUlL4s97eXoyOjsLHxweiKHqTSEJBgsMi5OtX8gVFJQf4DrNYLAgMDIRer8fcuXMRHBzMXkBJSQlMJhOCgoJw6tQp7pDlKDw8HDdu3IDZbIaXlxcCAgI4nCnDbKI2w5mk30RqrBg3ZcGf1Mg7WsIXREVFwdXVlUnBnatUKg6tq6uDp6cn3NzckJqainv37sHR0RExMTH8PavVClmW+Ue4uLigvb2dPw8NDWXAeAbcQgIhfWYo3iQtckr38wW7du3iETPnTCI237RpE9ra2rikTE6Wp4GBATg5OSE6OppL5+vry/9bv349B3d0dHB/ISEhzMcHDGjRCeoHrioH7jQn92H91dbW8t8LFy7E9u3b+by0tBR9fX2Pcubt7Y36+no+Zyqw1saUYFFOFP0jSdkzIlrAgGq9qKlcpjbCKjrjtbcWYOjWbd6emGTnzp3jX8l25eDgIIaHh5GRkYGkpCTk5uaiv78f2dnZOH78OMbHx5GXl4djx46hqamJ71zmp6urC+7u7uOyLHvZajF4juSKz+VFcCY1Lnb9OK11yBRSKpWn1Wq1xgYUiejActkCb9IgM/+raYMxRVhaJq4lT5ikFMQ6vcLuH5PbK+jp650WYFZWFgRBuCyKout/HVNmgYROlmy269jXvYw1NzdDp9Ox6NZNBmknauQoEfUS0QMGXb16Ne7evftCsAsXLsDDw4PBsifDZhBRo22rTx4RERHo7u5+Llh1dbUNdmjivH3C5j0NZhusq2RmZqKnp+eZoIaGBsTGxrJ3/iai1KddL54ZIeuftjnrIvHx8bzu9u3bx0+GgoICJCYmIiwsjOWLpeKgJElBU12gbDmsmsjhs8Bj7P5DRH8Q0WUiaiGir4koVqVS+f/f6yGrw8XskJyI9joR/f74EATBNr/KLslE9B0R1bPmT0RbWdvSaDTOU4H+Bc/z92HCspq3AAAAAElFTkSuQmCC',
                supported: true,
              },
              ETH: {
                symbol: 'ETH',
                decimals: 18,
                address: '',
              },
            },
          },
        },
        {
          type: 'risks',
          status: 'Calculated',
          data: {
            totalScore: 53,
            score: {
              sof: [
                {
                  name: 'High-risk exchange',
                  amount: 8000000000000000,
                  price: 30.91239302510495,
                  score: 70,
                  share: 0.0004189346504509982,
                  generalShare: 0,
                  deepDepthShare: 0.0004189346504509982,
                  depth: 2,
                },
              ],
              uof: [
                {
                  name: 'High-risk exchange',
                  amount: 76369620159299360,
                  price: 295.09596419278,
                  score: 70,
                  share: 0.004252601572588926,
                  generalShare: 0,
                  deepDepthShare: 0.004252601572588926,
                  depth: 2,
                },
              ],
            },
            owner: {
              status: 'Not Identified',
              type: {},
              tags: [],
              meta: [],
              clusterData: {},
            },
          },
        },
        {
          type: 'tier2',
          status: 'TIER2 Found',
          data: {
            labelBarsSof: [
              {
                directTx:
                  '0x899f1bb885d288721a25fd032d9879d97f845d15e6d779ff61e14422a44ef13b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'NFT marketplace',
                  score: 40,
                  id: '6604a0ed8d004d1f88b8a4b2',
                  type: 'NFT marketplace',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 4006994793500000000,
                amountCur: 15483.224738277662,
                currency: '',
                tx_hash:
                  '0x899f1bb885d288721a25fd032d9879d97f845d15e6d779ff61e14422a44ef13b',
                address: '0x00000000006c3852cbef3e08e8df289169ede581',
                directStamp: 1664531087,
                timestamp: 1664531087,
                listType: 'Known sources',
                share: 0.2098,
                amountDec: 0.78625,
                deepDepthShare: 0.03249807000626659,
                generalShare: 0.17733555039047003,
                price: null,
                originalShare: 0.20983362039673661,
              },
              {
                directTx:
                  '0x41ec849a95f3a8526876d300d26ad1b017c7fed6c2a33e9c2be2335c9ae21d37',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unknown smart contract',
                  score: 50,
                  default: true,
                  type: 'unknown smart contract',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 1.411005876372823e24,
                amountCur: 37406.67052986267,
                currency: '',
                tx_hash:
                  '0x41ec849a95f3a8526876d300d26ad1b017c7fed6c2a33e9c2be2335c9ae21d37',
                address: '0x0000000000000068f116a894984e2db1123eb395',
                directStamp: 1742201411,
                timestamp: 1742201411,
                listType: 'Unknown sources',
                share: 0.5069,
                amountDec: 0.46305,
                deepDepthShare: 0.003104201026179284,
                generalShare: 0.5038429780626984,
                price: null,
                originalShare: 0.5069471790888778,
              },
              {
                directTx:
                  '0x459e9b02296996aa0f6cb980d2f9796192eafda7da6be750bf8ec1f1b5b51454',
                directionUp: false,
                token: '',
                funds: {
                  name: 'wrapped token',
                  score: 10,
                  id: '65ea5850e72f728fbc45010e',
                  type: 'wrapped token',
                },
                owner: 'Wrapped Ether',
                entity: '682afaa11a39a7022034af45',
                depth: 1,
                amount: 3579297629329458000,
                amountCur: 13707.41873232806,
                currency: '',
                tx_hash:
                  '0x459e9b02296996aa0f6cb980d2f9796192eafda7da6be750bf8ec1f1b5b51454',
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                inputAmounts: [
                  {
                    amount: 230000000000000000,
                    currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                    amountCur: 871.3121730986122,
                    amountDec: 0.23,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 230000000000000000,
                    amountCur: 888.7312994717673,
                    amountDec: 0.23,
                  },
                ],
                directStamp: 1744733507,
                timestamp: 1744733507,
                listType: 'Swap',
                share: 0.1857,
                amountDec: 0.23,
                deepDepthShare: 0.06539591493429646,
                generalShare: 0.12037141374031128,
                price: null,
                originalShare: 0.18576732867460768,
              },
              {
                directTx:
                  '0x201fe0a9a1cc5ca88f2e8ab549fbf15f37bc26d36a776a7942387c4ec41589e9',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'Crypto.com',
                entity: '65abc6368bc257cd152c00e9',
                depth: 1,
                amount: 1143612428571428600,
                amountCur: 4418.974607549346,
                currency: '',
                tx_hash:
                  '0x201fe0a9a1cc5ca88f2e8ab549fbf15f37bc26d36a776a7942387c4ec41589e9',
                address: '0x46340b20830761efd32832a74d7169b29feb9758',
                directStamp: 1693846727,
                timestamp: 1693846727,
                listType: 'Known sources',
                share: 0.0598,
                amountDec: 0.19,
                deepDepthShare: 0.008112273014260832,
                generalShare: 0.051775086112612737,
                price: null,
                originalShare: 0.05988735912687357,
              },
              {
                directTx:
                  '0x8ada37a39d79fb899767bcc7420ecc055577dd4f815bda2927b716f33049b400',
                directionUp: false,
                token: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                funds: {
                  name: 'DEX',
                  score: 50,
                  id: '66049d278d004d1f88b515cd',
                  type: 'DEX',
                },
                owner: 'Mimic.fi',
                entity: '682af8b31a39a702203499ba',
                depth: 3,
                amount: 186567940829092400,
                amountCur: 707.6843001219924,
                currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                tx_hash:
                  '0x5c1e8a403d44e66f64e2d8f20874d39f71f11af5e803411250effd85501d2594',
                address: '0xa7ca2c8673bcfa5a26d8ceec2887f2cc2b0db22a',
                inputAmounts: [
                  {
                    amount: 200000000000000000,
                    amountCur: 772.8098256276238,
                    amountDec: 0.2,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 200000000000000000,
                    currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                    amountCur: 757.6627592161846,
                    amountDec: 0.2,
                  },
                ],
                directStamp: 1686905879,
                timestamp: 1686511955,
                listType: 'Swap',
                share: 0.0095,
                amountDec: 0.1746,
                deepDepthShare: 0.009590764282159926,
                generalShare: 0,
                price: null,
                originalShare: 0.009590764282159926,
              },
              {
                directTx:
                  '0x9a188bbfac46dcf5ed4cefa6d49aa2d182bd1300639e58418ccf01fb8518c2e8',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Cross-chain protocol',
                  score: 60,
                  id: '61c5f810c004380117d443d5',
                  type: 'Cross-chain protocol',
                },
                owner: 'Across Protocol',
                entity: '65dd3ad48bc257cd15c51b27',
                depth: 1,
                amount: 216497881166959740,
                amountCur: 836.5584489669407,
                currency: '',
                tx_hash:
                  '0x9a188bbfac46dcf5ed4cefa6d49aa2d182bd1300639e58418ccf01fb8518c2e8',
                address: '0x5c7bcd6e7de5423a257d81b442095a1a6ced35c5',
                directStamp: 1738982795,
                timestamp: 1738982795,
                listType: 'Risky sources',
                share: 0.0113,
                amountDec: 0.09889913099979605,
                deepDepthShare: 0.005131459344631808,
                generalShare: 0.006205848676625944,
                price: null,
                originalShare: 0.011337308021257752,
              },
              {
                directTx:
                  '0x55ca1d0ea7fb07d014649c51662334f334f2d29f4e07a8387a69fd9085320847',
                directionUp: false,
                token: '',
                funds: {
                  name: 'MEV bot',
                  score: 50,
                  id: '637e329fca61b25b03cf5037',
                  type: 'MEV bot',
                },
                owner: 'MEV Bot 0x74d631',
                entity: '682af8b01a39a702203497b6',
                depth: 1,
                amount: 147846565390970080,
                amountCur: 570.4969228720861,
                currency: '',
                tx_hash:
                  '0x55ca1d0ea7fb07d014649c51662334f334f2d29f4e07a8387a69fd9085320847',
                address: '0x74de5d4fcbf63e00296fd95d33236b9794016631',
                inputAmounts: [
                  {
                    amount: 5.943396e25,
                    currency: '0x18c1074845c389907762a71242bfe271c9da2d9c',
                  },
                ],
                outputAmounts: [
                  {
                    amount: 74582008814593900,
                    amountCur: 288.1885461348211,
                    amountDec: 0.0745820088145939,
                  },
                ],
                directStamp: 1686986171,
                timestamp: 1686986171,
                listType: 'Swap',
                share: 0.0077,
                amountDec: 0.0745820088145939,
                deepDepthShare: 0,
                generalShare: 0.007731557009277383,
                price: null,
                originalShare: 0.007731557009277383,
              },
              {
                directTx:
                  '0xb28e63fa9649ab1c363a385b5a5275b9fe98777331515b4a376ca01d862519f8',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unknown wallet / otc / service',
                  score: 50,
                  default: true,
                  type: 'unknown wallet / otc / service',
                },
                owner: 'unknown wallet / otc / service',
                depth: 1,
                amount: 71376716914832300,
                amountCur: 275.8031407641191,
                currency: '',
                tx_hash:
                  '0xb28e63fa9649ab1c363a385b5a5275b9fe98777331515b4a376ca01d862519f8',
                address: '0xf70da97812cb96acdf810712aa562db8dfa3dbef',
                directStamp: 1745291567,
                timestamp: 1745291567,
                listType: 'Unknown sources',
                share: 0.0037,
                amountDec: 0.027704580975743413,
                deepDepthShare: 0,
                generalShare: 0.0037377724938818906,
                price: null,
                originalShare: 0.0037377724938818906,
              },
              {
                directTx:
                  '0xcb5fdaf14a71c25abaf9cd10a6d5708f922b14425bb0d81d8dea2133eca5c0a4',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                  type: 'small transactions',
                },
                owner: 'small transactions',
                depth: 2,
                amount: 90365928308363490,
                amountCur: 349.1783864933236,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1701838631,
                timestamp: {
                  minimum: 1701185627,
                  maximum: 1701747215,
                },
                listType: 'Unknown sources',
                share: 0.0047,
                amountDec: 0.010526510505908531,
                deepDepthShare: 0.001047770741692021,
                generalShare: 0.003684406581876006,
                price: null,
                originalShare: 0.004732177323568027,
              },
              {
                directTx:
                  '0x8e3e3acf75ff973ea259bb023d690e461f399ce82d62520d458c27060e56303e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'High-risk exchange',
                  score: 70,
                  id: '61766f47820e1372d85ded59',
                  type: 'High-risk exchange',
                },
                owner: 'ChangeNOW',
                entity: '6603e884a6a313bd816dba8e',
                depth: 2,
                amount: 8000000000000000,
                amountCur: 30.91239302510495,
                currency: '',
                tx_hash:
                  '0x1cfff699ad72f1b7e7a552f196edc44c4b1d989ea28d633881756ba856078c81',
                address: '0x077d360f11d220e4d5d831430c81c26c9be7c4a4',
                directStamp: 1707845075,
                timestamp: 1707844187,
                listType: 'Risky sources',
                share: 0.0004,
                amountDec: 0.008,
                deepDepthShare: 0.0004189346504509982,
                generalShare: 0,
                price: null,
                originalShare: 0.0004189346504509982,
              },
              {
                directTx:
                  '0x17fae9c733155c441c529a24929189678f2fbbc12a4218a6012600b943c02eed',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Service',
                  score: 30,
                  id: '617bc29abc4783e21affa642',
                  type: 'Service',
                },
                owner: 'ENS Domains',
                entity: '682af8381a39a70220348a18',
                depth: 1,
                amount: 305516524664082,
                amountCur: 1.1805308607600342,
                currency: '',
                tx_hash:
                  '0x17fae9c733155c441c529a24929189678f2fbbc12a4218a6012600b943c02eed',
                address: '0x283af0b28c62c092c9727f1ee09c02ca627eb7f5',
                directStamp: 1677460607,
                timestamp: 1677460607,
                listType: 'Known sources',
                share: 0,
                amountDec: 0.000305516524664082,
                deepDepthShare: 0,
                generalShare: 0.000015998932308393872,
                price: null,
                originalShare: 0.000015998932308393872,
              },
            ],
            labelBarsUof: [
              {
                directTx:
                  '0x7d6942018c15960f1ad963ede6ec9ef22200cc71b450d75d1cf591672e2f340f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'NFT marketplace',
                  score: 40,
                  id: '6604a0ed8d004d1f88b8a4b2',
                  type: 'NFT marketplace',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 2599008160456794600,
                amountCur: 10042.565898357449,
                currency: '',
                tx_hash:
                  '0x7d6942018c15960f1ad963ede6ec9ef22200cc71b450d75d1cf591672e2f340f',
                address: '0x00000000006c3852cbef3e08e8df289169ede581',
                directStamp: 1664545751,
                timestamp: 1664545751,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Known sources',
                share: 0.1447,
                amountDec: 0.8,
                deepDepthShare: 0.015724338996918483,
                generalShare: 0.12899818084168965,
                price: null,
                originalShare: 0.1447225198386081,
              },
              {
                directTx:
                  '0xe44038dbf7d98b59988b048233486cdb5860f1876023cac375159b8866b8373b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown smart contract',
                  score: 50,
                  default: true,
                  type: 'unknown smart contract',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 36200968176048546000,
                amountCur: 42936.48661030878,
                currency: '',
                tx_hash:
                  '0xe44038dbf7d98b59988b048233486cdb5860f1876023cac375159b8866b8373b',
                address: '0x0000000000000068f116a894984e2db1123eb395',
                directStamp: 1742395859,
                timestamp: 1742395859,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Unknown sources',
                share: 0.6187,
                amountDec: 0.43,
                deepDepthShare: 0.012907467778157069,
                generalShare: 0.6058464043051602,
                price: null,
                originalShare: 0.6187538720833173,
              },
              {
                directTx:
                  '0x62b11c2c7c573915648cd7943aa1c310e32303b74de90e6adf023110e22f0d28',
                directionUp: true,
                token: '',
                funds: {
                  name: 'wrapped token',
                  score: 10,
                  id: '65ea5850e72f728fbc45010e',
                  type: 'wrapped token',
                },
                owner: 'Wrapped Ether',
                entity: '682afaa11a39a7022034af45',
                depth: 1,
                amount: 2321416271415973000,
                amountCur: 8832.516265432812,
                currency: '',
                tx_hash:
                  '0x62b11c2c7c573915648cd7943aa1c310e32303b74de90e6adf023110e22f0d28',
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                inputAmounts: [
                  {
                    amount: 230000000000000000,
                    amountCur: 888.7312994717673,
                    amountDec: 0.23,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 230000000000000000,
                    currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                    amountCur: 871.3121730986122,
                    amountDec: 0.23,
                  },
                ],
                directStamp: 1744070159,
                timestamp: 1744070159,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Swap',
                share: 0.1272,
                amountDec: 0.23,
                deepDepthShare: 0.0007039545854955671,
                generalShare: 0.12658064811330283,
                price: null,
                originalShare: 0.1272846026987984,
              },
              {
                directTx:
                  '0x0ebd8a2f69a478de89d44f829ead2a498e725a24ac67123e90260e4efd73b2db',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown wallet / otc / service',
                  score: 50,
                  default: true,
                  type: 'unknown wallet / otc / service',
                },
                owner: 'unknown wallet / otc / service',
                depth: 2,
                amount: 319928553773650600,
                amountCur: 1235.8394159684058,
                currency: '',
                tx_hash:
                  '0xd262b9f0f81b2f224bb38e31262451f140c03954d975adbaf12c041b1b529a66',
                address: '0xeba88149813bec1cccccfdb0dacefaaa5de94cb1',
                directStamp: 1744733651,
                timestamp: 1744733747,
                'address-1': '0x35a507c63c9e3177025b7a1e727f2e7fbb6af4b8',
                listType: 'Unknown sources',
                share: 0.0178,
                amountDec: 0.19995,
                deepDepthShare: 0.015029683044908603,
                generalShare: 0.0027798883539780746,
                price: null,
                originalShare: 0.01780957139888668,
              },
              {
                directTx:
                  '0x01511a85ac8674e3265ff8ed07e7c5ddcd691dd2ed32040517d625b7bd57bdeb',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'Crypto.com',
                entity: '65abc6368bc257cd152c00e9',
                depth: 2,
                amount: 668000000000000000,
                amountCur: 2581.184817596263,
                currency: '',
                tx_hash:
                  '0xd72b470d45ca7a73150258506be5ea3da7848b46783046711e3afc5491d8370a',
                address: '0xcffad3200574698b78f32232aa9d63eabd290703',
                directStamp: 1688194691,
                timestamp: 1688530103,
                'address-1': '0x77ef13a157a3177d44f06d34c5aca28f61874967',
                listType: 'Known sources',
                share: 0.0371,
                amountDec: 0.157,
                deepDepthShare: 0.037197223772540804,
                generalShare: 0,
                price: null,
                originalShare: 0.037197223772540804,
              },
              {
                directTx:
                  '0xb21b52e645c9866f1a4fa4b8065df3ab687e180fc690e26ba4cb3fa931e3cacf',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Cross-chain protocol',
                  score: 60,
                  id: '61c5f810c004380117d443d5',
                  type: 'Cross-chain protocol',
                },
                owner: 'Socket.tech',
                entity: '65dd42288bc257cd15c624ab',
                depth: 2,
                amount: 208895124728877760,
                amountCur: 807.1810245809239,
                currency: '',
                tx_hash:
                  '0xa46e73e8a50fae734d4c1be8b17a771eabe6ee87a8e5f49654e599cf4a15608d',
                address: '0x3a23f943181408eac424116af7b7790c94cb97a5',
                directStamp: 1712716415,
                timestamp: 1712716487,
                'address-1': '0x856ab40c16b68ffa2ba912974a00a45bac43e69d',
                listType: 'Risky sources',
                share: 0.0116,
                amountDec: 0.09576217320898289,
                deepDepthShare: 0.00756724755110391,
                generalShare: 0.004064966070951317,
                price: null,
                originalShare: 0.011632213622055227,
              },
              {
                directTx:
                  '0x14adef8c8e3fcc7916749eb5967fa6bdf4c3472c4823bfa45e552b8f54cbd131',
                directionUp: true,
                token: '',
                funds: {
                  name: 'dApps',
                  score: 50,
                  id: '66049d908d004d1f88b561f9',
                  type: 'dApps',
                },
                owner: 'Base (by Coinbase)',
                entity: '682af82a1a39a70220347f58',
                depth: 2,
                amount: 424555676617511600,
                amountCur: 1640.503992079985,
                currency: '',
                tx_hash:
                  '0x481164c459d0a0463b813bb67580d44c8d0ad78bf44b3778849aa66b35112187',
                address: '0x49048044d57e1c92a77f79988d21fa8faf74e97e',
                directStamp: 1693976783,
                timestamp: 1693976843,
                'address-1': '0xb85dcbdadae8d2ccd532f80a86880f7f7877a919',
                listType: 'Known sources',
                share: 0.0236,
                amountDec: 0.049,
                deepDepthShare: 0.00493117562794961,
                generalShare: 0.018709980819721125,
                price: null,
                originalShare: 0.023641156447670737,
              },
              {
                directTx:
                  '0xb36aea9fd79894536ccaf73cbd127016c76956e0d85c82a211575d0fff24c77c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'High-risk exchange',
                  score: 70,
                  id: '61766f47820e1372d85ded59',
                  type: 'High-risk exchange',
                },
                owner: 'ChangeNOW',
                entity: '6603e884a6a313bd816dba8e',
                depth: 2,
                amount: 76369620159299380,
                amountCur: 295.09596419278006,
                currency: '',
                tx_hash:
                  '0x78d17356afcf6322c78206e5d0001cbf2ff49baccedde75bbac1a698bd204133',
                address: '0x077d360f11d220e4d5d831430c81c26c9be7c4a4',
                directStamp: 1711566359,
                timestamp: 1711566491,
                'address-1': '0xc65c55b2ea33fcb3d393f9ef0e1bfe67798b68f0',
                listType: 'Risky sources',
                share: 0.0042,
                amountDec: 0.048878,
                deepDepthShare: 0.004252601572588927,
                generalShare: 0,
                price: null,
                originalShare: 0.004252601572588927,
              },
              {
                directTx:
                  '0xd7d097d7ce922bbcc9e8dadf7a83c3842a3508c3e29cf0851d1692e6a377600a',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Online wallet',
                  score: 60,
                  id: '61767102820e13ff395ded5f',
                  type: 'Online wallet',
                },
                owner: 'MetaMask',
                entity: '667abef6b8f819d6d0a61a11',
                depth: 1,
                amount: 50000000000000000,
                amountCur: 193.20245640690592,
                currency: '',
                tx_hash:
                  '0xd7d097d7ce922bbcc9e8dadf7a83c3842a3508c3e29cf0851d1692e6a377600a',
                address: '0x881d40237659c251811cec9c364ef91dc08d300c',
                inputAmounts: [
                  {
                    amount: 30000000000000000,
                    amountCur: 115.92147384414356,
                    amountDec: 0.03,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 1.4427173822532351e28,
                    currency: '0x2f573070e6090b3264fe707e2c9f201716f123c7',
                  },
                ],
                directStamp: 1688792531,
                timestamp: 1688792531,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Swap',
                share: 0.0027,
                amountDec: 0.03,
                deepDepthShare: 0,
                generalShare: 0.0027842233362680244,
                price: null,
                originalShare: 0.0027842233362680244,
              },
              {
                directTx:
                  '0x042d40bf48977d7917044f9e876a031a641ed9f0acaff357d2f02a2355e3dadf',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                  type: 'small transactions',
                },
                owner: 'small transactions',
                depth: 1,
                amount: 157924666762290140,
                amountCur: 610.2286709143303,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1659231967,
                timestamp: {
                  minimum: 1659237039,
                  maximum: 1659241593,
                },
                listType: 'Unknown sources',
                share: 0.0087,
                amountDec: 0.028399,
                deepDepthShare: 0.0011338527996630921,
                generalShare: 0.007660098051775301,
                price: null,
                originalShare: 0.008793950851438392,
              },
              {
                directTx:
                  '0x9f934ba4efb800e6aecb1e45a8452e3f8fad059999a3bd7fe5bbda7847b9a0bc',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 30,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Coinbase',
                entity: '682aefde3be18468d7f0500a',
                depth: 4,
                amount: 29493507176617844,
                amountCur: 113.96436069154554,
                currency: '',
                tx_hash:
                  '0xfc51fd9157845d4022ea7a2a2c242996d8a0648bcf26c7eeff2603a2f19885bc',
                address: '0xa9d1e08c7793af67e9d92fe308d5697fb81d3e43',
                directStamp: 1685504735,
                timestamp: 1686689171,
                'address-1': '0x068068fee8521a94275ed6e9059a3d5b9492c9e3',
                listType: 'Known sources',
                share: 0.0016,
                amountDec: 0.024993507176617843,
                deepDepthShare: 0.0016423302189905575,
                generalShare: 0,
                price: null,
                originalShare: 0.0016423302189905575,
              },
              {
                directTx:
                  '0x59c25368ec3376382dc24b7a6ea360fe2d859f699151c24833d60b2f61fa678d',
                directionUp: true,
                token: '',
                funds: {
                  name: 'DEX',
                  score: 50,
                  id: '66049d278d004d1f88b515cd',
                  type: 'DEX',
                },
                owner: 'Uniswap',
                entity: '6603e89ea6a313bd816dbb0f',
                depth: 2,
                amount: 18511061132255000,
                amountCur: 71.52764962900136,
                currency: '',
                tx_hash:
                  '0x07caad8f8549be229014dfc2442e7134c2ca92cdeca8cce17f42a9100d8d74cf',
                address: '0x68b3465833fb72a70ecdf485e0e4c7bd8665fc45',
                inputAmounts: [
                  {
                    amount: 18511061132255000,
                    amountCur: 71.52764962900136,
                    amountDec: 0.018511061132255,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 19191008636,
                    currency: '0xa0b73e1ff0b80914ab6fe0444e65848c4c34450b',
                    amountCur: 27.14577274773372,
                    amountDec: 191.91008636,
                  },
                ],
                directStamp: 1653821009,
                timestamp: 1653821355,
                'address-1': '0xc0c603c330cfed4963fee36b3b49fae2e706a3db',
                listType: 'Swap',
                share: 0.001,
                amountDec: 0.018511061132255,
                deepDepthShare: 0.0010307785676701676,
                generalShare: 0,
                price: null,
                originalShare: 0.0010307785676701676,
              },
              {
                directTx:
                  '0xa8ea1efb3e695f7304ee2678f669d20921bec8437a2513b05cb800b2b0508e77',
                directionUp: true,
                token: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                funds: {
                  name: 'MEV bot',
                  score: 50,
                  id: '637e329fca61b25b03cf5037',
                  type: 'MEV bot',
                },
                owner: 'MEV Bot 0x74d631',
                entity: '682af8b01a39a702203497b6',
                depth: 1,
                amount: 1.4109711103888875e24,
                amountCur: 15.91732136558043,
                currency: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                tx_hash:
                  '0xa8ea1efb3e695f7304ee2678f669d20921bec8437a2513b05cb800b2b0508e77',
                address: '0x74de5d4fcbf63e00296fd95d33236b9794016631',
                inputAmounts: [
                  {
                    amount: 1.4109711103888875e24,
                    currency: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                    amountCur: 15.91732136558043,
                    amountDec: 1410971.1103888876,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 5498638962952396,
                    amountCur: 21.247011090742497,
                    amountDec: 0.005498638962952396,
                  },
                ],
                directStamp: 1748906735,
                timestamp: 1748906735,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Swap',
                share: 0.0002,
                amountDec: 1410971.1103888876,
                deepDepthShare: 0,
                generalShare: 0.00022938309595603334,
                price: null,
                originalShare: 0.00022938309595603334,
              },
              {
                directTx:
                  '0x17fae9c733155c441c529a24929189678f2fbbc12a4218a6012600b943c02eed',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Service',
                  score: 30,
                  id: '617bc29abc4783e21affa642',
                  type: 'Service',
                },
                owner: 'ENS Domains',
                entity: '682af8381a39a70220348a18',
                depth: 1,
                amount: 3360681771304902,
                amountCur: 12.985839468360377,
                currency: '',
                tx_hash:
                  '0x17fae9c733155c441c529a24929189678f2fbbc12a4218a6012600b943c02eed',
                address: '0x283af0b28c62c092c9727f1ee09c02ca627eb7f5',
                directStamp: 1677460607,
                timestamp: 1677460607,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Known sources',
                share: 0.0001,
                amountDec: 0.003360681771304902,
                deepDepthShare: 0,
                generalShare: 0.0001871377722687534,
                price: null,
                originalShare: 0.0001871377722687534,
              },
              {
                directTx:
                  '0x3a1a64089e04781da4a1ad17fa847f19ec8d0568d5d9c17ef9de7c88081a642f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                  type: 'unhosted wallet',
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 690223417815052,
                amountCur: 2.667057195828764,
                currency: '',
                tx_hash:
                  '0x3a1a64089e04781da4a1ad17fa847f19ec8d0568d5d9c17ef9de7c88081a642f',
                address: '0xa7bc237f6621d1e89009a078bf18c95d6d7c2c5d',
                directStamp: 1753323083,
                timestamp: 1753323083,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Unknown sources',
                share: 0,
                amountDec: 0.000690223417815052,
                deepDepthShare: 0,
                generalShare: 0.00003843472294238686,
                price: null,
                originalShare: 0.00003843472294238686,
              },
            ],
            evaluatedSofTxs: 257,
            evaluatedUofTxs: 272,
            currencies: {},
            sources: [],
          },
        },
      ],
      createdAt: '2025-07-31T08:34:12.748Z',
    },
  },
  tier2_0x6982508145454ce325ddbe47a25d4ec3d2311933: {
    success: true,
    data: {
      coin: 'eth',
      address: '0x44473b3356906d6ae34299ddf53020f131fa0835',
      decimals: 18,
      parts: [
        {
          type: 'address',
          status: 'Identified',
          data: {
            addressType: 'address',
            balance: 0,
            price: null,
            priceTimestamp: 1753886604191,
            numberOfTxs: 2,
            numberOfTxsBySources: 2,
            firstSeen: 1748901479,
            lastSeen: 1748906735,
            totalTxReceived: 1,
            totalTxSent: 1,
            tokens: {
              '': {
                address: '',
                symbol: 'ETH',
                decimals: 18,
                supported: true,
                unknownContract: true,
              },
              '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73': {
                address: '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73',
                name: 'Virtual Protocol',
                symbol: 'VIRTUAL',
                decimals: 18,
                supported: true,
              },
              '0x6982508145454ce325ddbe47a25d4ec3d2311933': {
                address: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                name: 'Pepe',
                symbol: 'PEPE',
                decimals: 18,
                icon: 'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAACKFBMVEVek0tdkkpflEthmE1moFFglUxjm05imU5lnU9lnlBHcThGbjdnoVJknE9KdjtFbDdoo1NZjEZBZjRNeT1rp1VVhUNTgUJOfD1CaDRRgEBQfT9KdDpJczpckEk2Vio0UyhYikZXiEVWh0RMeDw9YTAxTiYrRSGIJhhtqldgl0xUhEJEgkFEazY/ZDI5XC04WSwnQR1urVhaq1ZdqVVqpVRWolFbj0dJjEU8dztXbDZDazQ7Xi8zUSlYPiEjOxtaLBmKIxdsEw1eEwxpEgx1tl1YU1pvrllkqVZgp1RZp1NfpFJinE9OTk9Tm05OnE1NgD47ND5PaTVEdjM+aDNVZDM6UjFeWS8tXi47aCpUUipaTikxUCYzVyUuSCR4QyQxXyAcFx4oSB0sVxx0MRwfKRwmShkkRhgcPBCMFRBLGQ9kEAx/Dgx2DQsNMQL////+9f/18PfW2NXI0MW/wL+mpaeZqZOUlZOJhYqDlXxwaXN0gW9ud2xzjmppbWdkXWZ4u19nsVlxsFllh1hgrVdcclRFnU5Xlk1ZlUxRlUtZfUtOk0pRaElKh0RKZUA/fT9PiDlEczlTcDlCXTgybjVHfDNCcDFcXjFjXTFJWCwwOSw8cig1XScyVCZGTCZ/QSVDPiBxNR5pMx5sNB14MBwcHBw4NBqCKhqUKRqeKBogMRl0KRiaIhdfJRVlIxV/IRVkHhJ3GBFXGxCGFRBQFw8RHA0GAAwLGQYBAQHwHWUjAAACo0lEQVQ4y3XSVXPbQBQFYK1WjJZkZm7imMLMzMzMXGZmZmZm5v69OkrHqev0vuhhvzl7NWeR+KA4ivx/AMHnSDaeACQPeT5ZAsolWgUrq9c6WQ+jQBL8c07rZR2CohLDCnpJZ2Xw1ERA2GSc5qArJ9UnafmsIyYLnRCBUrJJA5mQKFrCYULPWExGif9bYIwVI4NeCZIIFPyyIljsdo6IC4CZgxQOdJosGsO0VYolneYIs7C2KCnJqRCgGslsUgys6HboCYijwZCWAH8CRBMGAKZ3+BwOe9TPFBVWIXa/z19ogyqg9CIGEMwQZe9el3J0E8t9FiczKN4YLWE1KuBFHYEgnFDSvWPv1Pc3+3ZeHe8YmvrZfWZWR6nAzHIgdhGZKu9u+1F9cNfGLctHm8ba9mw6MMqpwOgi1S9NTkz77jzfvnnbzP7qX2NNW4938OqBRaMuy5F8wGq6Fz13YUZuHfcOGWf7UoAKcFyt2uCEFDTr0EvT9zG6wE4bolZstVR0xZFob54WIhTmYlmMQFMYxqb1dKrZq4jofPGgtSWjQShQKBLEUt3wcPv8KRgHjXnlc/PFt7ouN9dn12fW1dXWHjvx/klzHCB4Q/uXpa/llR9Kiwd6bnblX8nPL/12EltrFOCZuf2flja8/Pi5vLJyoaKiYmGx9CyZ8Kg0GWn9b+fevX61ITZlZWWLPdk4kiCQGLk9UPz08eSzyZGRh48uatUbEgiWmd2Sm5t2/nRe77W0lYqSB8Ubtek1ggytkdU3lSygoERCNW7CKUv0eoJjjBE/6/GVME6jaz1BKSwWdniLht0pNtlGJgOgMSrooJdNCZjS3eJ6e+KokYoMHwrECqUVM5WckAUcFFdQWKQxBA0eAUeTfsIsih6eM4SMYb2XEgLwN2WMcSPeECwqAAAAAElFTkSuQmCC',
                supported: true,
              },
              '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2': {
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                name: 'Wrapped Ether',
                symbol: 'WETH',
                decimals: 18,
                icon: 'iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAFjklEQVR42q2We0xURxTGz727d/eyLC7IIiwU2QdQtrVG8FF5VKVVMDS1CJaikLap0RhpsIAiVYRqKC8DBlRqUogvHv4hr4ogGgkhpo2hVMAKxJJKLWltoxI0sSDUr5mRNUqqVOUkk8zenXt+93xnzpkhmsIUgqAVSTAT0RIi+oSI1hJRDBEFSIJitpJEBU2HKQTBjYjiiOi0QeGA1yUXhMomRNj54l3ZFyGq2fBT6ocVJJQQ0XJJUEgvw1tFRB1zVLOwTReCJtePAGMOYCnEX4ZtaNStRYH8Dj4UfGEgNVREUJJwgoj8XgSWphFU2KoLwTXPZMD7IGDJQdnM97GEnOBOEvysfghcHIiwoGWIXhIOq8EIImJjwF5tl/g8sAw7QcJRlyjAnAdY9qJxVjwCyAkqZwfEb9uMw7UncOnKZfz86y989F+/hu/bL6KsrAxr1qyxgWtEUZwy2o91oowj+oewUWMmktSLoFWo8WnaFlz6qRtT2cjICM40n8H8+fMZ9LpGo1n1NJg3Ed3OdloOmPNx3/glNqv8YTdDi0MVh/G8dvPmTSQkJDDoLYVCsWwyTCCiHYFqT9yevQMw56JYuxIOGnscOVGOF7WxsTFs2LCBQX8gIpfHga4aQfqtaGYE34VXXknEDBKRWZiDl7WhoSEsXbqUQfcTkdIGfPtVSY8/eXT5WCdbMSd0MUbuj2I67Pz589BoNAzqbwNmrrV/A/ApwVXPRNgTobr1DKbTIiMjGTBLkiQeZZFJckSbYQOOaN+DaZ4V3zY2oLi4GK2trSgvL0dFRQU6Ozuxe/dunDx5EkVFRUhLS+Nr2H87d+7ko6qqCoWFhaipqUFLSwv27NmDO3fuoLKyElqtdlCr1bqRLCj36hQyjLITPEiLz75IwdmzZ+Hs7MyTbjQa4e/vj/T0dF5jycnJMBgMfM7yExcXZ6s9bNy4Efb29lixYgVSUlL4s97eXoyOjsLHxweiKHqTSEJBgsMi5OtX8gVFJQf4DrNYLAgMDIRer8fcuXMRHBzMXkBJSQlMJhOCgoJw6tQp7pDlKDw8HDdu3IDZbIaXlxcCAgI4nCnDbKI2w5mk30RqrBg3ZcGf1Mg7WsIXREVFwdXVlUnBnatUKg6tq6uDp6cn3NzckJqainv37sHR0RExMTH8PavVClmW+Ue4uLigvb2dPw8NDWXAeAbcQgIhfWYo3iQtckr38wW7du3iETPnTCI237RpE9ra2rikTE6Wp4GBATg5OSE6OppL5+vry/9bv349B3d0dHB/ISEhzMcHDGjRCeoHrioH7jQn92H91dbW8t8LFy7E9u3b+by0tBR9fX2Pcubt7Y36+no+Zyqw1saUYFFOFP0jSdkzIlrAgGq9qKlcpjbCKjrjtbcWYOjWbd6emGTnzp3jX8l25eDgIIaHh5GRkYGkpCTk5uaiv78f2dnZOH78OMbHx5GXl4djx46hqamJ71zmp6urC+7u7uOyLHvZajF4juSKz+VFcCY1Lnb9OK11yBRSKpWn1Wq1xgYUiejActkCb9IgM/+raYMxRVhaJq4lT5ikFMQ6vcLuH5PbK+jp650WYFZWFgRBuCyKout/HVNmgYROlmy269jXvYw1NzdDp9Ox6NZNBmknauQoEfUS0QMGXb16Ne7evftCsAsXLsDDw4PBsifDZhBRo22rTx4RERHo7u5+Llh1dbUNdmjivH3C5j0NZhusq2RmZqKnp+eZoIaGBsTGxrJ3/iai1KddL54ZIeuftjnrIvHx8bzu9u3bx0+GgoICJCYmIiwsjOWLpeKgJElBU12gbDmsmsjhs8Bj7P5DRH8Q0WUiaiGir4koVqVS+f/f6yGrw8XskJyI9joR/f74EATBNr/KLslE9B0R1bPmT0RbWdvSaDTOU4H+Bc/z92HCspq3AAAAAElFTkSuQmCC',
                supported: true,
              },
              ETH: {
                symbol: 'ETH',
                decimals: 18,
                address: '',
              },
            },
          },
        },
        {
          type: 'risks',
          status: 'Calculated',
          data: {
            totalScore: 51,
            score: {
              sof: [
                {
                  name: 'unknown smart contract',
                  amount: 1.4109711103888875e24,
                  price: 15.91732136558043,
                  score: 50,
                  share: 1,
                  generalShare: 1,
                  deepDepthShare: 0,
                  depth: 1,
                },
              ],
              uof: [
                {
                  name: 'MEV bot',
                  amount: 1.4109711103888875e24,
                  price: 15.91732136558043,
                  score: 50,
                  share: 1,
                  generalShare: 1,
                  deepDepthShare: 0,
                  depth: 1,
                },
              ],
            },
            owner: {
              status: 'Not Identified',
              type: {},
              tags: [],
              meta: [],
              clusterData: {},
            },
          },
        },
        {
          type: 'tier2',
          status: 'TIER2 Found',
          data: {
            labelBarsSof: [
              {
                directTx:
                  '0xae31caf3547bc1eb1210d7909d34807dd2d928ae2215952c687ffbe8a61a2bef',
                directionUp: false,
                token: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                funds: {
                  name: 'unknown smart contract',
                  score: 50,
                  default: true,
                  type: 'unknown smart contract',
                },
                owner: 'unknown smart contract',
                depth: 1,
                amount: 1.4109711103888875e24,
                amountCur: 15.91732136558043,
                currency: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                tx_hash:
                  '0xae31caf3547bc1eb1210d7909d34807dd2d928ae2215952c687ffbe8a61a2bef',
                address: '0xeeeeee9ec4769a09a76a83c7bc42b185872860ee',
                directStamp: 1748901479,
                timestamp: 1748901479,
                listType: 'Unknown sources',
                share: 1,
                amountDec: 1410971.1103888876,
                deepDepthShare: 0,
                generalShare: 1,
                price: null,
                originalShare: 1,
              },
            ],
            labelBarsUof: [
              {
                directTx:
                  '0xa8ea1efb3e695f7304ee2678f669d20921bec8437a2513b05cb800b2b0508e77',
                directionUp: true,
                token: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                funds: {
                  name: 'MEV bot',
                  score: 50,
                  id: '637e329fca61b25b03cf5037',
                  type: 'MEV bot',
                },
                owner: 'MEV Bot 0x74d631',
                entity: '682af8b01a39a702203497b6',
                depth: 1,
                amount: 1.4109711103888875e24,
                amountCur: 15.91732136558043,
                currency: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                tx_hash:
                  '0xa8ea1efb3e695f7304ee2678f669d20921bec8437a2513b05cb800b2b0508e77',
                address: '0x74de5d4fcbf63e00296fd95d33236b9794016631',
                inputAmounts: [
                  {
                    amount: 1.4109711103888875e24,
                    currency: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                    amountCur: 15.91732136558043,
                    amountDec: 1410971.1103888876,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 5498638962952396,
                    amountCur: 21.247011090742497,
                    amountDec: 0.005498638962952396,
                  },
                ],
                directStamp: 1748906735,
                timestamp: 1748906735,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Swap',
                share: 1,
                amountDec: 1410971.1103888876,
                deepDepthShare: 0,
                generalShare: 1,
                price: null,
                originalShare: 1,
              },
            ],
            evaluatedSofTxs: 1,
            evaluatedUofTxs: 1,
            currencies: {},
            sources: [],
          },
        },
      ],
      createdAt: '2025-07-31T08:34:12.748Z',
    },
  },
  tier2_0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2: {
    success: true,
    data: {
      coin: 'eth',
      address: '0x44473b3356906d6ae34299ddf53020f131fa0835',
      decimals: 18,
      parts: [
        {
          type: 'address',
          status: 'Identified',
          data: {
            addressType: 'address',
            balance: 0,
            price: null,
            priceTimestamp: 1753886761013,
            numberOfTxs: 42,
            numberOfTxsBySources: 40,
            firstSeen: 1665031331,
            lastSeen: 1748868131,
            totalTxReceived: 19,
            totalTxSent: 23,
            tokens: {
              '': {
                address: '',
                symbol: 'ETH',
                decimals: 18,
                supported: true,
                unknownContract: true,
              },
              '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73': {
                address: '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73',
                name: 'Virtual Protocol',
                symbol: 'VIRTUAL',
                decimals: 18,
                supported: true,
              },
              '0x6982508145454ce325ddbe47a25d4ec3d2311933': {
                address: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                name: 'Pepe',
                symbol: 'PEPE',
                decimals: 18,
                icon: 'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAACKFBMVEVek0tdkkpflEthmE1moFFglUxjm05imU5lnU9lnlBHcThGbjdnoVJknE9KdjtFbDdoo1NZjEZBZjRNeT1rp1VVhUNTgUJOfD1CaDRRgEBQfT9KdDpJczpckEk2Vio0UyhYikZXiEVWh0RMeDw9YTAxTiYrRSGIJhhtqldgl0xUhEJEgkFEazY/ZDI5XC04WSwnQR1urVhaq1ZdqVVqpVRWolFbj0dJjEU8dztXbDZDazQ7Xi8zUSlYPiEjOxtaLBmKIxdsEw1eEwxpEgx1tl1YU1pvrllkqVZgp1RZp1NfpFJinE9OTk9Tm05OnE1NgD47ND5PaTVEdjM+aDNVZDM6UjFeWS8tXi47aCpUUipaTikxUCYzVyUuSCR4QyQxXyAcFx4oSB0sVxx0MRwfKRwmShkkRhgcPBCMFRBLGQ9kEAx/Dgx2DQsNMQL////+9f/18PfW2NXI0MW/wL+mpaeZqZOUlZOJhYqDlXxwaXN0gW9ud2xzjmppbWdkXWZ4u19nsVlxsFllh1hgrVdcclRFnU5Xlk1ZlUxRlUtZfUtOk0pRaElKh0RKZUA/fT9PiDlEczlTcDlCXTgybjVHfDNCcDFcXjFjXTFJWCwwOSw8cig1XScyVCZGTCZ/QSVDPiBxNR5pMx5sNB14MBwcHBw4NBqCKhqUKRqeKBogMRl0KRiaIhdfJRVlIxV/IRVkHhJ3GBFXGxCGFRBQFw8RHA0GAAwLGQYBAQHwHWUjAAACo0lEQVQ4y3XSVXPbQBQFYK1WjJZkZm7imMLMzMzMXGZmZmZm5v69OkrHqev0vuhhvzl7NWeR+KA4ivx/AMHnSDaeACQPeT5ZAsolWgUrq9c6WQ+jQBL8c07rZR2CohLDCnpJZ2Xw1ERA2GSc5qArJ9UnafmsIyYLnRCBUrJJA5mQKFrCYULPWExGif9bYIwVI4NeCZIIFPyyIljsdo6IC4CZgxQOdJosGsO0VYolneYIs7C2KCnJqRCgGslsUgys6HboCYijwZCWAH8CRBMGAKZ3+BwOe9TPFBVWIXa/z19ogyqg9CIGEMwQZe9el3J0E8t9FiczKN4YLWE1KuBFHYEgnFDSvWPv1Pc3+3ZeHe8YmvrZfWZWR6nAzHIgdhGZKu9u+1F9cNfGLctHm8ba9mw6MMqpwOgi1S9NTkz77jzfvnnbzP7qX2NNW4938OqBRaMuy5F8wGq6Fz13YUZuHfcOGWf7UoAKcFyt2uCEFDTr0EvT9zG6wE4bolZstVR0xZFob54WIhTmYlmMQFMYxqb1dKrZq4jofPGgtSWjQShQKBLEUt3wcPv8KRgHjXnlc/PFt7ouN9dn12fW1dXWHjvx/klzHCB4Q/uXpa/llR9Kiwd6bnblX8nPL/12EltrFOCZuf2flja8/Pi5vLJyoaKiYmGx9CyZ8Kg0GWn9b+fevX61ITZlZWWLPdk4kiCQGLk9UPz08eSzyZGRh48uatUbEgiWmd2Sm5t2/nRe77W0lYqSB8Ubtek1ggytkdU3lSygoERCNW7CKUv0eoJjjBE/6/GVME6jaz1BKSwWdniLht0pNtlGJgOgMSrooJdNCZjS3eJ6e+KokYoMHwrECqUVM5WckAUcFFdQWKQxBA0eAUeTfsIsih6eM4SMYb2XEgLwN2WMcSPeECwqAAAAAElFTkSuQmCC',
                supported: true,
              },
              '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2': {
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                name: 'Wrapped Ether',
                symbol: 'WETH',
                decimals: 18,
                icon: 'iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAFjklEQVR42q2We0xURxTGz727d/eyLC7IIiwU2QdQtrVG8FF5VKVVMDS1CJaikLap0RhpsIAiVYRqKC8DBlRqUogvHv4hr4ogGgkhpo2hVMAKxJJKLWltoxI0sSDUr5mRNUqqVOUkk8zenXt+93xnzpkhmsIUgqAVSTAT0RIi+oSI1hJRDBEFSIJitpJEBU2HKQTBjYjiiOi0QeGA1yUXhMomRNj54l3ZFyGq2fBT6ocVJJQQ0XJJUEgvw1tFRB1zVLOwTReCJtePAGMOYCnEX4ZtaNStRYH8Dj4UfGEgNVREUJJwgoj8XgSWphFU2KoLwTXPZMD7IGDJQdnM97GEnOBOEvysfghcHIiwoGWIXhIOq8EIImJjwF5tl/g8sAw7QcJRlyjAnAdY9qJxVjwCyAkqZwfEb9uMw7UncOnKZfz86y989F+/hu/bL6KsrAxr1qyxgWtEUZwy2o91oowj+oewUWMmktSLoFWo8WnaFlz6qRtT2cjICM40n8H8+fMZ9LpGo1n1NJg3Ed3OdloOmPNx3/glNqv8YTdDi0MVh/G8dvPmTSQkJDDoLYVCsWwyTCCiHYFqT9yevQMw56JYuxIOGnscOVGOF7WxsTFs2LCBQX8gIpfHga4aQfqtaGYE34VXXknEDBKRWZiDl7WhoSEsXbqUQfcTkdIGfPtVSY8/eXT5WCdbMSd0MUbuj2I67Pz589BoNAzqbwNmrrV/A/ApwVXPRNgTobr1DKbTIiMjGTBLkiQeZZFJckSbYQOOaN+DaZ4V3zY2oLi4GK2trSgvL0dFRQU6Ozuxe/dunDx5EkVFRUhLS+Nr2H87d+7ko6qqCoWFhaipqUFLSwv27NmDO3fuoLKyElqtdlCr1bqRLCj36hQyjLITPEiLz75IwdmzZ+Hs7MyTbjQa4e/vj/T0dF5jycnJMBgMfM7yExcXZ6s9bNy4Efb29lixYgVSUlL4s97eXoyOjsLHxweiKHqTSEJBgsMi5OtX8gVFJQf4DrNYLAgMDIRer8fcuXMRHBzMXkBJSQlMJhOCgoJw6tQp7pDlKDw8HDdu3IDZbIaXlxcCAgI4nCnDbKI2w5mk30RqrBg3ZcGf1Mg7WsIXREVFwdXVlUnBnatUKg6tq6uDp6cn3NzckJqainv37sHR0RExMTH8PavVClmW+Ue4uLigvb2dPw8NDWXAeAbcQgIhfWYo3iQtckr38wW7du3iETPnTCI237RpE9ra2rikTE6Wp4GBATg5OSE6OppL5+vry/9bv349B3d0dHB/ISEhzMcHDGjRCeoHrioH7jQn92H91dbW8t8LFy7E9u3b+by0tBR9fX2Pcubt7Y36+no+Zyqw1saUYFFOFP0jSdkzIlrAgGq9qKlcpjbCKjrjtbcWYOjWbd6emGTnzp3jX8l25eDgIIaHh5GRkYGkpCTk5uaiv78f2dnZOH78OMbHx5GXl4djx46hqamJ71zmp6urC+7u7uOyLHvZajF4juSKz+VFcCY1Lnb9OK11yBRSKpWn1Wq1xgYUiejActkCb9IgM/+raYMxRVhaJq4lT5ikFMQ6vcLuH5PbK+jp650WYFZWFgRBuCyKout/HVNmgYROlmy269jXvYw1NzdDp9Ox6NZNBmknauQoEfUS0QMGXb16Ne7evftCsAsXLsDDw4PBsifDZhBRo22rTx4RERHo7u5+Llh1dbUNdmjivH3C5j0NZhusq2RmZqKnp+eZoIaGBsTGxrJ3/iai1KddL54ZIeuftjnrIvHx8bzu9u3bx0+GgoICJCYmIiwsjOWLpeKgJElBU12gbDmsmsjhs8Bj7P5DRH8Q0WUiaiGir4koVqVS+f/f6yGrw8XskJyI9joR/f74EATBNr/KLslE9B0R1bPmT0RbWdvSaDTOU4H+Bc/z92HCspq3AAAAAElFTkSuQmCC',
                supported: true,
              },
              ETH: {
                symbol: 'ETH',
                decimals: 18,
                address: '',
              },
            },
          },
        },
        {
          type: 'tier2',
          status: 'TIER2 Found',
          data: {
            labelBarsSof: [
              {
                directTx:
                  '0x62b11c2c7c573915648cd7943aa1c310e32303b74de90e6adf023110e22f0d28',
                directionUp: false,
                token: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                funds: {
                  name: 'wrapped token',
                  score: 10,
                  id: '65ea5850e72f728fbc45010e',
                  type: 'wrapped token',
                },
                owner: 'Wrapped Ether',
                entity: '682afaa11a39a7022034af45',
                depth: 1,
                amount: 1626231090348281000,
                amountCur: 6160.673675182115,
                currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                tx_hash:
                  '0x62b11c2c7c573915648cd7943aa1c310e32303b74de90e6adf023110e22f0d28',
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                inputAmounts: [
                  {
                    amount: 230000000000000000,
                    amountCur: 888.7312994717673,
                    amountDec: 0.23,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 230000000000000000,
                    currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                    amountCur: 871.3121730986122,
                    amountDec: 0.23,
                  },
                ],
                directStamp: 1744070159,
                timestamp: 1744070159,
                listType: 'Swap',
                share: 0.892,
                amountDec: 0.23,
                deepDepthShare: 0.6149521455666106,
                generalShare: 0.2771478478079477,
                price: null,
                originalShare: 0.8920999933745583,
              },
              {
                directTx:
                  '0x8ada37a39d79fb899767bcc7420ecc055577dd4f815bda2927b716f33049b400',
                directionUp: false,
                token: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                funds: {
                  name: 'DEX',
                  score: 50,
                  id: '66049d278d004d1f88b515cd',
                  type: 'DEX',
                },
                owner: 'Mimic.fi',
                entity: '682af8b31a39a702203499ba',
                depth: 3,
                amount: 174600000000000000,
                amountCur: 661.4395887957292,
                currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                tx_hash:
                  '0x5c1e8a403d44e66f64e2d8f20874d39f71f11af5e803411250effd85501d2594',
                address: '0xa7ca2c8673bcfa5a26d8ceec2887f2cc2b0db22a',
                inputAmounts: [
                  {
                    amount: 200000000000000000,
                    amountCur: 772.8098256276238,
                    amountDec: 0.2,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 200000000000000000,
                    currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                    amountCur: 757.6627592161846,
                    amountDec: 0.2,
                  },
                ],
                directStamp: 1686905879,
                timestamp: 1686511955,
                listType: 'Swap',
                share: 0.0957,
                amountDec: 0.1746,
                deepDepthShare: 0.09578015066102291,
                generalShare: 0,
                price: null,
                originalShare: 0.09578015066102291,
              },
              {
                directTx:
                  '0x419d55778ef93823f4043cb7517d60ea7d573807ff2cdd1a358ec19d7044dea5',
                directionUp: false,
                token: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                funds: {
                  name: 'unknown smart contract',
                  score: 50,
                  default: true,
                  type: 'unknown smart contract',
                },
                owner: 'unknown smart contract',
                depth: 1,
                amount: 11669530043666566,
                amountCur: 44.20784165820287,
                currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                tx_hash:
                  '0x419d55778ef93823f4043cb7517d60ea7d573807ff2cdd1a358ec19d7044dea5',
                address: '0xeeeeee9ec4769a09a76a83c7bc42b185872860ee',
                directStamp: 1748805719,
                timestamp: 1748805719,
                listType: 'Unknown sources',
                share: 0.0064,
                amountDec: 0.011669530043666566,
                deepDepthShare: 0,
                generalShare: 0.006401542644477187,
                price: null,
                originalShare: 0.006401542644477187,
              },
              {
                directTx:
                  '0xaf2a326edad7dee511d80a1f9f6c5863c3aed372faef764b298125a0228cca59',
                directionUp: false,
                token: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                funds: {
                  name: 'MEV bot',
                  score: 50,
                  id: '637e329fca61b25b03cf5037',
                  type: 'MEV bot',
                },
                owner: 'MEV Bot 0x74d631',
                entity: '682af8b01a39a702203497b6',
                depth: 1,
                amount: 10424054449395040,
                amountCur: 39.48958928174196,
                currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                tx_hash:
                  '0xaf2a326edad7dee511d80a1f9f6c5863c3aed372faef764b298125a0228cca59',
                address: '0x74de5d4fcbf63e00296fd95d33236b9794016631',
                inputAmounts: [
                  {
                    amount: 3.987515573812553e28,
                    currency: '0x0eef64c9c064f97a1feee3d0c529c517fe1b029b',
                  },
                ],
                outputAmounts: [
                  {
                    amount: 10424054449395040,
                    currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                    amountCur: 39.48958928174196,
                    amountDec: 0.01042405444939504,
                  },
                ],
                directStamp: 1689139355,
                timestamp: 1689139355,
                listType: 'Swap',
                share: 0.0057,
                amountDec: 0.01042405444939504,
                deepDepthShare: 0,
                generalShare: 0.0057183133199413694,
                price: null,
                originalShare: 0.0057183133199413694,
              },
            ],
            labelBarsUof: [
              {
                directTx:
                  '0x459e9b02296996aa0f6cb980d2f9796192eafda7da6be750bf8ec1f1b5b51454',
                directionUp: true,
                token: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                funds: {
                  name: 'wrapped token',
                  score: 10,
                  id: '65ea5850e72f728fbc45010e',
                  type: 'wrapped token',
                },
                owner: 'Wrapped Ether',
                entity: '682afaa11a39a7022034af45',
                depth: 1,
                amount: 1816196621067691800,
                amountCur: 6880.322715986292,
                currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                tx_hash:
                  '0x459e9b02296996aa0f6cb980d2f9796192eafda7da6be750bf8ec1f1b5b51454',
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                inputAmounts: [
                  {
                    amount: 230000000000000000,
                    currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                    amountCur: 871.3121730986122,
                    amountDec: 0.23,
                  },
                ],
                outputAmounts: [
                  {
                    amount: 230000000000000000,
                    amountCur: 888.7312994717673,
                    amountDec: 0.23,
                  },
                ],
                directStamp: 1744733507,
                timestamp: 1744733507,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Swap',
                share: 0.9963,
                amountDec: 0.23,
                deepDepthShare: 0.0070735682414508234,
                generalShare: 0.9892356299023309,
                price: null,
                originalShare: 0.9963091981437817,
              },
              {
                directTx:
                  '0xafcc5e6f889884b7c3bbc521a81d76662d09b0f0da9d8f7e6f9fdfedb9954ea1',
                directionUp: true,
                token: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                funds: {
                  name: 'unknown wallet / otc / service',
                  score: 50,
                  default: true,
                  type: 'unknown wallet / otc / service',
                },
                owner: 'unknown wallet / otc / service',
                depth: 1,
                amount: 5020553773650667,
                amountCur: 19.01943312468696,
                currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                tx_hash:
                  '0xafcc5e6f889884b7c3bbc521a81d76662d09b0f0da9d8f7e6f9fdfedb9954ea1',
                address: '0xf70da97812cb96acdf810712aa562db8dfa3dbef',
                directStamp: 1748864423,
                timestamp: 1748864423,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Unknown sources',
                share: 0.0027,
                amountDec: 0.003897447957151767,
                deepDepthShare: 0,
                generalShare: 0.0027541202568271937,
                price: null,
                originalShare: 0.0027541202568271937,
              },
              {
                directTx:
                  '0xdef659d27b455f43354a411c2f09852e0b96a5e4f98128550d44013e853e7765',
                directionUp: true,
                token: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                funds: {
                  name: 'NFT marketplace',
                  score: 40,
                  id: '6604a0ed8d004d1f88b8a4b2',
                  type: 'NFT marketplace',
                },
                owner: 'OpenSea',
                entity: '6603e89da6a313bd816dbb0b',
                depth: 1,
                amount: 1707500000000000,
                amountCur: 6.468545806808176,
                currency: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                tx_hash:
                  '0xdef659d27b455f43354a411c2f09852e0b96a5e4f98128550d44013e853e7765',
                address: '0x0000a26b00c1f0df003000390027140000faa719',
                directStamp: 1665031331,
                timestamp: 1665031331,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Known sources',
                share: 0.0009,
                amountDec: 0.0017075,
                deepDepthShare: 0,
                generalShare: 0.0009366815993911605,
                price: null,
                originalShare: 0.0009366815993911605,
              },
            ],
            evaluatedSofTxs: 19,
            evaluatedUofTxs: 22,
            currencies: {},
            sources: [],
          },
        },
        {
          type: 'risks',
          status: 'Calculated',
          data: {
            totalScore: 51,
            score: {
              sof: [
                {
                  name: 'MEV bot',
                  amount: 10424054449395040,
                  price: 39.48958928174196,
                  score: 50,
                  share: 0.0057183133199413694,
                  generalShare: 0.0057183133199413694,
                  deepDepthShare: 0,
                  depth: 1,
                },
                {
                  name: 'unknown smart contract',
                  amount: 11669530043666566,
                  price: 44.20784165820287,
                  score: 50,
                  share: 0.006401542644477187,
                  generalShare: 0.006401542644477187,
                  deepDepthShare: 0,
                  depth: 1,
                },
                {
                  name: 'DEX',
                  amount: 174600000000000000,
                  price: 661.4395887957292,
                  score: 50,
                  share: 0.09578015066102291,
                  generalShare: 0,
                  deepDepthShare: 0.09578015066102291,
                  depth: 3,
                },
              ],
              uof: [
                {
                  name: 'unknown wallet / otc / service',
                  amount: 5020553773650667,
                  price: 19.01943312468696,
                  score: 50,
                  share: 0.0027541202568271937,
                  generalShare: 0.0027541202568271937,
                  deepDepthShare: 0,
                  depth: 1,
                },
                {
                  name: 'NFT marketplace',
                  amount: 1707500000000000,
                  price: 6.468545806808176,
                  score: 40,
                  share: 0.0009366815993911605,
                  generalShare: 0.0009366815993911605,
                  deepDepthShare: 0,
                  depth: 1,
                },
              ],
            },
            owner: {
              status: 'Not Identified',
              type: {},
              tags: [],
              meta: [],
              clusterData: {},
            },
          },
        },
      ],
      createdAt: '2025-07-31T08:34:12.748Z',
    },
  },
  tier2_0x44ff8620b8ca30902395a7bd3f2407e1a091bf73: {
    success: true,
    data: {
      coin: 'eth',
      address: '0x44473b3356906d6ae34299ddf53020f131fa0835',
      decimals: 18,
      parts: [
        {
          type: 'address',
          status: 'Identified',
          data: {
            addressType: 'address',
            balance: 6.566e-15,
            price: 8.746369325772732e-15,
            priceTimestamp: 1753886768642,
            numberOfTxs: 2,
            numberOfTxsBySources: 2,
            firstSeen: 1750096739,
            lastSeen: 1750096823,
            totalTxReceived: 1,
            totalTxSent: 1,
            tokens: {
              '': {
                address: '',
                symbol: 'ETH',
                decimals: 18,
                supported: true,
                unknownContract: true,
              },
              '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73': {
                address: '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73',
                name: 'Virtual Protocol',
                symbol: 'VIRTUAL',
                decimals: 18,
                supported: true,
              },
              '0x6982508145454ce325ddbe47a25d4ec3d2311933': {
                address: '0x6982508145454ce325ddbe47a25d4ec3d2311933',
                name: 'Pepe',
                symbol: 'PEPE',
                decimals: 18,
                icon: 'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAACKFBMVEVek0tdkkpflEthmE1moFFglUxjm05imU5lnU9lnlBHcThGbjdnoVJknE9KdjtFbDdoo1NZjEZBZjRNeT1rp1VVhUNTgUJOfD1CaDRRgEBQfT9KdDpJczpckEk2Vio0UyhYikZXiEVWh0RMeDw9YTAxTiYrRSGIJhhtqldgl0xUhEJEgkFEazY/ZDI5XC04WSwnQR1urVhaq1ZdqVVqpVRWolFbj0dJjEU8dztXbDZDazQ7Xi8zUSlYPiEjOxtaLBmKIxdsEw1eEwxpEgx1tl1YU1pvrllkqVZgp1RZp1NfpFJinE9OTk9Tm05OnE1NgD47ND5PaTVEdjM+aDNVZDM6UjFeWS8tXi47aCpUUipaTikxUCYzVyUuSCR4QyQxXyAcFx4oSB0sVxx0MRwfKRwmShkkRhgcPBCMFRBLGQ9kEAx/Dgx2DQsNMQL////+9f/18PfW2NXI0MW/wL+mpaeZqZOUlZOJhYqDlXxwaXN0gW9ud2xzjmppbWdkXWZ4u19nsVlxsFllh1hgrVdcclRFnU5Xlk1ZlUxRlUtZfUtOk0pRaElKh0RKZUA/fT9PiDlEczlTcDlCXTgybjVHfDNCcDFcXjFjXTFJWCwwOSw8cig1XScyVCZGTCZ/QSVDPiBxNR5pMx5sNB14MBwcHBw4NBqCKhqUKRqeKBogMRl0KRiaIhdfJRVlIxV/IRVkHhJ3GBFXGxCGFRBQFw8RHA0GAAwLGQYBAQHwHWUjAAACo0lEQVQ4y3XSVXPbQBQFYK1WjJZkZm7imMLMzMzMXGZmZmZm5v69OkrHqev0vuhhvzl7NWeR+KA4ivx/AMHnSDaeACQPeT5ZAsolWgUrq9c6WQ+jQBL8c07rZR2CohLDCnpJZ2Xw1ERA2GSc5qArJ9UnafmsIyYLnRCBUrJJA5mQKFrCYULPWExGif9bYIwVI4NeCZIIFPyyIljsdo6IC4CZgxQOdJosGsO0VYolneYIs7C2KCnJqRCgGslsUgys6HboCYijwZCWAH8CRBMGAKZ3+BwOe9TPFBVWIXa/z19ogyqg9CIGEMwQZe9el3J0E8t9FiczKN4YLWE1KuBFHYEgnFDSvWPv1Pc3+3ZeHe8YmvrZfWZWR6nAzHIgdhGZKu9u+1F9cNfGLctHm8ba9mw6MMqpwOgi1S9NTkz77jzfvnnbzP7qX2NNW4938OqBRaMuy5F8wGq6Fz13YUZuHfcOGWf7UoAKcFyt2uCEFDTr0EvT9zG6wE4bolZstVR0xZFob54WIhTmYlmMQFMYxqb1dKrZq4jofPGgtSWjQShQKBLEUt3wcPv8KRgHjXnlc/PFt7ouN9dn12fW1dXWHjvx/klzHCB4Q/uXpa/llR9Kiwd6bnblX8nPL/12EltrFOCZuf2flja8/Pi5vLJyoaKiYmGx9CyZ8Kg0GWn9b+fevX61ITZlZWWLPdk4kiCQGLk9UPz08eSzyZGRh48uatUbEgiWmd2Sm5t2/nRe77W0lYqSB8Ubtek1ggytkdU3lSygoERCNW7CKUv0eoJjjBE/6/GVME6jaz1BKSwWdniLht0pNtlGJgOgMSrooJdNCZjS3eJ6e+KokYoMHwrECqUVM5WckAUcFFdQWKQxBA0eAUeTfsIsih6eM4SMYb2XEgLwN2WMcSPeECwqAAAAAElFTkSuQmCC',
                supported: true,
              },
              '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2': {
                address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
                name: 'Wrapped Ether',
                symbol: 'WETH',
                decimals: 18,
                icon: 'iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAFjklEQVR42q2We0xURxTGz727d/eyLC7IIiwU2QdQtrVG8FF5VKVVMDS1CJaikLap0RhpsIAiVYRqKC8DBlRqUogvHv4hr4ogGgkhpo2hVMAKxJJKLWltoxI0sSDUr5mRNUqqVOUkk8zenXt+93xnzpkhmsIUgqAVSTAT0RIi+oSI1hJRDBEFSIJitpJEBU2HKQTBjYjiiOi0QeGA1yUXhMomRNj54l3ZFyGq2fBT6ocVJJQQ0XJJUEgvw1tFRB1zVLOwTReCJtePAGMOYCnEX4ZtaNStRYH8Dj4UfGEgNVREUJJwgoj8XgSWphFU2KoLwTXPZMD7IGDJQdnM97GEnOBOEvysfghcHIiwoGWIXhIOq8EIImJjwF5tl/g8sAw7QcJRlyjAnAdY9qJxVjwCyAkqZwfEb9uMw7UncOnKZfz86y989F+/hu/bL6KsrAxr1qyxgWtEUZwy2o91oowj+oewUWMmktSLoFWo8WnaFlz6qRtT2cjICM40n8H8+fMZ9LpGo1n1NJg3Ed3OdloOmPNx3/glNqv8YTdDi0MVh/G8dvPmTSQkJDDoLYVCsWwyTCCiHYFqT9yevQMw56JYuxIOGnscOVGOF7WxsTFs2LCBQX8gIpfHga4aQfqtaGYE34VXXknEDBKRWZiDl7WhoSEsXbqUQfcTkdIGfPtVSY8/eXT5WCdbMSd0MUbuj2I67Pz589BoNAzqbwNmrrV/A/ApwVXPRNgTobr1DKbTIiMjGTBLkiQeZZFJckSbYQOOaN+DaZ4V3zY2oLi4GK2trSgvL0dFRQU6Ozuxe/dunDx5EkVFRUhLS+Nr2H87d+7ko6qqCoWFhaipqUFLSwv27NmDO3fuoLKyElqtdlCr1bqRLCj36hQyjLITPEiLz75IwdmzZ+Hs7MyTbjQa4e/vj/T0dF5jycnJMBgMfM7yExcXZ6s9bNy4Efb29lixYgVSUlL4s97eXoyOjsLHxweiKHqTSEJBgsMi5OtX8gVFJQf4DrNYLAgMDIRer8fcuXMRHBzMXkBJSQlMJhOCgoJw6tQp7pDlKDw8HDdu3IDZbIaXlxcCAgI4nCnDbKI2w5mk30RqrBg3ZcGf1Mg7WsIXREVFwdXVlUnBnatUKg6tq6uDp6cn3NzckJqainv37sHR0RExMTH8PavVClmW+Ue4uLigvb2dPw8NDWXAeAbcQgIhfWYo3iQtckr38wW7du3iETPnTCI237RpE9ra2rikTE6Wp4GBATg5OSE6OppL5+vry/9bv349B3d0dHB/ISEhzMcHDGjRCeoHrioH7jQn92H91dbW8t8LFy7E9u3b+by0tBR9fX2Pcubt7Y36+no+Zyqw1saUYFFOFP0jSdkzIlrAgGq9qKlcpjbCKjrjtbcWYOjWbd6emGTnzp3jX8l25eDgIIaHh5GRkYGkpCTk5uaiv78f2dnZOH78OMbHx5GXl4djx46hqamJ71zmp6urC+7u7uOyLHvZajF4juSKz+VFcCY1Lnb9OK11yBRSKpWn1Wq1xgYUiejActkCb9IgM/+raYMxRVhaJq4lT5ikFMQ6vcLuH5PbK+jp650WYFZWFgRBuCyKout/HVNmgYROlmy269jXvYw1NzdDp9Ox6NZNBmknauQoEfUS0QMGXb16Ne7evftCsAsXLsDDw4PBsifDZhBRo22rTx4RERHo7u5+Llh1dbUNdmjivH3C5j0NZhusq2RmZqKnp+eZoIaGBsTGxrJ3/iai1KddL54ZIeuftjnrIvHx8bzu9u3bx0+GgoICJCYmIiwsjOWLpeKgJElBU12gbDmsmsjhs8Bj7P5DRH8Q0WUiaiGir4koVqVS+f/f6yGrw8XskJyI9joR/f74EATBNr/KLslE9B0R1bPmT0RbWdvSaDTOU4H+Bc/z92HCspq3AAAAAElFTkSuQmCC',
                supported: true,
              },
              ETH: {
                symbol: 'ETH',
                decimals: 18,
                address: '',
              },
            },
          },
        },
        {
          type: 'tier2',
          status: 'TIER2 Found',
          data: {
            labelBarsSof: [
              {
                directTx:
                  '0xd66a920d4923f55ec361232ce204cb07d6bca33644882bd3264e5d7d1de9385b',
                directionUp: false,
                token: '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73',
                funds: {
                  name: 'unknown smart contract',
                  score: 50,
                  default: true,
                  type: 'unknown smart contract',
                },
                owner: 'unknown smart contract',
                depth: 1,
                amount: 25097834358612627000,
                amountCur: 33.4320634446382,
                currency: '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73',
                tx_hash:
                  '0xd66a920d4923f55ec361232ce204cb07d6bca33644882bd3264e5d7d1de9385b',
                address: '0xeeeeee9ec4769a09a76a83c7bc42b185872860ee',
                directStamp: 1750096739,
                timestamp: 1750096739,
                listType: 'Unknown sources',
                share: 1,
                amountDec: 25.097834358612626,
                deepDepthShare: 0,
                generalShare: 1,
                price: null,
                originalShare: 1,
              },
            ],
            labelBarsUof: [
              {
                directTx:
                  '0x5d919d5a77977ea5a8ab1bd5e4041c1a9df48c23ea7c0f4f10ce640994d052ec',
                directionUp: true,
                token: '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73',
                funds: {
                  name: 'unknown smart contract',
                  score: 50,
                  default: true,
                  type: 'unknown smart contract',
                },
                owner: 'unknown smart contract',
                depth: 1,
                amount: 25097834358612620000,
                amountCur: 33.43206344463819,
                currency: '0x44ff8620b8ca30902395a7bd3f2407e1a091bf73',
                tx_hash:
                  '0x5d919d5a77977ea5a8ab1bd5e4041c1a9df48c23ea7c0f4f10ce640994d052ec',
                address: '0xeeeeee9ec4769a09a76a83c7bc42b185872860ee',
                directStamp: 1750096823,
                timestamp: 1750096823,
                'address-1': '0x44473b3356906d6ae34299ddf53020f131fa0835',
                listType: 'Unknown sources',
                share: 1,
                amountDec: 25.09783435861262,
                deepDepthShare: 0,
                generalShare: 1,
                price: null,
                originalShare: 1,
              },
            ],
            evaluatedSofTxs: 1,
            evaluatedUofTxs: 1,
            currencies: {},
            sources: [],
          },
        },
        {
          type: 'risks',
          status: 'Calculated',
          data: {
            totalScore: 50,
            score: {
              sof: [
                {
                  name: 'unknown smart contract',
                  amount: 25097834358612627000,
                  price: 33.4320634446382,
                  score: 50,
                  share: 1,
                  generalShare: 1,
                  deepDepthShare: 0,
                  depth: 1,
                },
              ],
              uof: [
                {
                  name: 'unknown smart contract',
                  amount: 25097834358612620000,
                  price: 33.43206344463819,
                  score: 50,
                  share: 1,
                  generalShare: 1,
                  deepDepthShare: 0,
                  depth: 1,
                },
              ],
            },
            owner: {
              status: 'Not Identified',
              type: {},
              tags: [],
              meta: [],
              clusterData: {},
            },
          },
        },
      ],
      createdAt: '2025-07-31T08:34:12.748Z',
    },
  },
  full_default: {
    success: true,
    data: {
      coin: 'btc',
      address: 'bc1psvfdgmx94c4qq98ee6vvqqxhl2rnhac45tz4f9pg3jppr6aatgfqagzzqt',
      decimals: 8,
      parts: [
        {
          type: 'address',
          status: 'Identified',
          data: {
            balance: 440308,
            price: 518.5549012447509,
            priceTimestamp: 1753894097552,
            numberOfTxs: 392,
            numberOfTxsBySources: 229,
            firstSeen: 1685910809,
            lastSeen: 1753785243,
            totalReceived: 201326118,
            totalReceivedPrice: 237103.67569401205,
            totalReceivedPriceTimestamp: 1753894097552,
            totalSent: 200885810,
            totalSentPrice: 236585.12079276727,
            totalSentPriceTimestamp: 1753894097552,
            totalTxReceived: 385,
            totalTxSent: 185,
            tokens: {
              BTC: {
                symbol: 'BTC',
                decimals: 8,
                address: '',
              },
            },
          },
        },
        {
          type: 'full',
          status: 'All information',
          data: {
            entityBarsSof: [
              {
                directTx:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                  type: 'Suspended exchange',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 19277593.01064663,
                amountCur: 22703.403844291628,
                currency: '',
                tx_hash:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                address:
                  'bc1pc6plmlxyg2qjfe6wfv3jqgvdcsx47jh7j0p3tjkeg9ec6232lfeqe6cn6t',
                cluster: 3310,
                directStamp: 1700648582,
                timestamp: 1700648582,
                listType: 'Risky sources',
                share: 0.7773,
                amountDec: 0.11442705346663631,
                deepDepthShare: 0.005839533800254578,
                generalShare: 0.7715334280135744,
                price: null,
                originalShare: 0.777372961813829,
              },
              {
                directTx:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 4660671.890667313,
                amountCur: 5488.917421439482,
                currency: '',
                tx_hash:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1688055567,
                timestamp: 1688055567,
                listType: 'Known sources',
                share: 0.1879,
                amountDec: 0.03779283,
                deepDepthShare: 0.0026471035924894373,
                generalShare: 0.1852954631838479,
                price: null,
                originalShare: 0.18794256677633733,
              },
              {
                directTx:
                  '4e2d99e9dbb7e10777eea046908c7f6c32110004efafbd777b0b93cb581646ee',
                directionUp: false,
                token: '',
                funds: {
                  name: 'maximum depth reached',
                  score: 50,
                  id: '61e08b592536c394af97d392',
                  default: true,
                  type: 'maximum depth reached',
                },
                owner: 'maximum depth reached',
                depth: 20,
                amount: 246433.15057320998,
                amountCur: 290.226655111703,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1706898546,
                timestamp: 1706898546,
                listType: 'Unknown sources',
                share: 0.0099,
                amountDec: 0.002252637786560397,
                deepDepthShare: 0.00993746823290693,
                generalShare: 0,
                price: null,
                originalShare: 0.00993746823290693,
              },
              {
                directTx:
                  'bbe5e6b98f5bad1a37ca2d64564de9c584990e1f6fb18be09439100deab71517',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Online wallet',
                  score: 60,
                  id: '61767102820e13ff395ded5f',
                  type: 'Online wallet',
                },
                owner: 'Cash App',
                depth: 7,
                amount: 206059.86111385567,
                amountCur: 242.678649786973,
                currency: '',
                tx_hash:
                  '5be8f1b8c47989c0287cc106777f666a6bba6ef62e00098dfce2983a3e9bea81',
                address: 'bc1qxj0h49u5n7hmhl2cql3qytnukmrlhtz4xejqf9',
                cluster: 39540539,
                directStamp: 1708096725,
                timestamp: 1708096725,
                listType: 'Risky sources',
                share: 0.0083,
                amountDec: 0.00165685,
                deepDepthShare: 0.008309406908661112,
                generalShare: 0,
                price: null,
                originalShare: 0.008309406908661112,
              },
              {
                directTx:
                  '595b785ab319eadbce739cde1702f0384ee93dc427157283f06071ae7a0f5972',
                directionUp: false,
                token: '',
                funds: {
                  name: 'High-risk exchange',
                  score: 70,
                  id: '61766f47820e1372d85ded59',
                  type: 'High-risk exchange',
                },
                owner: 'ChangeNOW',
                entity: '6603e884a6a313bd816dba8e',
                depth: 1,
                amount: 154530,
                amountCur: 181.99144437382776,
                currency: '',
                tx_hash:
                  '595b785ab319eadbce739cde1702f0384ee93dc427157283f06071ae7a0f5972',
                address: '37jAAWEdJ9D9mXybRobcveioxSkt7Lkwog',
                directStamp: 1709390007,
                timestamp: 1709390007,
                listType: 'Risky sources',
                share: 0.0062,
                amountDec: 0.0015453,
                deepDepthShare: 0,
                generalShare: 0.006231454503824571,
                price: null,
                originalShare: 0.006231454503824571,
              },
              {
                directTx:
                  '01c455ee522365706353b8e03c7c6d60df1e9a05e63473a9f8b7c0bed52ab48e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Coinbase',
                depth: 5,
                amount: 94159.30377244143,
                amountCur: 110.89230372601195,
                currency: '',
                tx_hash:
                  'd055aa0b160a02b7ac3709cb3c24b9d561768bdc2e056451ade761369dce2617',
                address: null,
                cluster: 502154,
                directStamp: 1710707326,
                timestamp: 1710707326,
                listType: 'Known sources',
                share: 0.0037,
                amountDec: 0.0009415930377244143,
                deepDepthShare: 0.003796993577750379,
                generalShare: 0,
                price: null,
                originalShare: 0.003796993577750379,
              },
              {
                directTx:
                  '4e2d99e9dbb7e10777eea046908c7f6c32110004efafbd777b0b93cb581646ee',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                  type: 'unidentified service / exchange',
                },
                owner: 'unidentified service / exchange',
                depth: 3,
                amount: 50193.36023010462,
                amountCur: 59.11319566590684,
                currency: '',
                tx_hash:
                  '3efbc3e64d0fc1ab46581dac14b7446415eb782a645f494cbac10c93c51e66b9',
                address: null,
                cluster: 112109219,
                directStamp: 1706898546,
                timestamp: 1706898546,
                listType: 'Unknown sources',
                share: 0.002,
                amountDec: 0.0005019336023010461,
                deepDepthShare: 0.0020240577277420213,
                generalShare: 0,
                price: null,
                originalShare: 0.0020240577277420213,
              },
              {
                directTx:
                  '133cc96b54817ca8d5e0163702bb21635144272ed9f7316bb9ab9d469bbacacf',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'KuCoin.com',
                depth: 9,
                amount: 38095,
                amountCur: 44.864842253419845,
                currency: '',
                tx_hash:
                  'a4615286e5add9ef63ac9faff77543a4417c06f7ef679cc219332a1163a4f7c2',
                address: 'bc1qrt7rkpswpgmcag7txzf6ps9mvepwgndshqdx6d',
                cluster: 96386194,
                directStamp: 1709385674,
                timestamp: 1709385674,
                listType: 'Known sources',
                share: 0.0015,
                amountDec: 0.00038095,
                deepDepthShare: 0.0015361888262680192,
                generalShare: 0,
                price: null,
                originalShare: 0.0015361888262680192,
              },
              {
                directTx:
                  '01c455ee522365706353b8e03c7c6d60df1e9a05e63473a9f8b7c0bed52ab48e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Bitstamp',
                depth: 3,
                amount: 24082.0914697535,
                amountCur: 28.361707177396468,
                currency: '',
                tx_hash:
                  '511ad83d52d17cba4e995ccf6029fa38714ddf78af474fa8f06277920a88d07e',
                address: null,
                cluster: 67827685,
                directStamp: 1710707326,
                timestamp: 1710707326,
                listType: 'Known sources',
                share: 0.0009,
                amountDec: 0.00024082091469753502,
                deepDepthShare: 0.0009711153649822735,
                generalShare: 0,
                price: null,
                originalShare: 0.0009711153649822735,
              },
              {
                directTx:
                  '964ef300e90d91dd3f464ce2b6d98ad243ed1b4e469f12744b1d4c46c07fce86',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                  type: 'unknown single wallet service',
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 11214.564435146414,
                amountCur: 13.207498735363075,
                currency: '',
                tx_hash:
                  '964ef300e90d91dd3f464ce2b6d98ad243ed1b4e469f12744b1d4c46c07fce86',
                address: null,
                cluster: 122276901,
                directStamp: 1715149594,
                timestamp: 1715149594,
                listType: 'Unknown sources',
                share: 0.0004,
                amountDec: 0.0001109199999999997,
                deepDepthShare: 0,
                generalShare: 0.0004522296515746067,
                price: null,
                originalShare: 0.0004522296515746067,
              },
              {
                directTx:
                  '3f89e829f8e155efa2c15638a875d680257bdeb8630031dadf577de7866e3a8a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                  type: 'small transactions',
                },
                owner: 'small transactions',
                depth: 2,
                amount: 27697.192112086494,
                amountCur: 32.61924543828389,
                currency: '',
                tx_hash:
                  '13352bcd5e38e56f238a401fbae9ec60ce628ac25096550886e17a8d64f74099',
                address: null,
                directStamp: 1691659833,
                timestamp: 1691659833,
                listType: 'Unknown sources',
                share: 0.0011,
                amountDec: 0.00007784429527976934,
                deepDepthShare: 0.00044269640807523085,
                generalShare: 0.0006741986448604823,
                price: null,
                originalShare: 0.0011168950529357132,
              },
              {
                directTx:
                  '3f89e829f8e155efa2c15638a875d680257bdeb8630031dadf577de7866e3a8a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'Kraken',
                depth: 10,
                amount: 7654.307887540198,
                amountCur: 9.01455088419998,
                currency: '',
                tx_hash:
                  '06d2d686578b14a5f9ef01b31bb099651b426165017e15ea743ec67e50ab71c6',
                address: null,
                cluster: 38326320,
                directStamp: 1691659833,
                timestamp: 1691659833,
                listType: 'Known sources',
                share: 0.0003,
                amountDec: 0.00007654307887540198,
                deepDepthShare: 0.00030866156318819845,
                generalShare: 0,
                price: null,
                originalShare: 0.00030866156318819845,
              },
            ],
            entityBarsUof: [
              {
                directTx:
                  'a0a004812174dac9081e6e54a954affc9046d0ae4e981126bcc86bffec120561',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Binance',
                depth: 1,
                amount: 8541069.007289635,
                amountCur: 10058.897852411672,
                currency: '',
                tx_hash:
                  'a0a004812174dac9081e6e54a954affc9046d0ae4e981126bcc86bffec120561',
                address: '1HoQLPurLCJXHHxz3wDkUCVo52xZttwPCB',
                cluster: 34203831,
                directStamp: 1701273376,
                timestamp: 1701273376,
                listType: 'Known sources',
                share: 0.369,
                amountDec: 0.023000000000000003,
                deepDepthShare: 0.07523465654449736,
                generalShare: 0.2938399697890183,
                price: null,
                originalShare: 0.3690746263335156,
              },
              {
                directTx:
                  '5fa09ef15e14007e97f16bf103cb5359ab56d708b00a82e52208953f8d9d358f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'KuCoin',
                depth: 1,
                amount: 2040000,
                amountCur: 2402.527318466373,
                currency: '',
                tx_hash:
                  '5fa09ef15e14007e97f16bf103cb5359ab56d708b00a82e52208953f8d9d358f',
                address: '3ETwyvEscCiMCqZhy4cyFmMc9Kj45LwB9o',
                cluster: 36804785,
                directStamp: 1701593763,
                timestamp: 1701593763,
                listType: 'Known sources',
                share: 0.0881,
                amountDec: 0.0204,
                deepDepthShare: 0,
                generalShare: 0.08815199093670546,
                price: null,
                originalShare: 0.08815199093670546,
              },
              {
                directTx:
                  '4b826bdd7314927411ea4fc9677d43669912e9372effb1560a404c54bdb01006',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                  type: 'unhosted wallet',
                },
                owner: 'unhosted wallet',
                depth: 4,
                amount: 2098813.2248243396,
                amountCur: 2471.792210293618,
                currency: '',
                tx_hash:
                  '4c5681183acab6c1075d3a98e2b431f723cee4fadf35346989c67da31447032d',
                address:
                  'bc1qclndu0gqyjtpk3d5f0akqjwuzq73n2j9lxh9ph5wgfjghj8w4s7sl07pgs',
                directStamp: 1688055893,
                timestamp: 1688055893,
                'address-1':
                  'bc1quamzl2kh29h4gex0vucfk0re2sq576a5mwmgy5wzm0s7hltzcgwqmy29rz',
                listType: 'Unknown sources',
                share: 0.0906,
                amountDec: 0.01586012551545688,
                deepDepthShare: 0.07509629054559942,
                generalShare: 0.015597123362514658,
                price: null,
                originalShare: 0.09069341390811411,
              },
              {
                directTx:
                  '05eb2b6ac6ff199d63dadcb3fe5c9d615afff73122ce648fbea90ecbc51943ea',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                  type: 'Suspended exchange',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 4577399.324048062,
                amountCur: 5390.846531154402,
                currency: '',
                tx_hash:
                  '05eb2b6ac6ff199d63dadcb3fe5c9d615afff73122ce648fbea90ecbc51943ea',
                address: '38JsEZeMVD2H4roq5HkfjKM64dsQB11ysS',
                cluster: 3310,
                directStamp: 1685911803,
                timestamp: 1685911803,
                listType: 'Risky sources',
                share: 0.1977,
                amountDec: 0.008393904029445254,
                deepDepthShare: 0.017908372157870167,
                generalShare: 0.17988911006132907,
                price: null,
                originalShare: 0.19779748221919918,
              },
              {
                directTx:
                  '4b826bdd7314927411ea4fc9677d43669912e9372effb1560a404c54bdb01006',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'OKX',
                depth: 4,
                amount: 1531039.929063597,
                amountCur: 1803.1202231559364,
                currency: '',
                tx_hash:
                  '4c5681183acab6c1075d3a98e2b431f723cee4fadf35346989c67da31447032d',
                address: '3A3Z58i4PzSFm5Uk77DAsS2R719cexD3LH',
                cluster: 42345622,
                directStamp: 1688055893,
                timestamp: 1688055893,
                'address-1':
                  'bc1quamzl2kh29h4gex0vucfk0re2sq576a5mwmgy5wzm0s7hltzcgwqmy29rz',
                listType: 'Known sources',
                share: 0.0661,
                amountDec: 0.007903392758863655,
                deepDepthShare: 0.06615893036791588,
                generalShare: 0,
                price: null,
                originalShare: 0.06615893036791588,
              },
              {
                directTx:
                  'f1cac543a7d0c3f8db46fe3c94e7ec54e70c166f3543fb418aa75e169fbdb483',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                  type: 'unidentified service / exchange',
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 1232622.8539733589,
                amountCur: 1451.6716078612658,
                currency: '',
                tx_hash:
                  'b96f97af0779b9222f3172e7f735cd49b9f6ff6e56b81912fbcb1c6fa5e79dd9',
                address: 'bc1qfhdpevk5vzda5rlkqruc7vh042v6xmac8guqnr',
                cluster: 113020304,
                directStamp: 1730992752,
                timestamp: 1730992752,
                'address-1': '31h5r2TK9d3VwsUskzQ5vgL6nhnVenpVKE',
                listType: 'Unknown sources',
                share: 0.0532,
                amountDec: 0.005168142559316986,
                deepDepthShare: 0.052661560957917,
                generalShare: 0.0006022423027866982,
                price: null,
                originalShare: 0.0532638032607037,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                  type: 'small transactions',
                },
                owner: 'small transactions',
                depth: {
                  minimum: 4,
                  maximum: 18,
                },
                amount: 1691032.8588494882,
                amountCur: 1991.5454116716592,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1733602375,
                timestamp: 1733602375,
                listType: 'Unknown sources',
                share: 0.073,
                amountDec: 0.0033323542873096666,
                deepDepthShare: 0.04156647913134705,
                generalShare: 0.03150602736226632,
                price: null,
                originalShare: 0.07307250649361333,
              },
              {
                directTx:
                  '5339dfa1bda0b414f0a6d2ca77eadd0f941d4615780a7375d4776588a7e14305',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                  type: 'unknown single wallet service',
                },
                owner: 'unknown single wallet service',
                depth: 4,
                amount: 755291.2283815859,
                amountCur: 889.513632149404,
                currency: '',
                tx_hash:
                  '0a8f2720ab61c16a1c41b0caa8644c631806f93b83dfc4d7a38716e95433c0bc',
                address: '1JaLcWmap1HnLMTpwWkG1f7Qg1RsQipf5Q',
                cluster: 63419260,
                directStamp: 1732442617,
                timestamp: 1732442617,
                'address-1': '12q6fkqwieR61nEZHP7DK9mP5UVXvkHPfG',
                listType: 'Unknown sources',
                share: 0.0326,
                amountDec: 0.002556958843018847,
                deepDepthShare: 0.03115376831149864,
                generalShare: 0.0014836951781418977,
                price: null,
                originalShare: 0.03263746348964054,
              },
              {
                directTx:
                  '91a427ab462b15911d50299a771ca4bdf35a285a98d5b361714c96be268b1bad',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'MEXC',
                depth: 3,
                amount: 255220.50651238573,
                amountCur: 300.57560741609393,
                currency: '',
                tx_hash:
                  '3d4e9a674eb0277f5d36c44e72046c77feb5b0bfef35130d4cd611501ffff479',
                address: '3HYPdHxkr7EdzyjcBYXqS7QkdMqYmAvPYa',
                cluster: 46904186,
                directStamp: 1753785243,
                timestamp: 1753785243,
                'address-1': 'bc1qr7hu54ncqa4cjac3j9jh54n80lshlrjfj98h79',
                listType: 'Known sources',
                share: 0.011,
                amountDec: 0.0025522050651238574,
                deepDepthShare: 0.011028527341637846,
                generalShare: 0,
                price: null,
                originalShare: 0.011028527341637846,
              },
              {
                directTx:
                  '02e724951642dcaf4e83a3634223dfa185b8af6f7759028a0818c6b3327e6320',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'CoinEx',
                depth: 1,
                amount: 167765,
                amountCur: 197.57842920711326,
                currency: '',
                tx_hash:
                  '02e724951642dcaf4e83a3634223dfa185b8af6f7759028a0818c6b3327e6320',
                address: '127Y6BXnqJmYf6LRiMY7UwVopybekbUs7n',
                cluster: 113646335,
                directStamp: 1726355073,
                timestamp: 1726355073,
                listType: 'Known sources',
                share: 0.0072,
                amountDec: 0.00167765,
                deepDepthShare: 0,
                generalShare: 0.007249420960537448,
                price: null,
                originalShare: 0.007249420960537448,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'maximum depth reached',
                  score: 50,
                  id: '61e08b592536c394af97d392',
                  default: true,
                  type: 'maximum depth reached',
                },
                owner: 'maximum depth reached',
                depth: 20,
                amount: 83209.43283224056,
                amountCur: 97.99653702625037,
                currency: '',
                tx_hash:
                  '6726ed456616fa9e0c8e59c68101c05ca525a5d7b008c2836e883d4dced64d18',
                address: null,
                directStamp: 1687958689,
                timestamp: 1687958689,
                listType: 'Unknown sources',
                share: 0.0035,
                amountDec: 0.0004752089116996734,
                deepDepthShare: 0.003595626063174546,
                generalShare: 0,
                price: null,
                originalShare: 0.003595626063174546,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Coinbase',
                depth: 15,
                amount: 147647.40794065004,
                amountCur: 173.88575052851004,
                currency: '',
                tx_hash:
                  '278e88991cfbe711e29a28ff272a6c7d41f39d6d78dc130c5dc2c964c4bd8bd4',
                address: '3CW24NViy1rVCRCxXnHx5sHBx3vTh96XJz',
                cluster: 502154,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1qd4h63phn4qn24cexxqgmqp80dqhx4wpf4pn8gu',
                listType: 'Known sources',
                share: 0.0063,
                amountDec: 0.00040937967548976246,
                deepDepthShare: 0.0063302949006000375,
                generalShare: 0.00004980949479811875,
                price: null,
                originalShare: 0.006380104395398156,
              },
              {
                directTx:
                  '4da3c27a240e27f27fd5959410b63476b54510bf5a1cfb5a7439f085998a20de',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Gambling',
                  score: 60,
                  id: '61766e55820e134d585ded4f',
                  type: 'Gambling',
                },
                owner: 'Betplay',
                depth: 7,
                amount: 20737.50813178421,
                amountCur: 24.422759707612805,
                currency: '',
                tx_hash:
                  '88d3d3d3e39158304801fcb81500153539989f425d41bb16cf49b3390808a06c',
                address: 'bc1qa7yuxdlktc3f4d5ftq4jzsfgw2e0wmj0jd399k',
                cluster: 84776286,
                directStamp: 1735820508,
                timestamp: 1735820508,
                'address-1': '3CqTUuTd7pjeQ5zKy6GJVD1wNoox3Yunxk',
                listType: 'Risky sources',
                share: 0.0008,
                amountDec: 0.0002073750813178421,
                deepDepthShare: 0.0008961042298445577,
                generalShare: 0,
                price: null,
                originalShare: 0.0008961042298445577,
              },
            ],
          },
        },
        {
          type: 'sof',
          status: 'SOF Found',
          data: {
            sources: [
              {
                directTx:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 11442705.346663631,
                amountCur: 13476.182447314022,
                currency: '',
                tx_hash:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                address:
                  'bc1pc6plmlxyg2qjfe6wfv3jqgvdcsx47jh7j0p3tjkeg9ec6232lfeqe6cn6t',
                cluster: 3310,
                directStamp: 1700648582,
                timestamp: 1700648582,
                listType: 'Risky sources',
                share: 0.4614294814495864,
                amountDec: 0.11442705346663631,
              },
              {
                directTx:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 3779283,
                amountCur: 4450.897378291937,
                currency: '',
                tx_hash:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1688055567,
                timestamp: 1688055567,
                listType: 'Known sources',
                share: 0.15240037579484655,
                amountDec: 0.03779283,
              },
              {
                directTx:
                  'b8355ff67b1c230df717c54e5b097b502cb45f5a250080822a2bdce1ae456fe6',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 1011094.2419558349,
                amountCur: 1190.775263648501,
                currency: '',
                tx_hash:
                  'b8355ff67b1c230df717c54e5b097b502cb45f5a250080822a2bdce1ae456fe6',
                address: null,
                cluster: 3310,
                directStamp: 1732382148,
                timestamp: 1732382148,
                listType: 'Risky sources',
                share: 0.04077258634457243,
                amountDec: 0.01011094241955835,
              },
              {
                directTx:
                  '761dbe8b2fbe66e7247084ada939d1929a912a4a417cf1c5fac87bf57ca3c2fd',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 1000000,
                amountCur: 1177.7094698364574,
                currency: '',
                tx_hash:
                  '761dbe8b2fbe66e7247084ada939d1929a912a4a417cf1c5fac87bf57ca3c2fd',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1685910809,
                timestamp: 1685910809,
                listType: 'Risky sources',
                share: 0.04032520872209002,
                amountDec: 0.01,
              },
              {
                directTx:
                  '656a5adcd612fb784631044987c658f683301335a80ea23ebd9277358b4916e4',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 818193.2155907573,
                amountCur: 963.593898157177,
                currency: '',
                tx_hash:
                  '656a5adcd612fb784631044987c658f683301335a80ea23ebd9277358b4916e4',
                address:
                  'bc1qwfxx2s0kf3k97lyxcmrqenxduvcyvmljpxdjrpwplk4cf2s8f3mqgm4xve',
                cluster: 3310,
                directStamp: 1733577486,
                timestamp: 1733577486,
                listType: 'Risky sources',
                share: 0.032993812193695286,
                amountDec: 0.008181932155907573,
              },
              {
                directTx:
                  'b3eb8160eb781a1364ed6878957d17c413afcb4898732ae48e21dce3f211446f',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 800000,
                amountCur: 942.167575869166,
                currency: '',
                tx_hash:
                  'b3eb8160eb781a1364ed6878957d17c413afcb4898732ae48e21dce3f211446f',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1719174114,
                timestamp: 1719174114,
                listType: 'Risky sources',
                share: 0.03226016697767202,
                amountDec: 0.008,
              },
              {
                directTx:
                  'd676609d61970e9b108e0293cc1c5209e25551aed4bf3ceb44ed94c136f885d4',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 706655.3927521049,
                amountCur: 832.2347479551551,
                currency: '',
                tx_hash:
                  'd676609d61970e9b108e0293cc1c5209e25551aed4bf3ceb44ed94c136f885d4',
                address: null,
                cluster: 3310,
                directStamp: 1753784333,
                timestamp: 1753784333,
                listType: 'Risky sources',
                share: 0.02849602620731913,
                amountDec: 0.007066553927521049,
              },
              {
                directTx:
                  '27c56fc861d38b377734e45b1fbe637d408ea1fbbca1713a4e0349b2284ac5d6',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 600825.5545597614,
                amountCur: 707.5979453247721,
                currency: '',
                tx_hash:
                  '27c56fc861d38b377734e45b1fbe637d408ea1fbbca1713a4e0349b2284ac5d6',
                address: null,
                cluster: 3310,
                directStamp: 1735818789,
                timestamp: 1735818789,
                listType: 'Risky sources',
                share: 0.024228415893187864,
                amountDec: 0.0060082555455976145,
              },
              {
                directTx:
                  'c819aba64e1c679e097b675d7aa6331df304e41b92733cc244af80961199b9fb',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 559601.9610344638,
                amountCur: 659.0485288493403,
                currency: '',
                tx_hash:
                  'c819aba64e1c679e097b675d7aa6331df304e41b92733cc244af80961199b9fb',
                address:
                  'bc1pq8qqz6r0d5x38d9r742mcjt9fmqgtnqj8xt96wq02ulxccfs73ds5dd0d7',
                cluster: 3310,
                directStamp: 1722440381,
                timestamp: 1722440381,
                listType: 'Risky sources',
                share: 0.02256606588000564,
                amountDec: 0.005596019610344638,
              },
              {
                directTx:
                  'ca15ef17a0cd3af637e01104a6dff7e15bf1088948e7958175cebd90affa50e4',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 530902.9107977018,
                amountCur: 625.2493856101934,
                currency: '',
                tx_hash:
                  'ca15ef17a0cd3af637e01104a6dff7e15bf1088948e7958175cebd90affa50e4',
                address: null,
                cluster: 3310,
                directStamp: 1730990436,
                timestamp: 1730990436,
                listType: 'Risky sources',
                share: 0.021408770689082462,
                amountDec: 0.005309029107977018,
              },
              {
                directTx:
                  '3394d76ba307e18bde511c432e88d191d731101b230269a3479da068a257c57e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 404360.8253713263,
                amountCur: 476.219573270697,
                currency: '',
                tx_hash:
                  '3394d76ba307e18bde511c432e88d191d731101b230269a3479da068a257c57e',
                address: null,
                cluster: 3310,
                directStamp: 1738788538,
                timestamp: 1738788538,
                listType: 'Risky sources',
                share: 0.01630593468213533,
                amountDec: 0.004043608253713263,
              },
              {
                directTx:
                  'b82a6941853322703b3d7ce788f60f7dee71933f838eb4fda45271b271c3a52a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 356800,
                amountCur: 420.206738837648,
                currency: '',
                tx_hash:
                  'b82a6941853322703b3d7ce788f60f7dee71933f838eb4fda45271b271c3a52a',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1687954289,
                timestamp: 1687954289,
                listType: 'Known sources',
                share: 0.01438803447204172,
                amountDec: 0.003568,
              },
              {
                directTx:
                  '4e2d99e9dbb7e10777eea046908c7f6c32110004efafbd777b0b93cb581646ee',
                directionUp: false,
                token: '',
                funds: {
                  name: 'maximum depth reached',
                  score: 50,
                  id: '61e08b592536c394af97d392',
                  default: true,
                },
                owner: 'maximum depth reached',
                depth: 20,
                amount: 225263.7786560397,
                amountCur: 265.2952853343616,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1706898546,
                timestamp: 1706898546,
                listType: 'Unknown sources',
                share: 0.009083808891831488,
                amountDec: 0.002252637786560397,
              },
              {
                directTx:
                  '8fc0d9241797e014fdd6aefff98985e1348aee1393a9a4e466ad44b5f43fb591',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 212502.8700473788,
                amountCur: 250.26664242222407,
                currency: '',
                tx_hash:
                  '8fc0d9241797e014fdd6aefff98985e1348aee1393a9a4e466ad44b5f43fb591',
                address:
                  'bc1qn4rsj8g37dct9x37aptvsdprk62pmqm5fn7yf3z6em5lsay72qjqc87amh',
                cluster: 3310,
                directStamp: 1738148975,
                timestamp: 1738148975,
                listType: 'Risky sources',
                share: 0.00856922258870372,
                amountDec: 0.002125028700473788,
              },
              {
                directTx:
                  '1a785c79e0c188d41418cb283539b1a7ba6655523bd1551faf160611cdc22dee',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 209604,
                amountCur: 246.85261571560082,
                currency: '',
                tx_hash:
                  '1a785c79e0c188d41418cb283539b1a7ba6655523bd1551faf160611cdc22dee',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1712783397,
                timestamp: 1712783397,
                listType: 'Known sources',
                share: 0.008452325048984957,
                amountDec: 0.00209604,
              },
              {
                directTx:
                  'bbe5e6b98f5bad1a37ca2d64564de9c584990e1f6fb18be09439100deab71517',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Online wallet',
                  score: 60,
                  id: '61767102820e13ff395ded5f',
                },
                owner: 'Cash App',
                depth: 7,
                amount: 165685,
                amountCur: 195.12879350985344,
                currency: '',
                tx_hash:
                  '5be8f1b8c47989c0287cc106777f666a6bba6ef62e00098dfce2983a3e9bea81',
                address: 'bc1qxj0h49u5n7hmhl2cql3qytnukmrlhtz4xejqf9',
                cluster: 39540539,
                directStamp: 1708096725,
                timestamp: 1708096725,
                listType: 'Risky sources',
                share: 0.006681282207119485,
                amountDec: 0.00165685,
              },
              {
                directTx:
                  '595b785ab319eadbce739cde1702f0384ee93dc427157283f06071ae7a0f5972',
                directionUp: false,
                token: '',
                funds: {
                  name: 'High-risk exchange',
                  score: 70,
                  id: '61766f47820e1372d85ded59',
                },
                owner: 'ChangeNOW',
                entity: '6603e884a6a313bd816dba8e',
                depth: 1,
                amount: 154530,
                amountCur: 181.99144437382776,
                currency: '',
                tx_hash:
                  '595b785ab319eadbce739cde1702f0384ee93dc427157283f06071ae7a0f5972',
                address: '37jAAWEdJ9D9mXybRobcveioxSkt7Lkwog',
                directStamp: 1709390007,
                timestamp: 1709390007,
                listType: 'Risky sources',
                share: 0.006231454503824571,
                amountDec: 0.0015453,
              },
              {
                directTx:
                  '70074d60ab9364ae35e4904df4c7ace8c1d18f7edb447d5e33620b02c84069fd',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 150000,
                amountCur: 176.6564204754686,
                currency: '',
                tx_hash:
                  '70074d60ab9364ae35e4904df4c7ace8c1d18f7edb447d5e33620b02c84069fd',
                address:
                  'bc1p6zgg8j70qdxjly75mrk7clsqfaydvfskf27e6cfnhwmd2w4vn55shycuxr',
                cluster: 3310,
                directStamp: 1687692619,
                timestamp: 1687692619,
                listType: 'Risky sources',
                share: 0.006048781308313503,
                amountDec: 0.0015,
              },
              {
                directTx:
                  '3f753cbbf532f70c8fe9615bb400a167f3ca1b3aed753fcf5c283e3680e23574',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 145000,
                amountCur: 170.76787312628633,
                currency: '',
                tx_hash:
                  '3f753cbbf532f70c8fe9615bb400a167f3ca1b3aed753fcf5c283e3680e23574',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1711991560,
                timestamp: 1711991560,
                listType: 'Known sources',
                share: 0.0058471552647030535,
                amountDec: 0.00145,
              },
              {
                directTx:
                  '67d85bb442bb336a0f2930e8b07545e301061c4c8b6708283cafb71b6a166b90',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 2,
                amount: 144811,
                amountCur: 170.54528603648723,
                currency: '',
                tx_hash:
                  '60bf4995c471a7903ffb449e4f6a50120a3ca7871bb0a27091b0279639f1fc6e',
                address:
                  'bc1phsu2q9h04waeqqrwjpf8wrlc5hnk3c0zjlcc6c4r0hxsmm8r650scnu4av',
                cluster: 3310,
                directStamp: 1729607349,
                timestamp: 1729607349,
                listType: 'Risky sources',
                share: 0.005839533800254578,
                amountDec: 0.00144811,
              },
              {
                directTx:
                  '3a5be5430be1a9063554512e141fc9ae21b799077ba60e01c86b023faf588041',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 118790.00000000001,
                amountCur: 139.9001079218728,
                currency: '',
                tx_hash:
                  '3a5be5430be1a9063554512e141fc9ae21b799077ba60e01c86b023faf588041',
                address: 'bc1qskmsg7f2ttmtw3xdage68pvhv7vhjjkvg6h5eg',
                cluster: 3310,
                directStamp: 1726084169,
                timestamp: 1726084169,
                listType: 'Risky sources',
                share: 0.0047902315440970745,
                amountDec: 0.0011879000000000002,
              },
              {
                directTx:
                  '791ec0d9096ac0bbf02204d76772dbb56343f1507154229450ba91bc70ce3296',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 110000,
                amountCur: 129.5480416820103,
                currency: '',
                tx_hash:
                  '791ec0d9096ac0bbf02204d76772dbb56343f1507154229450ba91bc70ce3296',
                address:
                  'bc1p2eh3c6e5n087lgz8pz7y25jceancklcddsx67jg8sk3famzylhjqn3gxpg',
                cluster: 3310,
                directStamp: 1687692619,
                timestamp: 1687692619,
                listType: 'Risky sources',
                share: 0.004435772959429902,
                amountDec: 0.0011,
              },
              {
                directTx:
                  'f4dbfcfee75ae4cbe54916a9b1709bcc71aa676b0550490f01787c7a13dadfb0',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 104341,
                amountCur: 122.8833837922058,
                currency: '',
                tx_hash:
                  'f4dbfcfee75ae4cbe54916a9b1709bcc71aa676b0550490f01787c7a13dadfb0',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1689778499,
                timestamp: 1689778499,
                listType: 'Known sources',
                share: 0.004207572603271595,
                amountDec: 0.00104341,
              },
              {
                directTx:
                  '140ead1544b13a9d85d5f00130d111d5d82449d65d11243707fda45c43b3759a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 100000,
                amountCur: 117.77094698364574,
                currency: '',
                tx_hash:
                  '140ead1544b13a9d85d5f00130d111d5d82449d65d11243707fda45c43b3759a',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1719175449,
                timestamp: 1719175449,
                listType: 'Risky sources',
                share: 0.0040325208722090024,
                amountDec: 0.001,
              },
              {
                directTx:
                  '689e9630ae648f2ebb81fcc8fda08577b6dada4cd20f5ccb7712fae90d32fdea',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 100000,
                amountCur: 117.77094698364574,
                currency: '',
                tx_hash:
                  '689e9630ae648f2ebb81fcc8fda08577b6dada4cd20f5ccb7712fae90d32fdea',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1713473773,
                timestamp: 1713473773,
                listType: 'Risky sources',
                share: 0.0040325208722090024,
                amountDec: 0.001,
              },
              {
                directTx:
                  'ef578dcfd664b2ce9e67ab6009451085cf24758f52677c3e1f787ea9bb082a7e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 100000,
                amountCur: 117.77094698364574,
                currency: '',
                tx_hash:
                  'ef578dcfd664b2ce9e67ab6009451085cf24758f52677c3e1f787ea9bb082a7e',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1723445381,
                timestamp: 1723445381,
                listType: 'Risky sources',
                share: 0.0040325208722090024,
                amountDec: 0.001,
              },
              {
                directTx:
                  '01c455ee522365706353b8e03c7c6d60df1e9a05e63473a9f8b7c0bed52ab48e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 5,
                amount: 94159.30377244143,
                amountCur: 110.89230372601195,
                currency: '',
                tx_hash:
                  'd055aa0b160a02b7ac3709cb3c24b9d561768bdc2e056451ade761369dce2617',
                address: null,
                cluster: 502154,
                directStamp: 1710707326,
                timestamp: 1710707326,
                listType: 'Known sources',
                share: 0.003796993577750379,
                amountDec: 0.0009415930377244143,
              },
              {
                directTx:
                  '2dbf4b877b8d6b0cc0451ba18f854369eef492bd35b16c3121be04a8f16fbda1',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 80000,
                amountCur: 94.21675758691659,
                currency: '',
                tx_hash:
                  '2dbf4b877b8d6b0cc0451ba18f854369eef492bd35b16c3121be04a8f16fbda1',
                address:
                  'bc1p0mwrrlzhlewex00c56xuhtkpnvkmd8jc673k2hn7qznvhpuk3g0skmf5p9',
                cluster: 3310,
                directStamp: 1711179609,
                timestamp: 1711179609,
                listType: 'Risky sources',
                share: 0.0032260166977672016,
                amountDec: 0.0008,
              },
              {
                directTx:
                  '3f89e829f8e155efa2c15638a875d680257bdeb8630031dadf577de7866e3a8a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 4,
                amount: 65643.89066731259,
                amountCur: 77.30943167580308,
                currency: '',
                tx_hash:
                  'e96f39b9b3736b8c7f7079674222af5d8519eee6c993efede88cb6c01801384f',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1691659833,
                timestamp: 1691659833,
                listType: 'Known sources',
                share: 0.0026471035924894373,
                amountDec: 0.0006564389066731259,
              },
              {
                directTx:
                  '4e2d99e9dbb7e10777eea046908c7f6c32110004efafbd777b0b93cb581646ee',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 3,
                amount: 50193.36023010462,
                amountCur: 59.11319566590684,
                currency: '',
                tx_hash:
                  '3efbc3e64d0fc1ab46581dac14b7446415eb782a645f494cbac10c93c51e66b9',
                address: null,
                cluster: 112109219,
                directStamp: 1706898546,
                timestamp: 1706898546,
                listType: 'Unknown sources',
                share: 0.0020240577277420213,
                amountDec: 0.0005019336023010461,
              },
              {
                directTx:
                  '232f767116902aad412c17e2f6305c165341dc8315c623d51202b995ce431a26',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 50000,
                amountCur: 58.88547349182287,
                currency: '',
                tx_hash:
                  '232f767116902aad412c17e2f6305c165341dc8315c623d51202b995ce431a26',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1711968346,
                timestamp: 1711968346,
                listType: 'Risky sources',
                share: 0.0020162604361045012,
                amountDec: 0.0005,
              },
              {
                directTx:
                  '33a06df8a54c19b004702e53a779ac35a16e167c1d723b9d03d451ce45c9c55f',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 50000,
                amountCur: 58.88547349182287,
                currency: '',
                tx_hash:
                  '33a06df8a54c19b004702e53a779ac35a16e167c1d723b9d03d451ce45c9c55f',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1727469157,
                timestamp: 1727469157,
                listType: 'Risky sources',
                share: 0.0020162604361045012,
                amountDec: 0.0005,
              },
              {
                directTx:
                  '4e2d99e9dbb7e10777eea046908c7f6c32110004efafbd777b0b93cb581646ee',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Online wallet',
                  score: 60,
                  id: '61767102820e13ff395ded5f',
                },
                owner: 'Cash App',
                depth: 3,
                amount: 40374.86111385568,
                amountCur: 47.549856277119574,
                currency: '',
                tx_hash:
                  'cd87f7515d078c5f98c874380127721962ec628e3df08be7895f4f2b9618374a',
                address: null,
                cluster: 39540539,
                directStamp: 1706898546,
                timestamp: 1706898546,
                listType: 'Risky sources',
                share: 0.0016281247015416263,
                amountDec: 0.0004037486111385568,
              },
              {
                directTx:
                  'ac9f16cd8688564588871798ccde77e4bd45c8c27d042ce03aaabe68e1b1e99d',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 40000,
                amountCur: 47.10837879345829,
                currency: '',
                tx_hash:
                  'ac9f16cd8688564588871798ccde77e4bd45c8c27d042ce03aaabe68e1b1e99d',
                address:
                  'bc1p2eh3c6e5n087lgz8pz7y25jceancklcddsx67jg8sk3famzylhjqn3gxpg',
                cluster: 3310,
                directStamp: 1743693155,
                timestamp: 1743693155,
                listType: 'Risky sources',
                share: 0.0016130083488836008,
                amountDec: 0.0004,
              },
              {
                directTx:
                  '133cc96b54817ca8d5e0163702bb21635144272ed9f7316bb9ab9d469bbacacf',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                },
                owner: 'KuCoin.com',
                depth: 9,
                amount: 38095,
                amountCur: 44.864842253419845,
                currency: '',
                tx_hash:
                  'a4615286e5add9ef63ac9faff77543a4417c06f7ef679cc219332a1163a4f7c2',
                address: 'bc1qrt7rkpswpgmcag7txzf6ps9mvepwgndshqdx6d',
                cluster: 96386194,
                directStamp: 1709385674,
                timestamp: 1709385674,
                listType: 'Known sources',
                share: 0.0015361888262680192,
                amountDec: 0.00038095,
              },
              {
                directTx:
                  'f22d7032749881959888eb3e038fad7613c243785e363b16939dccaa14b90e85',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 30000,
                amountCur: 35.33128409509372,
                currency: '',
                tx_hash:
                  'f22d7032749881959888eb3e038fad7613c243785e363b16939dccaa14b90e85',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1700492970,
                timestamp: 1700492970,
                listType: 'Risky sources',
                share: 0.0012097562616627006,
                amountDec: 0.0003,
              },
              {
                directTx:
                  '56d5d4d429962a893dda8ca54849109c8fabf9c33b00ef0a54e15a18768e36d6',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 25000,
                amountCur: 29.442736745911436,
                currency: '',
                tx_hash:
                  '56d5d4d429962a893dda8ca54849109c8fabf9c33b00ef0a54e15a18768e36d6',
                address: '3QDeLpSg5DYyTyPCjE6LM2QBegsoXnYhgz',
                cluster: 3310,
                directStamp: 1707002054,
                timestamp: 1707002054,
                listType: 'Risky sources',
                share: 0.0010081302180522506,
                amountDec: 0.00025,
              },
              {
                directTx:
                  '01c455ee522365706353b8e03c7c6d60df1e9a05e63473a9f8b7c0bed52ab48e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Bitstamp',
                depth: 3,
                amount: 24082.0914697535,
                amountCur: 28.361707177396468,
                currency: '',
                tx_hash:
                  '511ad83d52d17cba4e995ccf6029fa38714ddf78af474fa8f06277920a88d07e',
                address: null,
                cluster: 67827685,
                directStamp: 1710707326,
                timestamp: 1710707326,
                listType: 'Known sources',
                share: 0.0009711153649822735,
                amountDec: 0.00024082091469753502,
              },
              {
                directTx:
                  '3f89e829f8e155efa2c15638a875d680257bdeb8630031dadf577de7866e3a8a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'maximum depth reached',
                  score: 50,
                  id: '61e08b592536c394af97d392',
                  default: true,
                },
                owner: 'maximum depth reached',
                depth: 20,
                amount: 21169.371917170265,
                amountCur: 24.93136977734138,
                currency: '',
                tx_hash:
                  'fe30d066dd68c992fff920f851b067cfc20273c99734f8e6e6d1ab8630f3621b',
                address: null,
                directStamp: 1691659833,
                timestamp: 1691659833,
                listType: 'Unknown sources',
                share: 0.0008536593410754419,
                amountDec: 0.00021169371917170265,
              },
              {
                directTx:
                  'f64169f7d0e992722a59ac835212b40a64392c8d5c4aa3c44d5305b17031ce31',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 21000,
                amountCur: 24.731898866565604,
                currency: '',
                tx_hash:
                  'f64169f7d0e992722a59ac835212b40a64392c8d5c4aa3c44d5305b17031ce31',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1689622970,
                timestamp: 1689622970,
                listType: 'Risky sources',
                share: 0.0008468293831638904,
                amountDec: 0.00021,
              },
              {
                directTx:
                  '98591cd5d63092b0147404fb377820116cee97edd6e5edc9d8559b1ed9f8c85b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 14099.000000000002,
                amountCur: 16.604525815224214,
                currency: '',
                tx_hash:
                  '98591cd5d63092b0147404fb377820116cee97edd6e5edc9d8559b1ed9f8c85b',
                address:
                  'bc1p6zgg8j70qdxjly75mrk7clsqfaydvfskf27e6cfnhwmd2w4vn55shycuxr',
                cluster: 3310,
                directStamp: 1711140127,
                timestamp: 1711140127,
                listType: 'Risky sources',
                share: 0.0005685451177727472,
                amountDec: 0.00014099000000000002,
              },
              {
                directTx:
                  'e46749296996faccb93c9b12243f934bf612decc74ab5dc5763825cd4e91ab8a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 13810,
                amountCur: 16.264167778441475,
                currency: '',
                tx_hash:
                  'e46749296996faccb93c9b12243f934bf612decc74ab5dc5763825cd4e91ab8a',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1722370261,
                timestamp: 1722370261,
                listType: 'Risky sources',
                share: 0.0005568911324520631,
                amountDec: 0.0001381,
              },
              {
                directTx:
                  '964ef300e90d91dd3f464ce2b6d98ad243ed1b4e469f12744b1d4c46c07fce86',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 11091.99999999997,
                amountCur: 13.063153439425951,
                currency: '',
                tx_hash:
                  '964ef300e90d91dd3f464ce2b6d98ad243ed1b4e469f12744b1d4c46c07fce86',
                address: null,
                cluster: 122276901,
                directStamp: 1715149594,
                timestamp: 1715149594,
                listType: 'Unknown sources',
                share: 0.0004472872151454213,
                amountDec: 0.0001109199999999997,
              },
              {
                directTx:
                  'f1f7abd88116bc0bccd77bbc49d2661e59fd9ad04a4b00395c41df2a76298641',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  'f1f7abd88116bc0bccd77bbc49d2661e59fd9ad04a4b00395c41df2a76298641',
                address:
                  'bc1pwrklz6fyyfpmnazrv7zfxulp0hmctzmjf65q0xmuknps3ddjewyqfafz3e',
                cluster: 3310,
                directStamp: 1690961567,
                timestamp: 1690961567,
                listType: 'Risky sources',
                share: 0.0004032520872209002,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '32c63542770809dd4af04c6796bd29528244fa5675c4658ca34dd712862692eb',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  '32c63542770809dd4af04c6796bd29528244fa5675c4658ca34dd712862692eb',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1689606314,
                timestamp: 1689606314,
                listType: 'Risky sources',
                share: 0.0003629268784988102,
                amountDec: 0.00009,
              },
              {
                directTx:
                  '3f89e829f8e155efa2c15638a875d680257bdeb8630031dadf577de7866e3a8a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 7784.429527976934,
                amountCur: 9.16779637237298,
                currency: '',
                tx_hash:
                  '13352bcd5e38e56f238a401fbae9ec60ce628ac25096550886e17a8d64f74099',
                address: null,
                directStamp: 1691659833,
                timestamp: 1691659833,
                listType: 'Unknown sources',
                share: 0.00031390874549807056,
                amountDec: 0.00007784429527976934,
              },
              {
                directTx:
                  '3f89e829f8e155efa2c15638a875d680257bdeb8630031dadf577de7866e3a8a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                },
                owner: 'Kraken',
                depth: 10,
                amount: 7654.307887540198,
                amountCur: 9.01455088419998,
                currency: '',
                tx_hash:
                  '06d2d686578b14a5f9ef01b31bb099651b426165017e15ea743ec67e50ab71c6',
                address: null,
                cluster: 38326320,
                directStamp: 1691659833,
                timestamp: 1691659833,
                listType: 'Known sources',
                share: 0.00030866156318819845,
                amountDec: 0.00007654307887540198,
              },
              {
                directTx:
                  '486c5b20dd3a19f2b733476197bf11ab7544fc153eefe4ff3c83a26411a0865a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 6593.949873616006,
                amountCur: 7.765757209784481,
                currency: '',
                tx_hash:
                  '486c5b20dd3a19f2b733476197bf11ab7544fc153eefe4ff3c83a26411a0865a',
                address:
                  'bc1ptdt9ypvmh9lrah9tvmne2gjcvmp74j2h3txjjcsy8cxph5n7vags3v3xsd',
                cluster: 3310,
                directStamp: 1729863097,
                timestamp: 1729863097,
                listType: 'Risky sources',
                share: 0.00026590240495656453,
                amountDec: 0.00006593949873616006,
              },
              {
                directTx:
                  '8f1ed97358db19dd26adf0be869a250cfd07032f62a4d017cadad8409e2e6708',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 5116,
                amountCur: 6.025161647683316,
                currency: '',
                tx_hash:
                  '8f1ed97358db19dd26adf0be869a250cfd07032f62a4d017cadad8409e2e6708',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1685959723,
                timestamp: 1685959723,
                listType: 'Risky sources',
                share: 0.00020630376782221254,
                amountDec: 0.00005116,
              },
              {
                directTx:
                  'f1b9d9d8cfaadfbd62d992d2cf358b0d2d03c91e0bc128ecd7f8432a8c9b1c65',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 3637.999999999999,
                amountCur: 4.284507051265031,
                currency: '',
                tx_hash:
                  'f1b9d9d8cfaadfbd62d992d2cf358b0d2d03c91e0bc128ecd7f8432a8c9b1c65',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1711138265,
                timestamp: 1711138265,
                listType: 'Risky sources',
                share: 0.00014670310933096345,
                amountDec: 0.000036379999999999994,
              },
              {
                directTx:
                  '01c455ee522365706353b8e03c7c6d60df1e9a05e63473a9f8b7c0bed52ab48e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 3265.604757804777,
                amountCur: 3.8459336480096766,
                currency: '',
                tx_hash:
                  '01c455ee522365706353b8e03c7c6d60df1e9a05e63473a9f8b7c0bed52ab48e',
                address: null,
                directStamp: 1710707326,
                timestamp: 1710707326,
                listType: 'Unknown sources',
                share: 0.00013168619346232786,
                amountDec: 0.00003265604757804777,
              },
              {
                directTx:
                  '0adc898cef433fe135011519e8c50061ab38c37d9cf9ebe71e073eae374b7428',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 3193.725876652706,
                amountCur: 3.7612812089956336,
                currency: '',
                tx_hash:
                  '668efe6f7a9e7495c811573870ced9d31a6be0d2eee6e5e7a11050a66f1470da',
                address: null,
                directStamp: 1710707652,
                timestamp: 1710707652,
                listType: 'Unknown sources',
                share: 0.0001287876625771603,
                amountDec: 0.00003193725876652706,
              },
              {
                directTx:
                  '8c56a271a570ccc592f01432cf8016e3c5b30294013597a819596995d8a61cca',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 1568.7266765760253,
                amountCur: 1.8475042625886584,
                currency: '',
                tx_hash:
                  '8c56a271a570ccc592f01432cf8016e3c5b30294013597a819596995d8a61cca',
                address:
                  'bc1p7cfdjcgyew5ullrmv7hc4rj8v2tc7lesekkv6dyyyhmj2g2uj45q6mh9wz',
                cluster: 3310,
                directStamp: 1753393605,
                timestamp: 1753393605,
                listType: 'Risky sources',
                share: 0.00006325923066083882,
                amountDec: 0.000015687266765760253,
              },
              {
                directTx:
                  'ee1fa6ee410b17ddfe22aa91538efb48d92d318017a25d4eed4510b1b4d0758e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1246.9963847985186,
                amountCur: 1.4685994512290423,
                currency: '',
                tx_hash:
                  'ee1fa6ee410b17ddfe22aa91538efb48d92d318017a25d4eed4510b1b4d0758e',
                address: null,
                directStamp: 1727471206,
                timestamp: 1727471206,
                listType: 'Unknown sources',
                share: 0.00005028538949269195,
                amountDec: 0.000012469963847985186,
              },
              {
                directTx:
                  '5f61aeffd31495be35cf6b2b1f65be0dbc6c3b0862084674977506db67d0beb2',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1092,
                amountCur: 1.2860587410614115,
                currency: '',
                tx_hash:
                  '5f61aeffd31495be35cf6b2b1f65be0dbc6c3b0862084674977506db67d0beb2',
                address: null,
                directStamp: 1743694054,
                timestamp: 1743694054,
                listType: 'Unknown sources',
                share: 0.0000440351279245223,
                amountDec: 0.00001092,
              },
              {
                directTx:
                  '715fe9035b6fbf3dacea84fab801aab9a16dedb35772d9953063f1cf002abc2b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1092,
                amountCur: 1.2860587410614115,
                currency: '',
                tx_hash:
                  '715fe9035b6fbf3dacea84fab801aab9a16dedb35772d9953063f1cf002abc2b',
                address: null,
                directStamp: 1739281536,
                timestamp: 1739281536,
                listType: 'Unknown sources',
                share: 0.0000440351279245223,
                amountDec: 0.00001092,
              },
              {
                directTx:
                  '846c3f880410d009c0d072c548859a1b22a1a8403d1c996feab0a2403cdd6db9',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1092,
                amountCur: 1.2860587410614115,
                currency: '',
                tx_hash:
                  '846c3f880410d009c0d072c548859a1b22a1a8403d1c996feab0a2403cdd6db9',
                address: null,
                directStamp: 1727524308,
                timestamp: 1727524308,
                listType: 'Unknown sources',
                share: 0.0000440351279245223,
                amountDec: 0.00001092,
              },
              {
                directTx:
                  '85a94523924e23056690913d25b9a25ebf3e5173c06b2eb448176e28f7d3cc95',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1092,
                amountCur: 1.2860587410614115,
                currency: '',
                tx_hash:
                  '85a94523924e23056690913d25b9a25ebf3e5173c06b2eb448176e28f7d3cc95',
                address: null,
                directStamp: 1727524902,
                timestamp: 1727524902,
                listType: 'Unknown sources',
                share: 0.0000440351279245223,
                amountDec: 0.00001092,
              },
              {
                directTx:
                  '16cac7cf9f4e32882e5b1f87fd0111828c076916c1681704a771bf03f5efa891',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 1091.9999999999886,
                amountCur: 1.2860587410613982,
                currency: '',
                tx_hash:
                  '16cac7cf9f4e32882e5b1f87fd0111828c076916c1681704a771bf03f5efa891',
                address: null,
                cluster: 3310,
                directStamp: 1720788104,
                timestamp: 1720788104,
                listType: 'Risky sources',
                share: 0.00004403512792452185,
                amountDec: 0.000010919999999999887,
              },
              {
                directTx:
                  '05eb2b6ac6ff199d63dadcb3fe5c9d615afff73122ce648fbea90ecbc51943ea',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 1076.2300485427195,
                amountCur: 1.2674863198913109,
                currency: '',
                tx_hash:
                  '05eb2b6ac6ff199d63dadcb3fe5c9d615afff73122ce648fbea90ecbc51943ea',
                address:
                  'bc1pvx60tkscfxt7lmkdcrf4wwctcrcjxlvmllsuqc8zcqdqay30nefqm8qyw2',
                cluster: 3310,
                directStamp: 1685911803,
                timestamp: 1685911803,
                listType: 'Risky sources',
                share: 0.00004339920134047024,
                amountDec: 0.000010762300485427195,
              },
              {
                directTx:
                  '071bb9efd52dc286b25c75bafd3a0d4aab2d866aed47e197ed6bf10b065c52dd',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1000,
                amountCur: 1.1777094698364574,
                currency: '',
                tx_hash:
                  '071bb9efd52dc286b25c75bafd3a0d4aab2d866aed47e197ed6bf10b065c52dd',
                address: null,
                directStamp: 1723109149,
                timestamp: 1723109149,
                listType: 'Unknown sources',
                share: 0.000040325208722090024,
                amountDec: 0.00001,
              },
              {
                directTx:
                  '201e535b4f6cbc53166971a54c083c660fb2b89ac3073b19c933c904e22447f6',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1000,
                amountCur: 1.1777094698364574,
                currency: '',
                tx_hash:
                  '201e535b4f6cbc53166971a54c083c660fb2b89ac3073b19c933c904e22447f6',
                address: null,
                directStamp: 1726090076,
                timestamp: 1726090076,
                listType: 'Unknown sources',
                share: 0.000040325208722090024,
                amountDec: 0.00001,
              },
              {
                directTx:
                  '59ff5e28c821619ca7708cf1a001a986fd97e57b8e8667fb338a19d5da3f5512',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1000,
                amountCur: 1.1777094698364574,
                currency: '',
                tx_hash:
                  '59ff5e28c821619ca7708cf1a001a986fd97e57b8e8667fb338a19d5da3f5512',
                address: null,
                directStamp: 1688492919,
                timestamp: 1688492919,
                listType: 'Unknown sources',
                share: 0.000040325208722090024,
                amountDec: 0.00001,
              },
              {
                directTx:
                  '720476200cd93ddb6998f7917f11a44a9a054b5a336b8e687f010f16b04aa71f',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1000,
                amountCur: 1.1777094698364574,
                currency: '',
                tx_hash:
                  '720476200cd93ddb6998f7917f11a44a9a054b5a336b8e687f010f16b04aa71f',
                address: null,
                directStamp: 1688412345,
                timestamp: 1688412345,
                listType: 'Unknown sources',
                share: 0.000040325208722090024,
                amountDec: 0.00001,
              },
              {
                directTx:
                  'be841ea33edf5eeb2f01b9f6e370c6eec4bd6ce24524ffd138d85e4523a34fe0',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1000,
                amountCur: 1.1777094698364574,
                currency: '',
                tx_hash:
                  'be841ea33edf5eeb2f01b9f6e370c6eec4bd6ce24524ffd138d85e4523a34fe0',
                address: null,
                directStamp: 1709417356,
                timestamp: 1709417356,
                listType: 'Unknown sources',
                share: 0.000040325208722090024,
                amountDec: 0.00001,
              },
              {
                directTx:
                  'df5875ad83a465d326a4fe3d6b16544c7866aa12d2d4b58bc4cde1cdc60046c1',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1000,
                amountCur: 1.1777094698364574,
                currency: '',
                tx_hash:
                  'df5875ad83a465d326a4fe3d6b16544c7866aa12d2d4b58bc4cde1cdc60046c1',
                address: null,
                directStamp: 1709422641,
                timestamp: 1709422641,
                listType: 'Unknown sources',
                share: 0.000040325208722090024,
                amountDec: 0.00001,
              },
              {
                directTx:
                  '964f8dfe2de3cbcf893e2490940806d0244efa57ae332038499aec690af44a05',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 990.0000000000003,
                amountCur: 1.1659323751380932,
                currency: '',
                tx_hash:
                  '964f8dfe2de3cbcf893e2490940806d0244efa57ae332038499aec690af44a05',
                address: 'bc1qrcuzahl3kejqdmfz0zz777vq3287ch8hqtq6fj',
                cluster: 3310,
                directStamp: 1733336598,
                timestamp: 1733336598,
                listType: 'Risky sources',
                share: 0.00003992195663486913,
                amountDec: 0.000009900000000000003,
              },
              {
                directTx:
                  'f5432ef6a50e377359683e6abcf81d45b707b1679a628d03d1a9cbd14f655532',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 950.4355648535565,
                amountCur: 1.119336965197396,
                currency: '',
                tx_hash:
                  'f5432ef6a50e377359683e6abcf81d45b707b1679a628d03d1a9cbd14f655532',
                address: null,
                directStamp: 1688443397,
                timestamp: 1688443397,
                listType: 'Unknown sources',
                share: 0.00003832651252961719,
                amountDec: 0.000009504355648535564,
              },
              {
                directTx:
                  '8afdb93dabf2e612ccb90c2fbc355293c128ae6d7ac27ca8a84df7d1dccfea7d',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 888,
                amountCur: 1.045806009214774,
                currency: '',
                tx_hash:
                  '8afdb93dabf2e612ccb90c2fbc355293c128ae6d7ac27ca8a84df7d1dccfea7d',
                address: null,
                directStamp: 1714190961,
                timestamp: 1714190961,
                listType: 'Unknown sources',
                share: 0.000035808785345215936,
                amountDec: 0.00000888,
              },
              {
                directTx:
                  '65858512b8e6498d90e186f9950de5bc8f6e3c3b87e38e48e4ad6f24855c028f',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 823.5416053530278,
                amountCur: 0.9698927474285793,
                currency: '',
                tx_hash:
                  '65858512b8e6498d90e186f9950de5bc8f6e3c3b87e38e48e4ad6f24855c028f',
                address:
                  'bc1p7en40zu9hmf9d3luh8evmfyg655pu5k2gtna6j7zr623f9tz7z0stfnwav',
                cluster: 3310,
                directStamp: 1690493629,
                timestamp: 1690493629,
                listType: 'Risky sources',
                share: 0.00003320948712718593,
                amountDec: 0.000008235416053530278,
              },
              {
                directTx:
                  '55043f0e434ec7c1a4d05eab68a469ea8c6a6d917801acc364542dbd7d836cec',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 503.7732921532982,
                amountCur: 0.5932985768196276,
                currency: '',
                tx_hash:
                  '55043f0e434ec7c1a4d05eab68a469ea8c6a6d917801acc364542dbd7d836cec',
                address:
                  'bc1pywt4kpaxymww6n7kyv08xk77whkk60qgvpqz48smwlq3f78cejhqt0peak',
                cluster: 3310,
                directStamp: 1700983659,
                timestamp: 1700983659,
                listType: 'Risky sources',
                share: 0.000020314763154696185,
                amountDec: 0.000005037732921532982,
              },
              {
                directTx:
                  'c300b8e26ac66fc626e4649ea1aaec977a02be33429af9ac50a36086208c3f1d',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 498.1679332017806,
                amountCur: 0.5866970925005928,
                currency: '',
                tx_hash:
                  'c300b8e26ac66fc626e4649ea1aaec977a02be33429af9ac50a36086208c3f1d',
                address: 'bc1q5fj3hs35n663juh7q3fp3uvm43nkcd57ec4qfp',
                cluster: 3310,
                directStamp: 1700985977,
                timestamp: 1700985977,
                listType: 'Risky sources',
                share: 0.000020088725885014,
                amountDec: 0.000004981679332017806,
              },
              {
                directTx:
                  'df06ce2d6b39d711f0c52df89f09f3c272d5df9e273c25e4d2bff9a9d3f9268e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 478.7022619673856,
                amountCur: 0.5637721871511227,
                currency: '',
                tx_hash:
                  'df06ce2d6b39d711f0c52df89f09f3c272d5df9e273c25e4d2bff9a9d3f9268e',
                address:
                  'bc1pu5wdv0l7w9dklspze6cg23w388sneu2yprxdgdr6eshpju8rvxrqrqmvy8',
                cluster: 3310,
                directStamp: 1688155292,
                timestamp: 1688155292,
                listType: 'Risky sources',
                share: 0.00001930376862957144,
                amountDec: 0.000004787022619673856,
              },
              {
                directTx:
                  'a8e214e6d39166c8e52f14b1ba0d8bf9c524b8fe77f5a553ada13bac2f1eccc7',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 471.86515748031496,
                amountCur: 0.5557200644504382,
                currency: '',
                tx_hash:
                  'a8e214e6d39166c8e52f14b1ba0d8bf9c524b8fe77f5a553ada13bac2f1eccc7',
                address:
                  'bc1pv70ew5zpjpehtyg265f5rr64w67xzl47zcusvrhz088jdc8y78dsmefwja',
                cluster: 3310,
                directStamp: 1723110185,
                timestamp: 1723110185,
                listType: 'Risky sources',
                share: 0.00001902806096407558,
                amountDec: 0.00000471865157480315,
              },
              {
                directTx:
                  '15647244c22f471bb0a0c4a9c7360a3c5e25276f9c5e4b2eca00542cdd2a053e',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 405.8535197819903,
                amountCur: 0.477977533613708,
                currency: '',
                tx_hash:
                  '15647244c22f471bb0a0c4a9c7360a3c5e25276f9c5e4b2eca00542cdd2a053e',
                address:
                  'bc1pq5z0hvxnewyz2kr40j4d32nx9tn0jx0vvdsvjnlckjekyhdm0j6qh7w6hf',
                cluster: 3310,
                directStamp: 1713567412,
                timestamp: 1713567412,
                listType: 'Risky sources',
                share: 0.00001636612789580365,
                amountDec: 0.000004058535197819903,
              },
              {
                directTx:
                  '8b9e53acca797787e02c4942e7f503102767fee40f5b17999946b3986bb05bde',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 401.1420628697698,
                amountCur: 0.47242880619145944,
                currency: '',
                tx_hash:
                  '8b9e53acca797787e02c4942e7f503102767fee40f5b17999946b3986bb05bde',
                address:
                  'bc1p5a648pn4crxa94t2xhk856pqnjel0d0e5s0h08f090l755zemu2sznsa3v',
                cluster: 3310,
                directStamp: 1734555799,
                timestamp: 1734555799,
                listType: 'Risky sources',
                share: 0.000016176137412433224,
                amountDec: 0.000004011420628697698,
              },
              {
                directTx:
                  '0fe8c963d51817281b3964fda824e2b6b8ca960c608bb35ecd1c6185e89e7813',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 327.5594748894974,
                amountCur: 0.38576989551201835,
                currency: '',
                tx_hash:
                  '0fe8c963d51817281b3964fda824e2b6b8ca960c608bb35ecd1c6185e89e7813',
                address:
                  'bc1p7en40zu9hmf9d3luh8evmfyg655pu5k2gtna6j7zr623f9tz7z0stfnwav',
                cluster: 3310,
                directStamp: 1701462589,
                timestamp: 1701462589,
                listType: 'Risky sources',
                share: 0.000013208904193817187,
                amountDec: 0.0000032755947488949738,
              },
              {
                directTx:
                  '6969004b76384b994117e509a3d084149775675e20dc6baa2f4414349a433d40',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 154.86118478006955,
                amountCur: 0.18238148382558136,
                currency: '',
                tx_hash:
                  '6969004b76384b994117e509a3d084149775675e20dc6baa2f4414349a433d40',
                address:
                  'bc1plfztd3der66av2mt7cqk3uw6mgatey60nh5v2jdkl8kef92mksjs5fltw4',
                cluster: 3310,
                directStamp: 1711998239,
                timestamp: 1711998239,
                listType: 'Risky sources',
                share: 0.000006244809599206455,
                amountDec: 0.0000015486118478006956,
              },
              {
                directTx:
                  'f5432ef6a50e377359683e6abcf81d45b707b1679a628d03d1a9cbd14f655532',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 122.56443514644351,
                amountCur: 0.14434529593712286,
                currency: '',
                tx_hash:
                  'f5432ef6a50e377359683e6abcf81d45b707b1679a628d03d1a9cbd14f655532',
                address:
                  'bc1pvn6lq6d4vhhcvwrlmz4r63jaf9lg5hn2ec00m7eznjc2wwy69aqs7fve0d',
                cluster: 110473091,
                directStamp: 1688443397,
                timestamp: 1688443397,
                listType: 'Unknown sources',
                share: 0.000004942436429185401,
                amountDec: 0.0000012256443514644352,
              },
              {
                directTx:
                  'c71532f59c552615242a13d9e0876545a1a1bde163f5340712a204fa9b963caf',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 100.31878245874356,
                amountCur: 0.11814638010412577,
                currency: '',
                tx_hash:
                  'c71532f59c552615242a13d9e0876545a1a1bde163f5340712a204fa9b963caf',
                address:
                  'bc1p0p94s9zy4wcnhnlhq6hpgfd5zl36lmcw32g6mekhr3l8upcpek8sv0fnp0',
                cluster: 3310,
                directStamp: 1738861309,
                timestamp: 1738861309,
                listType: 'Risky sources',
                share: 0.000004045375841394777,
                amountDec: 0.0000010031878245874356,
              },
            ],
            currencies: {},
          },
        },
        {
          type: 'uof',
          status: 'UOF Found',
          data: {
            sources: [
              {
                directTx:
                  'a0a004812174dac9081e6e54a954affc9046d0ae4e981126bcc86bffec120561',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 1,
                amount: 2300000.0000000005,
                amountCur: 2708.7317806238525,
                currency: '',
                tx_hash:
                  'a0a004812174dac9081e6e54a954affc9046d0ae4e981126bcc86bffec120561',
                address: '1HoQLPurLCJXHHxz3wDkUCVo52xZttwPCB',
                cluster: 34203831,
                directStamp: 1701273376,
                timestamp: 1701273376,
                listType: 'Known sources',
                share: 0.09938704860510914,
                amountDec: 0.023000000000000003,
              },
              {
                directTx:
                  '5fa09ef15e14007e97f16bf103cb5359ab56d708b00a82e52208953f8d9d358f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                },
                owner: 'KuCoin',
                depth: 1,
                amount: 2040000,
                amountCur: 2402.527318466373,
                currency: '',
                tx_hash:
                  '5fa09ef15e14007e97f16bf103cb5359ab56d708b00a82e52208953f8d9d358f',
                address: '3ETwyvEscCiMCqZhy4cyFmMc9Kj45LwB9o',
                cluster: 36804785,
                directStamp: 1701593763,
                timestamp: 1701593763,
                listType: 'Known sources',
                share: 0.08815199093670546,
                amountDec: 0.0204,
              },
              {
                directTx:
                  'f8605f65b8b5d4830f89eb09861d8abf4f1cb3542d92c7a520c077133f772e04',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 1,
                amount: 1700000.0000000002,
                amountCur: 2002.1060987219778,
                currency: '',
                tx_hash:
                  'f8605f65b8b5d4830f89eb09861d8abf4f1cb3542d92c7a520c077133f772e04',
                address: '1HoQLPurLCJXHHxz3wDkUCVo52xZttwPCB',
                cluster: 34203831,
                directStamp: 1700660323,
                timestamp: 1700660323,
                listType: 'Known sources',
                share: 0.07345999244725457,
                amountDec: 0.017,
              },
              {
                directTx:
                  '4b826bdd7314927411ea4fc9677d43669912e9372effb1560a404c54bdb01006',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 4,
                amount: 1586012.5515456882,
                amountCur: 1867.8620012348395,
                currency: '',
                tx_hash:
                  '4c5681183acab6c1075d3a98e2b431f723cee4fadf35346989c67da31447032d',
                address:
                  'bc1qclndu0gqyjtpk3d5f0akqjwuzq73n2j9lxh9ph5wgfjghj8w4s7sl07pgs',
                directStamp: 1688055893,
                timestamp: 1688055893,
                'address-1':
                  'bc1quamzl2kh29h4gex0vucfk0re2sq576a5mwmgy5wzm0s7hltzcgwqmy29rz',
                listType: 'Unknown sources',
                share: 0.0685343941516454,
                amountDec: 0.01586012551545688,
              },
              {
                directTx:
                  '0529b4d6b279bfb0d04dc145775dbe475dd5f88fb51b0bfdf8303d7f36c7df97',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 1,
                amount: 1500000,
                amountCur: 1766.564204754686,
                currency: '',
                tx_hash:
                  '0529b4d6b279bfb0d04dc145775dbe475dd5f88fb51b0bfdf8303d7f36c7df97',
                address: '1HoQLPurLCJXHHxz3wDkUCVo52xZttwPCB',
                cluster: 34203831,
                directStamp: 1700906677,
                timestamp: 1700906677,
                listType: 'Known sources',
                share: 0.06481764039463637,
                amountDec: 0.015,
              },
              {
                directTx:
                  '25aeed280029f570788fe2e9e29d77c11876a77443aef9b14c9429a86f27af7e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 1,
                amount: 1300000,
                amountCur: 1531.0223107873946,
                currency: '',
                tx_hash:
                  '25aeed280029f570788fe2e9e29d77c11876a77443aef9b14c9429a86f27af7e',
                address: '1GVmVVbRuxr5khuMG1yagimqE4TDCyJmXZ',
                cluster: 96199223,
                directStamp: 1701171716,
                timestamp: 1701171716,
                listType: 'Known sources',
                share: 0.056175288342018195,
                amountDec: 0.013,
              },
              {
                directTx:
                  '4b826bdd7314927411ea4fc9677d43669912e9372effb1560a404c54bdb01006',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 2,
                amount: 900986.7745104566,
                amountCur: 1061.1006565383695,
                currency: '',
                tx_hash:
                  '027c6e589f4f4df1547974a8bff3fa91d43e9b576521f2d6aa81849fb8818a0b',
                address: '1CvFoML59rkCXYSxYjFeXLLbDTjS1ch21o',
                cluster: 34203831,
                directStamp: 1688055893,
                timestamp: 1688055893,
                'address-1':
                  'bc1qy0tmuapg67qhg6gdk8dr5d9eramn52fapettrp5cr2qea6td400suw0cwe',
                listType: 'Known sources',
                share: 0.0389332245003614,
                amountDec: 0.009009867745104566,
              },
              {
                directTx:
                  '05eb2b6ac6ff199d63dadcb3fe5c9d615afff73122ce648fbea90ecbc51943ea',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 839390.4029445255,
                amountCur: 988.5580264376074,
                currency: '',
                tx_hash:
                  '05eb2b6ac6ff199d63dadcb3fe5c9d615afff73122ce648fbea90ecbc51943ea',
                address: '38JsEZeMVD2H4roq5HkfjKM64dsQB11ysS',
                cluster: 3310,
                directStamp: 1685911803,
                timestamp: 1685911803,
                listType: 'Risky sources',
                share: 0.03627153685917812,
                amountDec: 0.008393904029445254,
              },
              {
                directTx:
                  '4b826bdd7314927411ea4fc9677d43669912e9372effb1560a404c54bdb01006',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                },
                owner: 'OKX',
                depth: 4,
                amount: 790339.2758863654,
                amountCur: 930.7900495950611,
                currency: '',
                tx_hash:
                  '4c5681183acab6c1075d3a98e2b431f723cee4fadf35346989c67da31447032d',
                address: '3A3Z58i4PzSFm5Uk77DAsS2R719cexD3LH',
                cluster: 42345622,
                directStamp: 1688055893,
                timestamp: 1688055893,
                'address-1':
                  'bc1quamzl2kh29h4gex0vucfk0re2sq576a5mwmgy5wzm0s7hltzcgwqmy29rz',
                listType: 'Known sources',
                share: 0.034151951316106495,
                amountDec: 0.007903392758863655,
              },
              {
                directTx:
                  '3e83a821fd59ef10cfb07ce2cb6a22adaac30744f1b18790878b0b07a87413e3',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                },
                owner: 'OKX',
                depth: 3,
                amount: 739910.3139013452,
                amountCur: 871.3993835112801,
                currency: '',
                tx_hash:
                  '497976b8a6dbed6043ea2f7f5e5a6662d777b6e26fb65f9dde4cd5d65c676205',
                address: '38nAs9dtFQxboTDnJ4AesnXvLn3MjtCVut',
                cluster: 42345622,
                directStamp: 1719176705,
                timestamp: 1719176705,
                'address-1': 'bc1qq0pv8t7mtmpwx4s5r4v7l25zux4awqzr04h5kq',
                listType: 'Known sources',
                share: 0.03197282710049328,
                amountDec: 0.007399103139013452,
              },
              {
                directTx:
                  'c300b8e26ac66fc626e4649ea1aaec977a02be33429af9ac50a36086208c3f1d',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 604704.1730289503,
                amountCur: 712.1658310258185,
                currency: '',
                tx_hash:
                  'c300b8e26ac66fc626e4649ea1aaec977a02be33429af9ac50a36086208c3f1d',
                address: null,
                cluster: 3310,
                directStamp: 1700985977,
                timestamp: 1700985977,
                listType: 'Risky sources',
                share: 0.026130331755017652,
                amountDec: 0.006047041730289504,
              },
              {
                directTx:
                  'c07761209b5a14f5408be9285aa351a212c67ca5608a9b3836053364d7aebe84',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 2,
                amount: 599072.2822700045,
                amountCur: 705.5330999459236,
                currency: '',
                tx_hash:
                  '51c6b268a651335b9e23d8df8cfa96531c6d15fd496e276acb2c4a1da7034c8e',
                address: '1LAVMSnpFsXRGS9BNssCNM9rQpus3mxSmp',
                cluster: 96199223,
                directStamp: 1732558077,
                timestamp: 1732558077,
                'address-1':
                  'bc1pznks2qgzh5444qa6qvk6alr7uypedgpdmakpzttehc2zn9n4twrq5ejuf6',
                listType: 'Known sources',
                share: 0.025886967841714167,
                amountDec: 0.005990722822700045,
              },
              {
                directTx:
                  '55043f0e434ec7c1a4d05eab68a469ea8c6a6d917801acc364542dbd7d836cec',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 579084.5161678754,
                amountCur: 681.99331852657,
                currency: '',
                tx_hash:
                  '55043f0e434ec7c1a4d05eab68a469ea8c6a6d917801acc364542dbd7d836cec',
                address: null,
                cluster: 3310,
                directStamp: 1700983659,
                timestamp: 1700983659,
                listType: 'Risky sources',
                share: 0.02502326128471423,
                amountDec: 0.005790845161678754,
              },
              {
                directTx:
                  'f1cac543a7d0c3f8db46fe3c94e7ec54e70c166f3543fb418aa75e169fbdb483',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 516814.2559316986,
                amountCur: 608.657043357244,
                currency: '',
                tx_hash:
                  'b96f97af0779b9222f3172e7f735cd49b9f6ff6e56b81912fbcb1c6fa5e79dd9',
                address: 'bc1qfhdpevk5vzda5rlkqruc7vh042v6xmac8guqnr',
                cluster: 113020304,
                directStamp: 1730992752,
                timestamp: 1730992752,
                'address-1': '31h5r2TK9d3VwsUskzQ5vgL6nhnVenpVKE',
                listType: 'Unknown sources',
                share: 0.022332453727868275,
                amountDec: 0.005168142559316986,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: {
                  minimum: 4,
                  maximum: 18,
                },
                amount: 333235.42873096664,
                amountCur: 392.4545201014713,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1733602375,
                timestamp: 1733602375,
                listType: 'Unknown sources',
                share: 0.01439968945749085,
                amountDec: 0.0033323542873096666,
              },
              {
                directTx:
                  '5339dfa1bda0b414f0a6d2ca77eadd0f941d4615780a7375d4776588a7e14305',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 4,
                amount: 255695.88430188468,
                amountCur: 301.13546434053677,
                currency: '',
                tx_hash:
                  '0a8f2720ab61c16a1c41b0caa8644c631806f93b83dfc4d7a38716e95433c0bc',
                address: '1JaLcWmap1HnLMTpwWkG1f7Qg1RsQipf5Q',
                cluster: 63419260,
                directStamp: 1732442617,
                timestamp: 1732442617,
                'address-1': '12q6fkqwieR61nEZHP7DK9mP5UVXvkHPfG',
                listType: 'Unknown sources',
                share: 0.011049069252712073,
                amountDec: 0.002556958843018847,
              },
              {
                directTx:
                  '91a427ab462b15911d50299a771ca4bdf35a285a98d5b361714c96be268b1bad',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                },
                owner: 'MEXC',
                depth: 3,
                amount: 255220.50651238573,
                amountCur: 300.57560741609393,
                currency: '',
                tx_hash:
                  '3d4e9a674eb0277f5d36c44e72046c77feb5b0bfef35130d4cd611501ffff479',
                address: '3HYPdHxkr7EdzyjcBYXqS7QkdMqYmAvPYa',
                cluster: 46904186,
                directStamp: 1753785243,
                timestamp: 1753785243,
                'address-1': 'bc1qr7hu54ncqa4cjac3j9jh54n80lshlrjfj98h79',
                listType: 'Known sources',
                share: 0.011028527341637846,
                amountDec: 0.0025522050651238574,
              },
              {
                directTx:
                  '91a427ab462b15911d50299a771ca4bdf35a285a98d5b361714c96be268b1bad',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 3,
                amount: 186144.81529646902,
                amountCur: 219.2245117356098,
                currency: '',
                tx_hash:
                  'c23caf2eed7d7cd47f3b5c74dc35c476625f9e22f12a2ad4f7aefc2abf698a48',
                address:
                  'bc1p3ryr4fkhxugn4s436alw882tzju7f79c08rcscvkk5yw70wfa4hswhd99m',
                cluster: 3310,
                directStamp: 1753785243,
                timestamp: 1753785243,
                'address-1': 'bc1qpzsm8gyhha4uzv5xj629uk3elcf9y8nf0mdhyj',
                listType: 'Risky sources',
                share: 0.008043645132808358,
                amountDec: 0.0018614481529646903,
              },
              {
                directTx:
                  '5f30bd80b1cca3c2f32f8775ece3222275c14e139f37fbcb22a1dba7e918062a',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 170000,
                amountCur: 200.21060987219775,
                currency: '',
                tx_hash:
                  '5f30bd80b1cca3c2f32f8775ece3222275c14e139f37fbcb22a1dba7e918062a',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1723106276,
                timestamp: 1723106276,
                listType: 'Risky sources',
                share: 0.007345999244725456,
                amountDec: 0.0017,
              },
              {
                directTx:
                  '02e724951642dcaf4e83a3634223dfa185b8af6f7759028a0818c6b3327e6320',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                },
                owner: 'CoinEx',
                depth: 1,
                amount: 167765,
                amountCur: 197.57842920711326,
                currency: '',
                tx_hash:
                  '02e724951642dcaf4e83a3634223dfa185b8af6f7759028a0818c6b3327e6320',
                address: '127Y6BXnqJmYf6LRiMY7UwVopybekbUs7n',
                cluster: 113646335,
                directStamp: 1726355073,
                timestamp: 1726355073,
                listType: 'Known sources',
                share: 0.007249420960537448,
                amountDec: 0.00167765,
              },
              {
                directTx:
                  'd594f0f1dd8581c23ffa632577571c482e51ad874fda661976bfb90267e3e58e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 167238,
                amountCur: 196.95777631650947,
                currency: '',
                tx_hash:
                  '9dc2b64b4d8da9019d36c87fe9250d7cb69dc32baf8e8bc169d374bc927cb570',
                address: null,
                directStamp: 1701131802,
                timestamp: 1701131802,
                listType: 'Unknown sources',
                share: 0.0072266483628787995,
                amountDec: 0.00167238,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 12,
                amount: 158426.05373790587,
                amountCur: 186.57986375595124,
                currency: '',
                tx_hash:
                  '74a7400e637b3634f58c7c4a03d6569a425d6e59a6e570f36d837a5493d8a3bd',
                address: 'bc1qffcga3gdma0utlp25qrjelr5rmny4eejw845qw',
                cluster: 133008365,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1': 'bc1q6eukhhq862xssstrn248uh5fssh5c65u6aprkk',
                listType: 'Unknown sources',
                share: 0.006845868653549947,
                amountDec: 0.0015842605373790587,
              },
              {
                directTx:
                  '4da3c27a240e27f27fd5959410b63476b54510bf5a1cfb5a7439f085998a20de',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 4,
                amount: 143377.31677276932,
                amountCur: 168.85682372303197,
                currency: '',
                tx_hash:
                  '641c14b038d957a91eba171b052277b785c44fb7554af38dc93693db3caa1326',
                address: 'bc1qqav28c9lmsm8a9l2z39l5lstyzlretsk82xgne',
                cluster: 125642039,
                directStamp: 1735820508,
                timestamp: 1735820508,
                'address-1': 'bc1q552zcst6u50nfjh7avj223dagewy8s6yzk9c7f',
                listType: 'Unknown sources',
                share: 0.006195586239550153,
                amountDec: 0.0014337731677276932,
              },
              {
                directTx:
                  'b3f236db4fb787891041c6d89dbd7b358b8b389e833b5d4ace62aae7f2353615',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 140000,
                amountCur: 164.87932577710404,
                currency: '',
                tx_hash:
                  'b3f236db4fb787891041c6d89dbd7b358b8b389e833b5d4ace62aae7f2353615',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1738846123,
                timestamp: 1738846123,
                listType: 'Risky sources',
                share: 0.0060496464368327285,
                amountDec: 0.0014,
              },
              {
                directTx:
                  'b4bd9e4ce767e8db6aa728f1be8ee4a6228abcc5ab7e2f7071d7352b8203500b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 140000,
                amountCur: 164.87932577710404,
                currency: '',
                tx_hash:
                  'b4bd9e4ce767e8db6aa728f1be8ee4a6228abcc5ab7e2f7071d7352b8203500b',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1738793173,
                timestamp: 1738793173,
                listType: 'Risky sources',
                share: 0.0060496464368327285,
                amountDec: 0.0014,
              },
              {
                directTx:
                  '4da3c27a240e27f27fd5959410b63476b54510bf5a1cfb5a7439f085998a20de',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: {
                  minimum: 11,
                  maximum: 12,
                },
                amount: 135720.9481241855,
                amountCur: 159.83984586103583,
                currency: '',
                tx_hash:
                  'f37043f5cab8cd7b4ed2691b18d1d05db4ef8d2f6bdb23bc14d61ded554b677c',
                address: 'bc1q7uzjlx7z0ytwcf29rz4rr7cgpley3zp62mpry9',
                cluster: 96293955,
                directStamp: 1735820508,
                timestamp: 1735820508,
                'address-1': '1Ch1tQubHugzQisLHcKuEARTUUWWr7p9vN',
                listType: 'Unknown sources',
                share: 0.005864741073021702,
                amountDec: 0.001357209481241855,
              },
              {
                directTx:
                  '4da3c27a240e27f27fd5959410b63476b54510bf5a1cfb5a7439f085998a20de',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 11,
                amount: 132546.633932033,
                amountCur: 156.10142597670156,
                currency: '',
                tx_hash:
                  '6e488ef735b02a7356e020f694e9368c86a38b859f3c4ea58212e6db75621a0f',
                address: 'bc1q7uzjlx7z0ytwcf29rz4rr7cgpley3zp62mpry9',
                cluster: 96293955,
                directStamp: 1735820508,
                timestamp: 1735820508,
                'address-1': '1Ch1tQubHugzQisLHcKuEARTUUWWr7p9vN',
                listType: 'Unknown sources',
                share: 0.005727573369150681,
                amountDec: 0.00132546633932033,
              },
              {
                directTx:
                  'bbb960a5ce973649d0bb9c12dafe2a39a47d6829f3c6a7dbadfd45bc4f77c089',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 127720,
                amountCur: 150.41705348751233,
                currency: '',
                tx_hash:
                  'bdb94c5a1d93ae7f7321d6ecf0b30b474a8b850a092ea6f63344a9be6a483813',
                address:
                  'bc1pzrm866nkj9acysru4jv0ayd7gmnawkfyesc4r26uwppjmfy40qxqve7flq',
                cluster: 111514160,
                directStamp: 1687728319,
                timestamp: 1687728319,
                'address-1':
                  'bc1pllvwgwyrwpyjz3lxtmgremjlg9nmwjsnhskqy5fef9p8n63g6m8q42e8nl',
                listType: 'Unknown sources',
                share: 0.005519006020801972,
                amountDec: 0.0012772,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 13,
                amount: 121178.60986095594,
                amountCur: 142.71319637486533,
                currency: '',
                tx_hash:
                  'f93061f2c9ad010bc309e3e93eb4e6fb41bc995fce570b8ef97fede0539ae416',
                address:
                  'bc1pu87l9vs3854v6rpq4xjse9j359l07fcnuzluzwucldkv09ku7waqnk247w',
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1':
                  'bc1ptcvzax3gxg8vdep5kqm36tnl3mxhakcs0dsercuz9pdfqyxvuhks5ntect',
                listType: 'Unknown sources',
                share: 0.005236341038326253,
                amountDec: 0.0012117860986095594,
              },
              {
                directTx:
                  'c71532f59c552615242a13d9e0876545a1a1bde163f5340712a204fa9b963caf',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 120106.07756010507,
                amountCur: 141.45006492744778,
                currency: '',
                tx_hash:
                  'c71532f59c552615242a13d9e0876545a1a1bde163f5340712a204fa9b963caf',
                address: '33NgDRCCRvrXV4YiYN6cSCoR4sufsSvZHK',
                directStamp: 1738861309,
                timestamp: 1738861309,
                listType: 'Unknown sources',
                share: 0.005189995029667464,
                amountDec: 0.0012010607756010507,
              },
              {
                directTx:
                  '28101a4dcca77665d79ac634763d2d40db44b8c7f23822749525d753d3faf938',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 109620,
                amountCur: 129.10051208347247,
                currency: '',
                tx_hash:
                  '28101a4dcca77665d79ac634763d2d40db44b8c7f23822749525d753d3faf938',
                address: null,
                directStamp: 1701093207,
                timestamp: 1701093207,
                listType: 'Unknown sources',
                share: 0.004736873160040026,
                amountDec: 0.0010962,
              },
              {
                directTx:
                  '1d8e83e0003b7f2555750096c63bbe3a037e9d30d3d6e2030d71b1ccee9521c4',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 103000,
                amountCur: 121.30407539315512,
                currency: '',
                tx_hash:
                  '1d8e83e0003b7f2555750096c63bbe3a037e9d30d3d6e2030d71b1ccee9521c4',
                address:
                  'bc1pqul85v7r7yad2xu0p7uutak25rempama0g73y5vdpdn46zwjmjcsfryfxa',
                cluster: 3310,
                directStamp: 1689622970,
                timestamp: 1689622970,
                listType: 'Risky sources',
                share: 0.004450811307098365,
                amountDec: 0.00103,
              },
              {
                directTx:
                  '6969004b76384b994117e509a3d084149775675e20dc6baa2f4414349a433d40',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 99172.56400038477,
                amountCur: 116.79646777121528,
                currency: '',
                tx_hash:
                  '6969004b76384b994117e509a3d084149775675e20dc6baa2f4414349a433d40',
                address: '3GdNL7BZHUxk5vBya1QWSAmzcz3p9YXo6e',
                directStamp: 1711998239,
                timestamp: 1711998239,
                listType: 'Unknown sources',
                share: 0.004285421060260667,
                amountDec: 0.0009917256400038476,
              },
              {
                directTx:
                  '5cd3c12b3d230cea04a6954bdcb919f8f499b87036e7dd384a8ba73b384ee588',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 90252,
                amountCur: 106.29063507167996,
                currency: '',
                tx_hash:
                  '5cd3c12b3d230cea04a6954bdcb919f8f499b87036e7dd384a8ba73b384ee588',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1711998239,
                timestamp: 1711998239,
                listType: 'Risky sources',
                share: 0.003899947787264482,
                amountDec: 0.00090252,
              },
              {
                directTx:
                  '8b958dddab75042d8501cdf2b632dc92c182d0ede8aeafa1343795deea710a00',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 90190.00000000001,
                amountCur: 106.21761708455011,
                currency: '',
                tx_hash:
                  '8b958dddab75042d8501cdf2b632dc92c182d0ede8aeafa1343795deea710a00',
                address: null,
                cluster: 3310,
                directStamp: 1709397226,
                timestamp: 1709397226,
                listType: 'Risky sources',
                share: 0.0038972686581281706,
                amountDec: 0.0009019000000000002,
              },
              {
                directTx:
                  'aa7d4fe9b8e7682e3d13904c36de09362c4ab0a1c7b9b557e942d5f110615633',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 90054,
                amountCur: 106.05744859665234,
                currency: '',
                tx_hash:
                  '9e1e7764f74ca231e00189699369675d42d906b168fa15d1ed73f51b4198c67e',
                address: null,
                directStamp: 1701095294,
                timestamp: 1701095294,
                listType: 'Unknown sources',
                share: 0.0038913918587323896,
                amountDec: 0.00090054,
              },
              {
                directTx:
                  '4da3c27a240e27f27fd5959410b63476b54510bf5a1cfb5a7439f085998a20de',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: {
                  minimum: 14,
                  maximum: 15,
                },
                amount: 85699.32542874826,
                amountCur: 100.92890711603314,
                currency: '',
                tx_hash:
                  '362ff49742b8c125a34c3e85f7e9ab604a3f09740d72a36d8cd5020c74a23ea9',
                address: null,
                cluster: 96906642,
                directStamp: 1735820508,
                timestamp: 1735820508,
                'address-1': '1LFqfvMLs5hWGpXR9d94aLUyy1mui7u5Rq',
                listType: 'Unknown sources',
                share: 0.003703218705135681,
                amountDec: 0.0008569932542874826,
              },
              {
                directTx:
                  '75791eb4ce1b74262fa8cca99bed589f80dfeb7beed5ec3a9aea5cf61d8b4446',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 82000,
                amountCur: 96.5721765265895,
                currency: '',
                tx_hash:
                  '75791eb4ce1b74262fa8cca99bed589f80dfeb7beed5ec3a9aea5cf61d8b4446',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1700684430,
                timestamp: 1700684430,
                listType: 'Risky sources',
                share: 0.003543364341573455,
                amountDec: 0.00082,
              },
              {
                directTx:
                  '5339dfa1bda0b414f0a6d2ca77eadd0f941d4615780a7375d4776588a7e14305',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 5,
                amount: 81416.6526462581,
                amountCur: 95.88516282388362,
                currency: '',
                tx_hash:
                  '459453e729214d87c05555932c6f92da011f6523572a0fd1dec1c31bc06fd1de',
                address: '1JaLcWmap1HnLMTpwWkG1f7Qg1RsQipf5Q',
                cluster: 63419260,
                directStamp: 1732442617,
                timestamp: 1732442617,
                'address-1': '12q6fkqwieR61nEZHP7DK9mP5UVXvkHPfG',
                listType: 'Unknown sources',
                share: 0.003518156875573451,
                amountDec: 0.000814166526462581,
              },
              {
                directTx:
                  '1e93f947ef69ff4df119698235b6a050b0d3026df96ed3e1cf645c6dda7c38bc',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 80000,
                amountCur: 94.21675758691659,
                currency: '',
                tx_hash:
                  '1e93f947ef69ff4df119698235b6a050b0d3026df96ed3e1cf645c6dda7c38bc',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1708458835,
                timestamp: 1708458835,
                listType: 'Risky sources',
                share: 0.003456940821047273,
                amountDec: 0.0008,
              },
              {
                directTx:
                  'ac0028360c8b0743e3d0d281c78171414b63416ba142ba383a327ad8abd5ddd7',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 80000,
                amountCur: 94.21675758691659,
                currency: '',
                tx_hash:
                  'ac0028360c8b0743e3d0d281c78171414b63416ba142ba383a327ad8abd5ddd7',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1701462589,
                timestamp: 1701462589,
                listType: 'Risky sources',
                share: 0.003456940821047273,
                amountDec: 0.0008,
              },
              {
                directTx:
                  '6aa73c00de0a9b108f11eee9daeafcdd9390b631d2a75915afffeb07fb23a13b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 72180,
                amountCur: 85.0070695327955,
                currency: '',
                tx_hash:
                  '6aa73c00de0a9b108f11eee9daeafcdd9390b631d2a75915afffeb07fb23a13b',
                address:
                  'bc1pq4v5gcw2kc3zl9uhthjnatxczhg5kca5rm5ccqsalarlx84e4uuq7zte7t',
                directStamp: 1686089286,
                timestamp: 1686089286,
                listType: 'Unknown sources',
                share: 0.0031190248557899027,
                amountDec: 0.0007218,
              },
              {
                directTx:
                  '4da3c27a240e27f27fd5959410b63476b54510bf5a1cfb5a7439f085998a20de',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: {
                  minimum: 3,
                  maximum: 14,
                },
                amount: 67368.55548598965,
                amountCur: 79.34058576505284,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1735820508,
                timestamp: 1735820508,
                listType: 'Unknown sources',
                share: 0.0029111138689313235,
                amountDec: 0.0006736855548598965,
              },
              {
                directTx:
                  '83fd0b57472e7bd670b41dbe7f2efa450ecea278c8268020fb2056b40104b94a',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 2,
                amount: 65151.17518099525,
                amountCur: 76.72915598163208,
                currency: '',
                tx_hash:
                  'fd7f009ee0c53b489ef50ccbbbceb0fe554b64f251f18d54755fa09a904c63f0',
                address: '12ZRwT7ufnk2YB6pmw8piBDX3wPDBLC7Hv',
                cluster: 34203831,
                directStamp: 1689963589,
                timestamp: 1689963589,
                'address-1': '322RXCej5QBu9aFbfDFVTkxJmisNbEhMPK',
                listType: 'Known sources',
                share: 0.0028152969627798057,
                amountDec: 0.0006515117518099525,
              },
              {
                directTx:
                  '3e83a821fd59ef10cfb07ce2cb6a22adaac30744f1b18790878b0b07a87413e3',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 2,
                amount: 64419,
                amountCur: 75.86686633739475,
                currency: '',
                tx_hash:
                  '59c5901d274b7e89bc6caab7ac648cdd0ad02512a9aa535053dc59d83fbc5776',
                address: 'bc1qm8fqpt33cp22x4w0er7sen4wstwnmlmc6y0ccz',
                cluster: 3310,
                directStamp: 1719176705,
                timestamp: 1719176705,
                'address-1':
                  'bc1pe05hvy9f7ktvt3stt7x3s8ujt59kpn9afzre3ug804cavum5kmnqlvlxxg',
                listType: 'Risky sources',
                share: 0.002783658384388054,
                amountDec: 0.00064419,
              },
              {
                directTx:
                  '5339dfa1bda0b414f0a6d2ca77eadd0f941d4615780a7375d4776588a7e14305',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: {
                  minimum: 2,
                  maximum: 8,
                },
                amount: 62828.225116217836,
                amountCur: 73.9933956923865,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1732442617,
                timestamp: 1732442617,
                listType: 'Unknown sources',
                share: 0.0027149182014775124,
                amountDec: 0.0006282822511621784,
              },
              {
                directTx:
                  '74b196630951797fc1abe81efa0355cc7e4b51d74ad8eb6eddc3c4cdd49b37e8',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 60000,
                amountCur: 70.66256819018744,
                currency: '',
                tx_hash:
                  '74b196630951797fc1abe81efa0355cc7e4b51d74ad8eb6eddc3c4cdd49b37e8',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1688414313,
                timestamp: 1688414313,
                listType: 'Risky sources',
                share: 0.002592705615785455,
                amountDec: 0.0006,
              },
              {
                directTx:
                  'ecd6fb414a75c4cf5ed6625f8e478a6741f36dae611b18d0ce6669c4ef24c1c2',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 59999.99999999999,
                amountCur: 70.66256819018743,
                currency: '',
                tx_hash:
                  'ecd6fb414a75c4cf5ed6625f8e478a6741f36dae611b18d0ce6669c4ef24c1c2',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1687728319,
                timestamp: 1687728319,
                listType: 'Risky sources',
                share: 0.0025927056157854546,
                amountDec: 0.0006,
              },
              {
                directTx:
                  '5237264dd455cb7ef799249c984d088c3cef10f4667e60ed96e5a9a185ed078a',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 54472,
                amountCur: 64.1521902409315,
                currency: '',
                tx_hash:
                  '306acfc8add3ded916f8c6f1f24eee0dbe85f5d138bfd84edf26b7a04ac6157d',
                address: null,
                directStamp: 1700651668,
                timestamp: 1700651668,
                listType: 'Unknown sources',
                share: 0.0023538310050510883,
                amountDec: 0.00054472,
              },
              {
                directTx:
                  'a34eac1c587c38e69694c061fc0047e100479472a2b49d2fe28ef319a96dc373',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 50000,
                amountCur: 58.88547349182287,
                currency: '',
                tx_hash:
                  'a34eac1c587c38e69694c061fc0047e100479472a2b49d2fe28ef319a96dc373',
                address:
                  'bc1p2eh3c6e5n087lgz8pz7y25jceancklcddsx67jg8sk3famzylhjqn3gxpg',
                cluster: 3310,
                directStamp: 1723619729,
                timestamp: 1723619729,
                listType: 'Risky sources',
                share: 0.0021605880131545458,
                amountDec: 0.0005,
              },
              {
                directTx:
                  'ac4c9bf1c812c8d928780abe1605497b1f4f9d7959be60ae3b253451e0cd481e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 50000,
                amountCur: 58.88547349182287,
                currency: '',
                tx_hash:
                  'ac4c9bf1c812c8d928780abe1605497b1f4f9d7959be60ae3b253451e0cd481e',
                address:
                  'bc1p6zgg8j70qdxjly75mrk7clsqfaydvfskf27e6cfnhwmd2w4vn55shycuxr',
                cluster: 3310,
                directStamp: 1688155822,
                timestamp: 1688155822,
                listType: 'Risky sources',
                share: 0.0021605880131545458,
                amountDec: 0.0005,
              },
              {
                directTx:
                  'cdb3faf6b3b646aa211758801addd0d8feb0b5ffb80e215b72fcd5cb4e385b40',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 49916,
                amountCur: 58.78654589635661,
                currency: '',
                tx_hash:
                  'cdb3faf6b3b646aa211758801addd0d8feb0b5ffb80e215b72fcd5cb4e385b40',
                address:
                  'bc1pzjmzv3vnypdhcca6tutyy3kz7kxcv68zxvs8cas7qj6fdy8pu75qd8ec2h',
                cluster: 3310,
                directStamp: 1720713112,
                timestamp: 1720713112,
                listType: 'Risky sources',
                share: 0.002156958225292446,
                amountDec: 0.00049916,
              },
              {
                directTx:
                  'd594f0f1dd8581c23ffa632577571c482e51ad874fda661976bfb90267e3e58e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 49256,
                amountCur: 58.009257646264544,
                currency: '',
                tx_hash:
                  '9dc2b64b4d8da9019d36c87fe9250d7cb69dc32baf8e8bc169d374bc927cb570',
                address: 'bc1qyu6spknuyqcr8g90r6llnczf09h57gc2a9qnsf',
                cluster: 110126834,
                directStamp: 1701131802,
                timestamp: 1701131802,
                'address-1':
                  'bc1pvfd3svwcrtl0j2j8w5crxgff8z8ge7q2t67m02mh97psxcep9j5sstvyhy',
                listType: 'Unknown sources',
                share: 0.002128438463518806,
                amountDec: 0.00049256,
              },
              {
                directTx:
                  'ca5fc57d4b98ab367672b5587d3863b1d0da16b13fa3008cec603423d13d3e24',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 4,
                amount: 48399.797903255516,
                amountCur: 57.00090032883473,
                currency: '',
                tx_hash:
                  '03812fcdf0e2e26cb20a1ad6098e1ef91a7ba2a7f2676c813f2e0bbd909dfe9a',
                address: 'bc1qy7vhjgcpu7dxp4elj4tt66422p7r8jusyepev7',
                cluster: 34203831,
                directStamp: 1691687044,
                timestamp: 1691687044,
                'address-1':
                  'bc1pdxehu9ycy9e6a9wy4627rs0sal404ps46q268txpdzdvn3cmc5kq04c4qa',
                listType: 'Known sources',
                share: 0.0020914404637775276,
                amountDec: 0.0004839979790325552,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'maximum depth reached',
                  score: 50,
                  id: '61e08b592536c394af97d392',
                  default: true,
                },
                owner: 'maximum depth reached',
                depth: 20,
                amount: 47520.89116996734,
                amountCur: 55.96580354593823,
                currency: '',
                tx_hash:
                  '6726ed456616fa9e0c8e59c68101c05ca525a5d7b008c2836e883d4dced64d18',
                address: null,
                directStamp: 1687958689,
                timestamp: 1687958689,
                listType: 'Unknown sources',
                share: 0.002053461356725063,
                amountDec: 0.0004752089116996734,
              },
              {
                directTx:
                  'd67a54960546a9f27b709d92f1ee16c1b53e52518837ed6a6d5cac808d641829',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 6,
                amount: 46751.60626506665,
                amountCur: 55.05980942843444,
                currency: '',
                tx_hash:
                  'f6b4a076db345d3e6137ae5f6dab96387b9673d2ea58844e59f2d96113445f35',
                address: 'bc1qvyuw2kunphjg6h25jw28wjr05jy2ks6qxw2hfm',
                cluster: 96199223,
                directStamp: 1723105790,
                timestamp: 1723105790,
                'address-1':
                  'bc1qlu5lku8cas22ya9dzvnf9hsq0pf4plhj8wr4ktqcq0wsrsxwl8us9lumhx',
                listType: 'Known sources',
                share: 0.0020202192018404794,
                amountDec: 0.0004675160626506665,
              },
              {
                directTx:
                  'cdbe43dab21815b4e9e5769856ef7302d6655f9f88d97501f8aa67439a6eae15',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 4,
                amount: 46438.260382199915,
                amountCur: 54.690779014848026,
                currency: '',
                tx_hash:
                  '03812fcdf0e2e26cb20a1ad6098e1ef91a7ba2a7f2676c813f2e0bbd909dfe9a',
                address: 'bc1qy7vhjgcpu7dxp4elj4tt66422p7r8jusyepev7',
                cluster: 34203831,
                directStamp: 1691677359,
                timestamp: 1691677359,
                'address-1':
                  'bc1pdxehu9ycy9e6a9wy4627rs0sal404ps46q268txpdzdvn3cmc5kq04c4qa',
                listType: 'Known sources',
                share: 0.0020066789746706155,
                amountDec: 0.00046438260382199913,
              },
              {
                directTx:
                  'b60dda866d9e957979c3a1725f0cf0da8a868fcee639ffefd1eb300fbfeb3b16',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 43995,
                amountCur: 51.813328125454944,
                currency: '',
                tx_hash:
                  'b60dda866d9e957979c3a1725f0cf0da8a868fcee639ffefd1eb300fbfeb3b16',
                address: null,
                cluster: 3310,
                directStamp: 1738415551,
                timestamp: 1738415551,
                listType: 'Risky sources',
                share: 0.001901101392774685,
                amountDec: 0.00043995,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 6,
                amount: 42649.426592797776,
                amountCur: 50.228633581432774,
                currency: '',
                tx_hash:
                  'e219dbc03c3c9bd1162e9d36e30aabf57fb47304149be4a69bd4a9bae82d6d40',
                address: '36PGSY1ZJQTmNkd5bcJ7pX71MkBjnysb1J',
                cluster: 3310,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1':
                  'bc1p7x7yfmsqzl2cpn0m6m2zm3lfkktm9e98qls6n59fkjqcg4z4yenq7s7zhw',
                listType: 'Risky sources',
                share: 0.001842956797286272,
                amountDec: 0.00042649426592797774,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 15,
                amount: 40937.967548976245,
                amountCur: 48.21303205828691,
                currency: '',
                tx_hash:
                  '278e88991cfbe711e29a28ff272a6c7d41f39d6d78dc130c5dc2c964c4bd8bd4',
                address: '3CW24NViy1rVCRCxXnHx5sHBx3vTh96XJz',
                cluster: 502154,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1qd4h63phn4qn24cexxqgmqp80dqhx4wpf4pn8gu',
                listType: 'Known sources',
                share: 0.0017690016393845573,
                amountDec: 0.00040937967548976246,
              },
              {
                directTx:
                  '7569b49afb81959e3fb2e2aab3dd911b6028041d2e4f38e3d982cc031fff81cf',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 40000,
                amountCur: 47.10837879345829,
                currency: '',
                tx_hash:
                  '7569b49afb81959e3fb2e2aab3dd911b6028041d2e4f38e3d982cc031fff81cf',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1688157204,
                timestamp: 1688157204,
                listType: 'Risky sources',
                share: 0.0017284704105236365,
                amountDec: 0.0004,
              },
              {
                directTx:
                  '7c30de17060b69db2c0f76dd8069fede16c041da661f25866f96330d7486c954',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 40000,
                amountCur: 47.10837879345829,
                currency: '',
                tx_hash:
                  '7c30de17060b69db2c0f76dd8069fede16c041da661f25866f96330d7486c954',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1688141596,
                timestamp: 1688141596,
                listType: 'Risky sources',
                share: 0.0017284704105236365,
                amountDec: 0.0004,
              },
              {
                directTx:
                  '9237fdd6bf5b1ce2d1498869c5161217b702e96a8cd7dd18ce24a61d7250d84a',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 40000,
                amountCur: 47.10837879345829,
                currency: '',
                tx_hash:
                  '9237fdd6bf5b1ce2d1498869c5161217b702e96a8cd7dd18ce24a61d7250d84a',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1687728606,
                timestamp: 1687728606,
                listType: 'Risky sources',
                share: 0.0017284704105236365,
                amountDec: 0.0004,
              },
              {
                directTx:
                  '8fb560012bc7b7589fffa852b9ef832a4de964238d91dba67df02242812917ae',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 38430,
                amountCur: 45.25937492581506,
                currency: '',
                tx_hash:
                  '8fb560012bc7b7589fffa852b9ef832a4de964238d91dba67df02242812917ae',
                address: null,
                directStamp: 1700692462,
                timestamp: 1700692462,
                listType: 'Unknown sources',
                share: 0.001660627946910584,
                amountDec: 0.0003843,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'maximum depth reached',
                  score: 50,
                  id: '61e08b592536c394af97d392',
                  default: true,
                },
                owner: 'maximum depth reached',
                depth: 20,
                amount: 35688.54166227323,
                amountCur: 42.03073348031213,
                currency: '',
                tx_hash:
                  'a25bbf8e0f149a601c342df397fb7de3c79266adfc6c0a179b90a76144a5682c',
                address: null,
                directStamp: 1733602375,
                timestamp: 1733602375,
                listType: 'Unknown sources',
                share: 0.001542164706449483,
                amountDec: 0.0003568854166227323,
              },
              {
                directTx:
                  '981b523b93e4abbcba38f60641c17e5650e6a697c051d264a67d1e7daecf5f23',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 2,
                amount: 35000,
                amountCur: 41.21983144427601,
                currency: '',
                tx_hash:
                  '59ff5e28c821619ca7708cf1a001a986fd97e57b8e8667fb338a19d5da3f5512',
                address:
                  'bc1p2sd59q7gwugp7gcxj4vqr7h2au3yt7dcy4l2p54ekpvqz9sl5ztqx70gha',
                cluster: 3310,
                directStamp: 1688492919,
                timestamp: 1688492919,
                'address-1':
                  'bc1pnqg2c3txv6hzeczk7ax36ft6geh33yuu6njx7s3pzqg9vvyrsmws64tgn4',
                listType: 'Risky sources',
                share: 0.0015124116092081821,
                amountDec: 0.00035,
              },
              {
                directTx:
                  'd80489fba0bc2161e49502555eb21c214e75e9fc9e848b689dadde356f6c9212',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 2,
                amount: 35000,
                amountCur: 41.21983144427601,
                currency: '',
                tx_hash:
                  '720476200cd93ddb6998f7917f11a44a9a054b5a336b8e687f010f16b04aa71f',
                address:
                  'bc1p2sd59q7gwugp7gcxj4vqr7h2au3yt7dcy4l2p54ekpvqz9sl5ztqx70gha',
                cluster: 3310,
                directStamp: 1688412345,
                timestamp: 1688412345,
                'address-1':
                  'bc1p5gnvuldzufja6xp9gz7p74ylecfzqt00chlpwcrkm8phhcp6rlmq9nt5ah',
                listType: 'Risky sources',
                share: 0.0015124116092081821,
                amountDec: 0.00035,
              },
              {
                directTx:
                  '4a51f17cdf6adbaa34449fc55ee943a03622fa0a1366b86c76fdfd41d0b7f857',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 34739,
                amountCur: 40.91244927264869,
                currency: '',
                tx_hash:
                  '835308c2dc0ad5c4462ecf75f2916f0080ecea7357f2d4411696c85f6b0f184e',
                address: null,
                directStamp: 1710707326,
                timestamp: 1710707326,
                listType: 'Unknown sources',
                share: 0.0015011333397795155,
                amountDec: 0.00034739,
              },
              {
                directTx:
                  'df06ce2d6b39d711f0c52df89f09f3c272d5df9e273c25e4d2bff9a9d3f9268e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 33500.11909521305,
                amountCur: 39.45340749908154,
                currency: '',
                tx_hash:
                  'df06ce2d6b39d711f0c52df89f09f3c272d5df9e273c25e4d2bff9a9d3f9268e',
                address: '3BBa2UTmhQ9yqDgk4MuZpTkqdgfhETn7LK',
                cluster: 3310,
                directStamp: 1688155292,
                timestamp: 1688155292,
                listType: 'Risky sources',
                share: 0.0014475991151273405,
                amountDec: 0.0003350011909521305,
              },
              {
                directTx:
                  'fcd74a3123cba183039c4b572c84c429b27fc8cf385169b7558e0912c61cd41f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 33000,
                amountCur: 38.864412504603095,
                currency: '',
                tx_hash:
                  'fcd74a3123cba183039c4b572c84c429b27fc8cf385169b7558e0912c61cd41f',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1733935002,
                timestamp: 1733935002,
                listType: 'Risky sources',
                share: 0.0014259880886820003,
                amountDec: 0.00033,
              },
              {
                directTx:
                  'd67a54960546a9f27b709d92f1ee16c1b53e52518837ed6a6d5cac808d641829',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 5,
                amount: 32726.12438554665,
                amountCur: 38.541866599904104,
                currency: '',
                tx_hash:
                  '38ff235f22ba08ee091d391c79d3f72bc2af2351a211bd3e1936e13e631fad91',
                address: 'bc1qvyuw2kunphjg6h25jw28wjr05jy2ks6qxw2hfm',
                cluster: 96199223,
                directStamp: 1723105790,
                timestamp: 1723105790,
                'address-1':
                  'bc1q3k6nnce2v73edpvspalas7uyj85p7ktzpqu9u6x2cn4v7fu82r2qw6z345',
                listType: 'Known sources',
                share: 0.0014141534412883353,
                amountDec: 0.0003272612438554665,
              },
              {
                directTx:
                  '3e83a821fd59ef10cfb07ce2cb6a22adaac30744f1b18790878b0b07a87413e3',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: {
                  minimum: 2,
                  maximum: 3,
                },
                amount: 32271.704035874434,
                amountCur: 38.006691450808745,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1719176705,
                timestamp: 1719176705,
                listType: 'Unknown sources',
                share: 0.0013945171380796298,
                amountDec: 0.0003227170403587443,
              },
              {
                directTx:
                  '958cdddea7f990c395104ad551e8b5e55ed7d0ea3847c106f61484f9bb191e28',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 32000,
                amountCur: 37.68670303476664,
                currency: '',
                tx_hash:
                  '958cdddea7f990c395104ad551e8b5e55ed7d0ea3847c106f61484f9bb191e28',
                address:
                  'bc1p6zftrsp5y4nsfaffs2hknqlt9gtscyjjhwsrjuazkstmh0lld5vqdw37wd',
                cluster: 3310,
                directStamp: 1723746965,
                timestamp: 1723746965,
                listType: 'Risky sources',
                share: 0.0013827763284189093,
                amountDec: 0.00032,
              },
              {
                directTx:
                  'e016635ef3014d64e79b588732d5377d45ca8ca44e235c1d454bb0ab0f6a8677',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 32000,
                amountCur: 37.68670303476664,
                currency: '',
                tx_hash:
                  'e016635ef3014d64e79b588732d5377d45ca8ca44e235c1d454bb0ab0f6a8677',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1738165665,
                timestamp: 1738165665,
                listType: 'Risky sources',
                share: 0.0013827763284189093,
                amountDec: 0.00032,
              },
              {
                directTx:
                  '73fe023779cff85f5794deb5fd34a87f3978f873c55a9c0e2477f8fdcffdad11',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 30000,
                amountCur: 35.33128409509372,
                currency: '',
                tx_hash:
                  '73fe023779cff85f5794deb5fd34a87f3978f873c55a9c0e2477f8fdcffdad11',
                address: 'bc1qldapsh7yws52nxfvp8msc6kag7jury3rxrw4dm',
                cluster: 3310,
                directStamp: 1711181462,
                timestamp: 1711181462,
                listType: 'Risky sources',
                share: 0.0012963528078927275,
                amountDec: 0.0003,
              },
              {
                directTx:
                  '934b4adea27c3a4d3d18334200e68eda9ea6f6835e1149400e6d36f37a29e56f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 30000,
                amountCur: 35.33128409509372,
                currency: '',
                tx_hash:
                  '934b4adea27c3a4d3d18334200e68eda9ea6f6835e1149400e6d36f37a29e56f',
                address: 'bc1qldapsh7yws52nxfvp8msc6kag7jury3rxrw4dm',
                cluster: 3310,
                directStamp: 1708457382,
                timestamp: 1708457382,
                listType: 'Risky sources',
                share: 0.0012963528078927275,
                amountDec: 0.0003,
              },
              {
                directTx:
                  '972d0507b39a4cd81662c725dbe79fabf2ffc71a293d5dad62e9b3a9c84d3ba4',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 30000,
                amountCur: 35.33128409509372,
                currency: '',
                tx_hash:
                  '972d0507b39a4cd81662c725dbe79fabf2ffc71a293d5dad62e9b3a9c84d3ba4',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1688414313,
                timestamp: 1688414313,
                listType: 'Risky sources',
                share: 0.0012963528078927275,
                amountDec: 0.0003,
              },
              {
                directTx:
                  'a8ed1002087192e1c08258260f8881dba2cb71f659fc17545f893af7558f210c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 30000,
                amountCur: 35.33128409509372,
                currency: '',
                tx_hash:
                  'a8ed1002087192e1c08258260f8881dba2cb71f659fc17545f893af7558f210c',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1688143603,
                timestamp: 1688143603,
                listType: 'Risky sources',
                share: 0.0012963528078927275,
                amountDec: 0.0003,
              },
              {
                directTx:
                  'e52ce3c7029a37c291a665dac5c263ec1eafb1707f1b2dda5a2f5520b72765ac',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 30000,
                amountCur: 35.33128409509372,
                currency: '',
                tx_hash:
                  'e52ce3c7029a37c291a665dac5c263ec1eafb1707f1b2dda5a2f5520b72765ac',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1738157026,
                timestamp: 1738157026,
                listType: 'Risky sources',
                share: 0.0012963528078927275,
                amountDec: 0.0003,
              },
              {
                directTx:
                  'e620a9142e80ede16bdbf6a219e3b0c71c59dd8587b0ed13459c3f250b7b5da3',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 30000,
                amountCur: 35.33128409509372,
                currency: '',
                tx_hash:
                  'e620a9142e80ede16bdbf6a219e3b0c71c59dd8587b0ed13459c3f250b7b5da3',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1729796563,
                timestamp: 1729796563,
                listType: 'Risky sources',
                share: 0.0012963528078927275,
                amountDec: 0.0003,
              },
              {
                directTx:
                  '63c3402e68c848b4cb8a45a83a2eaaee416894e11a95ae7a480dcfec55dc4c35',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 29999.999999999996,
                amountCur: 35.331284095093714,
                currency: '',
                tx_hash:
                  '63c3402e68c848b4cb8a45a83a2eaaee416894e11a95ae7a480dcfec55dc4c35',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1738167297,
                timestamp: 1738167297,
                listType: 'Risky sources',
                share: 0.0012963528078927273,
                amountDec: 0.0003,
              },
              {
                directTx:
                  'cdd1debb5d34bbd3d0076b864dc935d238f359d47b0cfd713999a549f63f9b39',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 29999.999999999996,
                amountCur: 35.331284095093714,
                currency: '',
                tx_hash:
                  'cdd1debb5d34bbd3d0076b864dc935d238f359d47b0cfd713999a549f63f9b39',
                address: 'bc1qldapsh7yws52nxfvp8msc6kag7jury3rxrw4dm',
                cluster: 3310,
                directStamp: 1708191970,
                timestamp: 1708191970,
                listType: 'Risky sources',
                share: 0.0012963528078927273,
                amountDec: 0.0003,
              },
              {
                directTx:
                  '151bb019ecce7705732deb8a6e45888f61c8639eb147d4e4a309ebf8ddfe4e81',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 29967,
                amountCur: 35.29241968258912,
                currency: '',
                tx_hash:
                  '317c80d6291d3c256331944cb650ec67c0dc1b68ab0b29f00e16a826f69a9889',
                address: null,
                directStamp: 1701186942,
                timestamp: 1701186942,
                listType: 'Unknown sources',
                share: 0.0012949268198040457,
                amountDec: 0.00029967,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 9,
                amount: 27103.335665089373,
                amountCur: 31.919855076931952,
                currency: '',
                tx_hash:
                  '29f7a7a464143913784c367feba205f76e921a450149c42f53dcf6d1c506a2d3',
                address: '3JU3Mip4WT3G38SbymyXNGP81Q4TrEkAwC',
                cluster: 502154,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1q2fns8hyd4ez0qemp0psf8ddsjl446502p28lh3',
                listType: 'Known sources',
                share: 0.0011711828430899238,
                amountDec: 0.0002710333566508937,
              },
              {
                directTx:
                  'f11a0b911e99a3b98da855375c27ba50c953eb5147c0f172fac6e63a76c18b93',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 26000,
                amountCur: 30.62044621574789,
                currency: '',
                tx_hash:
                  'f11a0b911e99a3b98da855375c27ba50c953eb5147c0f172fac6e63a76c18b93',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1738151684,
                timestamp: 1738151684,
                listType: 'Risky sources',
                share: 0.0011235057668403637,
                amountDec: 0.00026,
              },
              {
                directTx:
                  '28101a4dcca77665d79ac634763d2d40db44b8c7f23822749525d753d3faf938',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 25361,
                amountCur: 29.867889864522397,
                currency: '',
                tx_hash:
                  '28101a4dcca77665d79ac634763d2d40db44b8c7f23822749525d753d3faf938',
                address:
                  'bc1p7en40zu9hmf9d3luh8evmfyg655pu5k2gtna6j7zr623f9tz7z0stfnwav',
                cluster: 3310,
                directStamp: 1701093207,
                timestamp: 1701093207,
                listType: 'Risky sources',
                share: 0.0010958934520322488,
                amountDec: 0.00025361,
              },
              {
                directTx:
                  '6d935ce5ae31ee37275053c9dcfd1044b61edb83af3c4863e3d9ea3024cfb67c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 25000,
                amountCur: 29.442736745911436,
                currency: '',
                tx_hash:
                  '6d935ce5ae31ee37275053c9dcfd1044b61edb83af3c4863e3d9ea3024cfb67c',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1729812418,
                timestamp: 1729812418,
                listType: 'Risky sources',
                share: 0.0010802940065772729,
                amountDec: 0.00025,
              },
              {
                directTx:
                  '7c97438a861280819fbf82bdc0cee2ef8198df69d0434590153c2a0cbad838c9',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 25000,
                amountCur: 29.442736745911436,
                currency: '',
                tx_hash:
                  '7c97438a861280819fbf82bdc0cee2ef8198df69d0434590153c2a0cbad838c9',
                address:
                  'bc1p6zgg8j70qdxjly75mrk7clsqfaydvfskf27e6cfnhwmd2w4vn55shycuxr',
                cluster: 3310,
                directStamp: 1723717408,
                timestamp: 1723717408,
                listType: 'Risky sources',
                share: 0.0010802940065772729,
                amountDec: 0.00025,
              },
              {
                directTx:
                  'aa7d4fe9b8e7682e3d13904c36de09362c4ab0a1c7b9b557e942d5f110615633',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 24950,
                amountCur: 29.383851272419612,
                currency: '',
                tx_hash:
                  '9e1e7764f74ca231e00189699369675d42d906b168fa15d1ed73f51b4198c67e',
                address: 'bc1qcgsyqsxet9csv73ku44u8g2kpqt20svhdteths',
                cluster: 110126834,
                directStamp: 1701095294,
                timestamp: 1701095294,
                'address-1':
                  'bc1pm7d5ne0gjx5shyq6wrkf7sdhhq3s9p7hr92qhqk5h8e6tuunmqps8dn8jh',
                listType: 'Unknown sources',
                share: 0.0010781334185641185,
                amountDec: 0.0002495,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 3,
                amount: 24089.675800207526,
                amountCur: 28.37063931519454,
                currency: '',
                tx_hash:
                  '2e8e8c7ccf7a32207a19e2bc813d530ffcd6d173950db23cc1356f0ed0ce2b7c',
                address: 'bc1qyasecrpqy65083rakjkv3dwy3dft05yfhs5mnq',
                cluster: 103314453,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1': 'bc1qdjlda2da6vfgaw7mwma303cmr6l3mrlzzf8qln',
                listType: 'Unknown sources',
                share: 0.0010409572954941503,
                amountDec: 0.00024089675800207527,
              },
              {
                directTx:
                  '4a51f17cdf6adbaa34449fc55ee943a03622fa0a1366b86c76fdfd41d0b7f857',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 2,
                amount: 23609,
                amountCur: 27.804542873368923,
                currency: '',
                tx_hash:
                  '835308c2dc0ad5c4462ecf75f2916f0080ecea7357f2d4411696c85f6b0f184e',
                address: null,
                directStamp: 1710707326,
                timestamp: 1710707326,
                'address-1':
                  'bc1pzn5u9ktmsugc5h9zetf37grc7jtrue9z0y8c8pwqfvcsrknat8csmv6u9r',
                listType: 'Unknown sources',
                share: 0.0010201864480513135,
                amountDec: 0.00023609,
              },
              {
                directTx:
                  'a8e214e6d39166c8e52f14b1ba0d8bf9c524b8fe77f5a553ada13bac2f1eccc7',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 22866.28149606299,
                amountCur: 26.92983625785954,
                currency: '',
                tx_hash:
                  'a8e214e6d39166c8e52f14b1ba0d8bf9c524b8fe77f5a553ada13bac2f1eccc7',
                address:
                  'bc1pv70ew5zpjpehtyg265f5rr64w67xzl47zcusvrhz088jdc8y78dsmefwja',
                cluster: 3310,
                directStamp: 1723110185,
                timestamp: 1723110185,
                listType: 'Risky sources',
                share: 0.000988092274116226,
                amountDec: 0.0002286628149606299,
              },
              {
                directTx:
                  '4da3c27a240e27f27fd5959410b63476b54510bf5a1cfb5a7439f085998a20de',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 13,
                amount: 22030.335239408392,
                amountCur: 25.945334435123083,
                currency: '',
                tx_hash:
                  '6f74c18fbebafbef2635dd8b24472cdef707aada27626a1fdb1f673716a5f1c5',
                address: 'bc1qddvmdc9t8tad2eqd7vfwv2mexjzs49f42wvg27',
                cluster: 87538315,
                directStamp: 1735820508,
                timestamp: 1735820508,
                'address-1': 'bc1q2styuumzwqrms86zl372jhvmnnczf6jpwjfjgn',
                listType: 'Unknown sources',
                share: 0.0009519695648808391,
                amountDec: 0.00022030335239408392,
              },
              {
                directTx:
                  '2296854892497a5c53afabc65600a8452cd63f030d0d160cea1cae35fe2f7b64',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 21000,
                amountCur: 24.731898866565604,
                currency: '',
                tx_hash:
                  '2296854892497a5c53afabc65600a8452cd63f030d0d160cea1cae35fe2f7b64',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1688159407,
                timestamp: 1688159407,
                listType: 'Risky sources',
                share: 0.0009074469655249093,
                amountDec: 0.00021,
              },
              {
                directTx:
                  '05eb2b6ac6ff199d63dadcb3fe5c9d615afff73122ce648fbea90ecbc51943ea',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 20840.738109031343,
                amountCur: 24.544334629387755,
                currency: '',
                tx_hash:
                  '05eb2b6ac6ff199d63dadcb3fe5c9d615afff73122ce648fbea90ecbc51943ea',
                address: 'bc1qcq2uv5nk6hec6kvag3wyevp6574qmsm9scjxc2',
                directStamp: 1685911803,
                timestamp: 1685911803,
                listType: 'Unknown sources',
                share: 0.0009005649788733251,
                amountDec: 0.00020840738109031344,
              },
              {
                directTx:
                  '4da3c27a240e27f27fd5959410b63476b54510bf5a1cfb5a7439f085998a20de',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Gambling',
                  score: 60,
                  id: '61766e55820e134d585ded4f',
                },
                owner: 'Betplay',
                depth: 7,
                amount: 20737.50813178421,
                amountCur: 24.422759707612805,
                currency: '',
                tx_hash:
                  '88d3d3d3e39158304801fcb81500153539989f425d41bb16cf49b3390808a06c',
                address: 'bc1qa7yuxdlktc3f4d5ftq4jzsfgw2e0wmj0jd399k',
                cluster: 84776286,
                directStamp: 1735820508,
                timestamp: 1735820508,
                'address-1': '3CqTUuTd7pjeQ5zKy6GJVD1wNoox3Yunxk',
                listType: 'Risky sources',
                share: 0.0008961042298445577,
                amountDec: 0.0002073750813178421,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 11,
                amount: 20094.90102779227,
                amountCur: 23.665955235857318,
                currency: '',
                tx_hash:
                  'e3b05d7c5b09868a53d06afb9b426ef980bfb949090b6dfbac48b83ecddf49e9',
                address: '3JU3Mip4WT3G38SbymyXNGP81Q4TrEkAwC',
                cluster: 502154,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1q9e0y5am489ud5dckwqtkw4ehyj96agml4klqfc',
                listType: 'Known sources',
                share: 0.0008683360457234989,
                amountDec: 0.0002009490102779227,
              },
              {
                directTx:
                  '5668f6a293cb7a0549e79bf247ee85b544c6b66a3cc8e19c91d967ed6584020c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 20000,
                amountCur: 23.554189396729146,
                currency: '',
                tx_hash:
                  '5668f6a293cb7a0549e79bf247ee85b544c6b66a3cc8e19c91d967ed6584020c',
                address:
                  'bc1pj7xah55x62wgx3gmq2e36jtwp8pjdp9endvn5tcavu4rh794g6csegw9y4',
                cluster: 3310,
                directStamp: 1723622879,
                timestamp: 1723622879,
                listType: 'Risky sources',
                share: 0.0008642352052618183,
                amountDec: 0.0002,
              },
              {
                directTx:
                  'ad7fdb58c2ae6c51733b5fe18da999702d35bf0b1216f52c1cd833ae61e72cf4',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 20000,
                amountCur: 23.554189396729146,
                currency: '',
                tx_hash:
                  'ad7fdb58c2ae6c51733b5fe18da999702d35bf0b1216f52c1cd833ae61e72cf4',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1723620508,
                timestamp: 1723620508,
                listType: 'Risky sources',
                share: 0.0008642352052618183,
                amountDec: 0.0002,
              },
              {
                directTx:
                  'e82bad0d40057ff76a9c12fa7f3845042efb1b7462e574e33307e1f4af53d7d7',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 20000,
                amountCur: 23.554189396729146,
                currency: '',
                tx_hash:
                  'e82bad0d40057ff76a9c12fa7f3845042efb1b7462e574e33307e1f4af53d7d7',
                address:
                  'bc1pq0y0w50wdj32jhwr0jkewnda9mny260al4xpqpeswjxc7v9xn40slx4c0e',
                cluster: 3310,
                directStamp: 1723718001,
                timestamp: 1723718001,
                listType: 'Risky sources',
                share: 0.0008642352052618183,
                amountDec: 0.0002,
              },
              {
                directTx:
                  'd6d6a0b1493ba5e090ea34a35cc88446bfb475cb71b9483f9f215ced81367935',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 19838,
                amountCur: 23.36340046261564,
                currency: '',
                tx_hash:
                  'd6d6a0b1493ba5e090ea34a35cc88446bfb475cb71b9483f9f215ced81367935',
                address: null,
                directStamp: 1709420395,
                timestamp: 1709420395,
                listType: 'Unknown sources',
                share: 0.0008572349000991976,
                amountDec: 0.00019838,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 16,
                amount: 19781.14501747199,
                amountCur: 23.296441811285018,
                currency: '',
                tx_hash:
                  '4f9c8cd4eedc7b486bb8746460e3b7ead1180a54115dec9f0c05a9fdf85c3e43',
                address: '3CW24NViy1rVCRCxXnHx5sHBx3vTh96XJz',
                cluster: 502154,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1qzq53lcvcacmxxuca6csunpfsdwkm7lu3srezy3',
                listType: 'Known sources',
                share: 0.000854778096224435,
                amountDec: 0.0001978114501747199,
              },
              {
                directTx:
                  '21c1ffad4bc9d077fb33a01e8ea9cbb0730fabace5e21a84866ac72f4e249ff1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 2,
                amount: 18270,
                amountCur: 21.516752013912075,
                currency: '',
                tx_hash:
                  '201e535b4f6cbc53166971a54c083c660fb2b89ac3073b19c933c904e22447f6',
                address: '3PWC7Ao7UgWdD6jRhzShnhe6vEanqEqwMX',
                cluster: 3310,
                directStamp: 1726085146,
                timestamp: 1726085146,
                'address-1':
                  'bc1pplknput76dkm7xjahm7m0jhmcnnf948cugtstfsyde8zh7gvwnhqdps9jq',
                listType: 'Risky sources',
                share: 0.000789478860006671,
                amountDec: 0.0001827,
              },
              {
                directTx:
                  '091601e1d3e7892f20f043004fecdcceb1aa57b7d4f42c232eb3cc39f38aa1ae',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 18000,
                amountCur: 21.198770457056234,
                currency: '',
                tx_hash:
                  '091601e1d3e7892f20f043004fecdcceb1aa57b7d4f42c232eb3cc39f38aa1ae',
                address: null,
                directStamp: 1716489238,
                timestamp: 1716489238,
                listType: 'Unknown sources',
                share: 0.0007778116847356366,
                amountDec: 0.00018,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 13,
                amount: 17911.860870345954,
                amountCur: 21.094968169399518,
                currency: '',
                tx_hash:
                  '5c503fa91ae043184bfd9e02ea37a11cc82a1eff3d792a7a23873b6ecd1cb4b5',
                address: 'bc1qvyhzxqlsv8cuel2tee7ha97xektrfxxupza40s',
                cluster: 106745901,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1': 'bc1qrgkml86cw9z742cwg7e9p5c7qf276s2nmj5csw',
                listType: 'Unknown sources',
                share: 0.0007740030377952283,
                amountDec: 0.00017911860870345955,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 14,
                amount: 17845.53316251435,
                amountCur: 21.016853399773694,
                currency: '',
                tx_hash:
                  '5578a4c520858809583dfef4c29da4c460c16af46deaee5a6bd7fd1718198da1',
                address: 'bc1qvyhzxqlsv8cuel2tee7ha97xektrfxxupza40s',
                cluster: 106745901,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1': 'bc1q9dywhjeak2msej0dj7ey6cc69u546j4nuerq3p',
                listType: 'Unknown sources',
                share: 0.0007711369007856088,
                amountDec: 0.00017845533162514352,
              },
              {
                directTx:
                  '5fea78e5fed4782441017907fe569b2e55084a45f804cea7b75e6eb324f40019',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 17263,
                amountCur: 20.330798577786762,
                currency: '',
                tx_hash:
                  '5fea78e5fed4782441017907fe569b2e55084a45f804cea7b75e6eb324f40019',
                address: null,
                directStamp: 1713266032,
                timestamp: 1713266032,
                listType: 'Unknown sources',
                share: 0.0007459646174217384,
                amountDec: 0.00017263,
              },
              {
                directTx:
                  'ccf28d2a9c82326d13ebc9680fc1d7908c9c607b42a47ac5ecddecf8d25de161',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 17000,
                amountCur: 20.021060987219776,
                currency: '',
                tx_hash:
                  'ccf28d2a9c82326d13ebc9680fc1d7908c9c607b42a47ac5ecddecf8d25de161',
                address: null,
                directStamp: 1700676459,
                timestamp: 1700676459,
                listType: 'Unknown sources',
                share: 0.0007345999244725457,
                amountDec: 0.00017,
              },
              {
                directTx:
                  'b34c8138da4171cd10048963a7024055cbb29199a321ce512dcbb6d624dbf16c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 16082,
                amountCur: 18.939923693909908,
                currency: '',
                tx_hash:
                  'b34c8138da4171cd10048963a7024055cbb29199a321ce512dcbb6d624dbf16c',
                address: null,
                directStamp: 1724781861,
                timestamp: 1724781861,
                listType: 'Unknown sources',
                share: 0.0006949315285510281,
                amountDec: 0.00016082,
              },
              {
                directTx:
                  '744024cef065622aed55991e7b2a7a61e5a680dcf9a113dc73b76099b7d1d337',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 16000,
                amountCur: 18.84335151738332,
                currency: '',
                tx_hash:
                  '744024cef065622aed55991e7b2a7a61e5a680dcf9a113dc73b76099b7d1d337',
                address: null,
                directStamp: 1700679939,
                timestamp: 1700679939,
                listType: 'Unknown sources',
                share: 0.0006913881642094547,
                amountDec: 0.00016,
              },
              {
                directTx:
                  '8fbd4003ae3d73ebcaa0a1b9f697d0ba8c78231426b81d0ce5014aab8483a693',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 16000,
                amountCur: 18.84335151738332,
                currency: '',
                tx_hash:
                  '8fbd4003ae3d73ebcaa0a1b9f697d0ba8c78231426b81d0ce5014aab8483a693',
                address: null,
                directStamp: 1700688329,
                timestamp: 1700688329,
                listType: 'Unknown sources',
                share: 0.0006913881642094547,
                amountDec: 0.00016,
              },
              {
                directTx:
                  'bb19940ca44c1edc5d1900e638a0d7143278698661785222d908701117ce66aa',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 16000.000000000002,
                amountCur: 18.84335151738332,
                currency: '',
                tx_hash:
                  'bb19940ca44c1edc5d1900e638a0d7143278698661785222d908701117ce66aa',
                address: null,
                directStamp: 1706901570,
                timestamp: 1706901570,
                listType: 'Unknown sources',
                share: 0.0006913881642094547,
                amountDec: 0.00016,
              },
              {
                directTx:
                  'e572787b15c4f61c98f71952aca4282c2642205864e94f6eea585f70c04c0f0d',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 16000,
                amountCur: 18.84335151738332,
                currency: '',
                tx_hash:
                  'e572787b15c4f61c98f71952aca4282c2642205864e94f6eea585f70c04c0f0d',
                address:
                  'bc1pq0y0w50wdj32jhwr0jkewnda9mny260al4xpqpeswjxc7v9xn40slx4c0e',
                cluster: 3310,
                directStamp: 1724444499,
                timestamp: 1724444499,
                listType: 'Risky sources',
                share: 0.0006913881642094547,
                amountDec: 0.00016,
              },
              {
                directTx:
                  'c3e2d865805003b7cada001314baf3c63bef090e0fb6a988f8a1a46d44c6511f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 15633,
                amountCur: 18.41113214195334,
                currency: '',
                tx_hash:
                  'c3e2d865805003b7cada001314baf3c63bef090e0fb6a988f8a1a46d44c6511f',
                address: null,
                directStamp: 1723107328,
                timestamp: 1723107328,
                listType: 'Unknown sources',
                share: 0.0006755294481929003,
                amountDec: 0.00015633,
              },
              {
                directTx:
                  '0dbd7ba41897a829ec04e600412f2ee41d038326cf1eae8474cb12ddc184b706',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 15600,
                amountCur: 18.372267729448733,
                currency: '',
                tx_hash:
                  '0dbd7ba41897a829ec04e600412f2ee41d038326cf1eae8474cb12ddc184b706',
                address: null,
                directStamp: 1711558450,
                timestamp: 1711558450,
                listType: 'Unknown sources',
                share: 0.0006741034601042183,
                amountDec: 0.000156,
              },
              {
                directTx:
                  '8303276a0c1b018d44ca1ff148895df075148cbec91e6d4d263338188d37bb67',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 15356,
                amountCur: 18.08490661880864,
                currency: '',
                tx_hash:
                  '8303276a0c1b018d44ca1ff148895df075148cbec91e6d4d263338188d37bb67',
                address: null,
                directStamp: 1743694054,
                timestamp: 1743694054,
                listType: 'Unknown sources',
                share: 0.0006635597906000241,
                amountDec: 0.00015356,
              },
              {
                directTx:
                  '0fe8c963d51817281b3964fda824e2b6b8ca960c608bb35ecd1c6185e89e7813',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 15317.682108852556,
                amountCur: 18.03977927554013,
                currency: '',
                tx_hash:
                  '0fe8c963d51817281b3964fda824e2b6b8ca960c608bb35ecd1c6185e89e7813',
                address: null,
                directStamp: 1701462589,
                timestamp: 1701462589,
                listType: 'Unknown sources',
                share: 0.0006619040070739735,
                amountDec: 0.00015317682108852555,
              },
              {
                directTx:
                  '151bb019ecce7705732deb8a6e45888f61c8639eb147d4e4a309ebf8ddfe4e81',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 15249.999999999998,
                amountCur: 17.96006941500597,
                currency: '',
                tx_hash:
                  '317c80d6291d3c256331944cb650ec67c0dc1b68ab0b29f00e16a826f69a9889',
                address: 'bc1qztr4aa5haj005qeexc6e702nahattqq06cg7hp',
                cluster: 110126834,
                directStamp: 1701186942,
                timestamp: 1701186942,
                'address-1':
                  'bc1pyr4dylwlechurmhku65d23a2qglc8h50ee97zsyum5rz8fvuhlcq89f2gh',
                listType: 'Unknown sources',
                share: 0.0006589793440121363,
                amountDec: 0.0001525,
              },
              {
                directTx:
                  '8e4ed70c476808f3494f9a5af923841cc07f13971c3f3d49a372a1faaec9f1cf',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 14286,
                amountCur: 16.82475748608363,
                currency: '',
                tx_hash:
                  '8e4ed70c476808f3494f9a5af923841cc07f13971c3f3d49a372a1faaec9f1cf',
                address: null,
                directStamp: 1711583819,
                timestamp: 1711583819,
                listType: 'Unknown sources',
                share: 0.0006173232071185168,
                amountDec: 0.00014286,
              },
              {
                directTx:
                  '8d95da7efecb58a864e0ea482d345e31feddf4bc9511d33c30f7f22b5e74a198',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 14285.999999999998,
                amountCur: 16.824757486083627,
                currency: '',
                tx_hash:
                  '8d95da7efecb58a864e0ea482d345e31feddf4bc9511d33c30f7f22b5e74a198',
                address: null,
                directStamp: 1711573341,
                timestamp: 1711573341,
                listType: 'Unknown sources',
                share: 0.0006173232071185167,
                amountDec: 0.00014285999999999997,
              },
              {
                directTx:
                  '65858512b8e6498d90e186f9950de5bc8f6e3c3b87e38e48e4ad6f24855c028f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 14249.023072438016,
                amountCur: 16.781209408328426,
                currency: '',
                tx_hash:
                  '65858512b8e6498d90e186f9950de5bc8f6e3c3b87e38e48e4ad6f24855c028f',
                address: null,
                directStamp: 1690493629,
                timestamp: 1690493629,
                listType: 'Unknown sources',
                share: 0.0006157253689894428,
                amountDec: 0.00014249023072438017,
              },
              {
                directTx:
                  '16935f98849fa905b5a7fb7cd973b23c940390db3b007b65da447d8b21bdd70b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 1,
                amount: 13937,
                amountCur: 16.413736881110708,
                currency: '',
                tx_hash:
                  '16935f98849fa905b5a7fb7cd973b23c940390db3b007b65da447d8b21bdd70b',
                address: '3Anoj2mUpNN2Hb9c45joZ4FNLiAPgZr3B3',
                cluster: 127575307,
                directStamp: 1737402527,
                timestamp: 1737402527,
                listType: 'Unknown sources',
                share: 0.0006022423027866982,
                amountDec: 0.00013937,
              },
              {
                directTx:
                  'bbb960a5ce973649d0bb9c12dafe2a39a47d6829f3c6a7dbadfd45bc4f77c089',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 13640,
                amountCur: 16.063957168569278,
                currency: '',
                tx_hash:
                  'bdb94c5a1d93ae7f7321d6ecf0b30b474a8b850a092ea6f63344a9be6a483813',
                address: null,
                directStamp: 1687728319,
                timestamp: 1687728319,
                listType: 'Unknown sources',
                share: 0.0005894084099885601,
                amountDec: 0.0001364,
              },
              {
                directTx:
                  '5237264dd455cb7ef799249c984d088c3cef10f4667e60ed96e5a9a185ed078a',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 13482,
                amountCur: 15.877879072335118,
                currency: '',
                tx_hash:
                  '306acfc8add3ded916f8c6f1f24eee0dbe85f5d138bfd84edf26b7a04ac6157d',
                address: 'bc1qdu7f50xyf20xyfpnxxx6p80sf73zwcxvc2hwk7',
                cluster: 110126834,
                directStamp: 1700651668,
                timestamp: 1700651668,
                'address-1':
                  'bc1p4ggrwutmhgwnssla9gpve8eeq4tx6fj90wrqg7zqezr9f5yprlkqh2ta78',
                listType: 'Unknown sources',
                share: 0.0005825809518669918,
                amountDec: 0.00013482,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 6,
                amount: 13331.702426436932,
                amountCur: 15.700872196656452,
                currency: '',
                tx_hash:
                  '466ef7c8726a0d63ef58710e24acb706fccafeb6a4f07ea3b044fb854bd4d27b',
                address: 'bc1qvyhzxqlsv8cuel2tee7ha97xektrfxxupza40s',
                cluster: 106745901,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1':
                  'bc1pyd2wj4qnyhjd95d5yytelufr9y4n7zdkltqzdld4alj4agp3g77qz970cy',
                listType: 'Unknown sources',
                share: 0.0005760863291500601,
                amountDec: 0.0001333170242643693,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 4,
                amount: 13328.28393163224,
                amountCur: 15.69684620295238,
                currency: '',
                tx_hash:
                  'ec95a0c37fc84ee0045a3f76e2a8444d751e8de80fa8ac1b8ad861c3ee7a1f99',
                address: 'bc1qvyhzxqlsv8cuel2tee7ha97xektrfxxupza40s',
                cluster: 106745901,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1':
                  'bc1qh0v0s8q6qg5a0ka8nspeghxzk4h6mswcdshespz8t75rxnrjahrs6cc9h9',
                listType: 'Unknown sources',
                share: 0.0005759386099720992,
                amountDec: 0.00013328283931632242,
              },
              {
                directTx:
                  '5275b890f82fc9831f713260348d4db6d8d3793207776098601bcd2aa21ab24e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 13000,
                amountCur: 15.310223107873945,
                currency: '',
                tx_hash:
                  '5275b890f82fc9831f713260348d4db6d8d3793207776098601bcd2aa21ab24e',
                address: null,
                directStamp: 1700610367,
                timestamp: 1700610367,
                listType: 'Unknown sources',
                share: 0.0005617528834201818,
                amountDec: 0.00013,
              },
              {
                directTx:
                  'cdbe43dab21815b4e9e5769856ef7302d6655f9f88d97501f8aa67439a6eae15',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: {
                  minimum: 2,
                  maximum: 3,
                },
                amount: 12500.624558335967,
                amountCur: 14.72210392122245,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1691677359,
                timestamp: 1691677359,
                listType: 'Unknown sources',
                share: 0.0005401739915537206,
                amountDec: 0.00012500624558335968,
              },
              {
                directTx:
                  '016f8e9994887e42a9c2a70d8d232dd60a5b2ca5f84b17dbd3af8c41ad02a9cf',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 12000,
                amountCur: 14.132513638037489,
                currency: '',
                tx_hash:
                  '016f8e9994887e42a9c2a70d8d232dd60a5b2ca5f84b17dbd3af8c41ad02a9cf',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1688159407,
                timestamp: 1688159407,
                listType: 'Risky sources',
                share: 0.000518541123157091,
                amountDec: 0.00012,
              },
              {
                directTx:
                  'a00ca5c33d5de68167a5faeae6b6754189a1bc74336b6b3889c9343e51e61b64',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 12000,
                amountCur: 14.132513638037489,
                currency: '',
                tx_hash:
                  'a00ca5c33d5de68167a5faeae6b6754189a1bc74336b6b3889c9343e51e61b64',
                address: null,
                directStamp: 1701186112,
                timestamp: 1701186112,
                listType: 'Unknown sources',
                share: 0.000518541123157091,
                amountDec: 0.00012,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 7,
                amount: 11980.981954520703,
                amountCur: 14.11011590577874,
                currency: '',
                tx_hash:
                  '174ea6dfb091281c80814705b238549f4a9670727d1a117806638f6a4e3f11ce',
                address: '33qg4GjkxT8A7gMsZbzzkC8wgc1SWby79g',
                cluster: 3310,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1qvx872y0zweav0etfy7mm0w7g640xnfxxh2shk5',
                listType: 'Risky sources',
                share: 0.000517719319935167,
                amountDec: 0.00011980981954520703,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: {
                  minimum: 2,
                  maximum: 13,
                },
                amount: 11977.270293113199,
                amountCur: 14.105744646990296,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1687958689,
                timestamp: 1687958689,
                listType: 'Unknown sources',
                share: 0.0005175589325122482,
                amountDec: 0.000119772702931132,
              },
              {
                directTx:
                  '76cbb81853c72beaf7d9f7050eac69c33ab1adee091c6ad6dd4e9d202f91a783',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 2,
                amount: 11700,
                amountCur: 13.77920079708655,
                currency: '',
                tx_hash:
                  'dc0ea2c396aff4e5366a84f5bfb239d9022adc0afac63bf418a9f7a70c4437be',
                address: '3JibBeerFCN5NgxkUk5mjdMwwBYL3H6Kof',
                cluster: 85980607,
                directStamp: 1710798909,
                timestamp: 1710798909,
                'address-1':
                  'bc1prwpe4qsf6dmgfcmxm826nqdmxycva0f2k2d3qkd3ac2j9t24pleskvfhtv',
                listType: 'Known sources',
                share: 0.0005055775950781637,
                amountDec: 0.000117,
              },
              {
                directTx:
                  '97ee1170f5650a50708156d4356b068bc6a29add2ca82473e9ac7279df289ec6',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 11694,
                amountCur: 13.772134540267533,
                currency: '',
                tx_hash:
                  'cd8675db581ab6b1072e01d7dc344fe498f88d3ed2b4a2a876462d3c74ade0af',
                address: null,
                directStamp: 1706915380,
                timestamp: 1706915380,
                listType: 'Unknown sources',
                share: 0.0005053183245165852,
                amountDec: 0.00011694,
              },
              {
                directTx:
                  '0c0fe3df09c2b22af18b4e7a621ac9fc8eec2ff49406b9223e46b0b46b8c61a9',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 11000,
                amountCur: 12.954804168201031,
                currency: '',
                tx_hash:
                  '0c0fe3df09c2b22af18b4e7a621ac9fc8eec2ff49406b9223e46b0b46b8c61a9',
                address: 'bc1qqjqg79puepz2a84pq08wh3378sqhhh58uthdes',
                directStamp: 1724270093,
                timestamp: 1724270093,
                listType: 'Unknown sources',
                share: 0.0004753293628940001,
                amountDec: 0.00011,
              },
              {
                directTx:
                  '172e53e487625290b05211222f5ac54a4e0ad25daa7e81b18665dcc5bdf2600e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 11000,
                amountCur: 12.954804168201031,
                currency: '',
                tx_hash:
                  '172e53e487625290b05211222f5ac54a4e0ad25daa7e81b18665dcc5bdf2600e',
                address: 'bc1qlwshmalmf4k3mfvu8r06rvfpardxxapjkuaj58',
                directStamp: 1724270093,
                timestamp: 1724270093,
                listType: 'Unknown sources',
                share: 0.0004753293628940001,
                amountDec: 0.00011,
              },
              {
                directTx:
                  '3a9b2b75c7a5c03e460417872f1adc66213caf5a8140eb53728a58af8f50c55e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 11000,
                amountCur: 12.954804168201031,
                currency: '',
                tx_hash:
                  '3a9b2b75c7a5c03e460417872f1adc66213caf5a8140eb53728a58af8f50c55e',
                address: 'bc1q6nuxc8tvl3pa803264505qcgl9er2j3uwuqyjg',
                directStamp: 1724270093,
                timestamp: 1724270093,
                listType: 'Unknown sources',
                share: 0.0004753293628940001,
                amountDec: 0.00011,
              },
              {
                directTx:
                  '55fe0d3ac2b3defe778dc9307be41602a6be56253889ea2f6cbb3c3413527c39',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 11000,
                amountCur: 12.954804168201031,
                currency: '',
                tx_hash:
                  '55fe0d3ac2b3defe778dc9307be41602a6be56253889ea2f6cbb3c3413527c39',
                address: 'bc1q80z4nfy3gqrcfdk73nehnpyeeqq4kqgfvphruk',
                directStamp: 1724186255,
                timestamp: 1724186255,
                listType: 'Unknown sources',
                share: 0.0004753293628940001,
                amountDec: 0.00011,
              },
              {
                directTx:
                  'b93a9ac6a4b42cd9ea906e2e29d58a1bfade95d4222a349d449d5245679a031b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 11000,
                amountCur: 12.954804168201031,
                currency: '',
                tx_hash:
                  'b93a9ac6a4b42cd9ea906e2e29d58a1bfade95d4222a349d449d5245679a031b',
                address: 'bc1q4wq8g53kuzgdqw64n30d9nu7v5fn3ay4lafzd8',
                directStamp: 1724267437,
                timestamp: 1724267437,
                listType: 'Unknown sources',
                share: 0.0004753293628940001,
                amountDec: 0.00011,
              },
              {
                directTx:
                  'cb455e49ee8a6d6793b16a4c08a37c38be30fb9ca2d8eb0486918a586f9f5623',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 11000,
                amountCur: 12.954804168201031,
                currency: '',
                tx_hash:
                  'cb455e49ee8a6d6793b16a4c08a37c38be30fb9ca2d8eb0486918a586f9f5623',
                address: 'bc1q4an6mald2etnlv60398dgk6g8927plyfv0l8yh',
                directStamp: 1724189873,
                timestamp: 1724189873,
                listType: 'Unknown sources',
                share: 0.0004753293628940001,
                amountDec: 0.00011,
              },
              {
                directTx:
                  'ca5fc57d4b98ab367672b5587d3863b1d0da16b13fa3008cec603423d13d3e24',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: {
                  minimum: 2,
                  maximum: 3,
                },
                amount: 10654.49769783346,
                amountCur: 12.5479028350892,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1691687044,
                timestamp: 1691687044,
                listType: 'Unknown sources',
                share: 0.00046039960024243356,
                amountDec: 0.00010654497697833459,
              },
              {
                directTx:
                  'cdd1debb5d34bbd3d0076b864dc935d238f359d47b0cfd713999a549f63f9b39',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 10546,
                amountCur: 12.42012406889528,
                currency: '',
                tx_hash:
                  'cdd1debb5d34bbd3d0076b864dc935d238f359d47b0cfd713999a549f63f9b39',
                address: 'bc1qptgujmlkez7e6744yctzjgztu0st372mxs6702',
                cluster: 122276901,
                directStamp: 1708191970,
                timestamp: 1708191970,
                listType: 'Unknown sources',
                share: 0.00045571122373455684,
                amountDec: 0.00010546,
              },
              {
                directTx:
                  '36195773f01d526e845ce956000547fbba87d32ef706e523269b68d45ae796f8',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 10313,
                amountCur: 12.145717762423384,
                currency: '',
                tx_hash:
                  '36195773f01d526e845ce956000547fbba87d32ef706e523269b68d45ae796f8',
                address: null,
                directStamp: 1710864792,
                timestamp: 1710864792,
                listType: 'Unknown sources',
                share: 0.0004456428835932566,
                amountDec: 0.00010313,
              },
              {
                directTx:
                  '0ec03d8d04fac85f35728b65ded3e7a31edfba74cb147c4ee288045ae473967d',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  '0ec03d8d04fac85f35728b65ded3e7a31edfba74cb147c4ee288045ae473967d',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1738161122,
                timestamp: 1738161122,
                listType: 'Risky sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '14713595fc3b32d98d5e0b1bc3c8021c47b08f98e083dcded84243fc56ebcca5',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  '14713595fc3b32d98d5e0b1bc3c8021c47b08f98e083dcded84243fc56ebcca5',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1753554881,
                timestamp: 1753554881,
                listType: 'Risky sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '218b81eda24520401dbf4425f9ca82d0f8971e8f63727a642a03d2832faacbd3',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  '218b81eda24520401dbf4425f9ca82d0f8971e8f63727a642a03d2832faacbd3',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1688159407,
                timestamp: 1688159407,
                listType: 'Risky sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '3daca6ec4925f64b25b7953952e36b4cfd3d7791116cfa1242c48ee47b47b149',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  '3daca6ec4925f64b25b7953952e36b4cfd3d7791116cfa1242c48ee47b47b149',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1688157204,
                timestamp: 1688157204,
                listType: 'Risky sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '54b7f34f26cf62d88180aa37b6826f25a6bdad3767725bb74e7f67e33a3a11e8',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  '54b7f34f26cf62d88180aa37b6826f25a6bdad3767725bb74e7f67e33a3a11e8',
                address: null,
                directStamp: 1701187541,
                timestamp: 1701187541,
                listType: 'Unknown sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '5be647ba81a3de4ac86f0d13e62023b5f94f2e66193ef6b0470c75324927f62f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  '5be647ba81a3de4ac86f0d13e62023b5f94f2e66193ef6b0470c75324927f62f',
                address:
                  'bc1pjg429ecnphmk2w0acppfkxypslj6h5fl5nxzap57s2mhu38mnugqvzpyj2',
                cluster: 3310,
                directStamp: 1736433195,
                timestamp: 1736433195,
                listType: 'Risky sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '622b1282eeafd4ea28e0c0d80cb23a3b364a2cbbad71105b312fa4965b73cafc',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  '622b1282eeafd4ea28e0c0d80cb23a3b364a2cbbad71105b312fa4965b73cafc',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1738155847,
                timestamp: 1738155847,
                listType: 'Risky sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '66a766bbf8245f7d84d0d964490448ae07a2c00f8b8a06131117445a7103e51c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  '66a766bbf8245f7d84d0d964490448ae07a2c00f8b8a06131117445a7103e51c',
                address:
                  'bc1pzrwl9zv7m9393rrcemcj7vuzd6k7s0zdd0pava60s2mzlkj0nt3q4a39qu',
                cluster: 3310,
                directStamp: 1736432415,
                timestamp: 1736432415,
                listType: 'Risky sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '871bca9dd857e7f8f2ac68b94d784cb296187a034f63d7978126724f98babe55',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  '871bca9dd857e7f8f2ac68b94d784cb296187a034f63d7978126724f98babe55',
                address:
                  'bc1p6zgg8j70qdxjly75mrk7clsqfaydvfskf27e6cfnhwmd2w4vn55shycuxr',
                cluster: 3310,
                directStamp: 1688157204,
                timestamp: 1688157204,
                listType: 'Risky sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '96990784a3c7244e289305b86ae96e5486dfa7c25bc9b8d588a488645ef16623',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  '96990784a3c7244e289305b86ae96e5486dfa7c25bc9b8d588a488645ef16623',
                address: null,
                directStamp: 1707005801,
                timestamp: 1707005801,
                listType: 'Unknown sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  'fef77c0299498894bb110b9609c6eb5ea6692d11358b5593ddf1f019c53d76b5',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 10000,
                amountCur: 11.777094698364573,
                currency: '',
                tx_hash:
                  'fef77c0299498894bb110b9609c6eb5ea6692d11358b5593ddf1f019c53d76b5',
                address: null,
                directStamp: 1727471206,
                timestamp: 1727471206,
                listType: 'Unknown sources',
                share: 0.00043211760263090913,
                amountDec: 0.0001,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 16,
                amount: 9812.698533787572,
                amountCur: 11.556507987891944,
                currency: '',
                tx_hash:
                  '24090e2e6b08824103223279a33a5a03be2e510c33ffbb360c69e6b13a78d815',
                address: 'bc1qvyhzxqlsv8cuel2tee7ha97xektrfxxupza40s',
                cluster: 106745901,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1': 'bc1qzeuvha23qn029gq2a2k5jal0v2d4e4kej3sa44',
                listType: 'Unknown sources',
                share: 0.0004240239765760123,
                amountDec: 0.00009812698533787572,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 15,
                amount: 9793.687407339023,
                amountCur: 11.534118404241228,
                currency: '',
                tx_hash:
                  '445753eb1d09607b1cbd3ca0e9fd3b1521fb38a99bf7749b4d7e1a1c491256d4',
                address: 'bc1qvyhzxqlsv8cuel2tee7ha97xektrfxxupza40s',
                cluster: 106745901,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1': 'bc1qty5hyntwrxtsehpkxe7s876yf7myux2crl2ama',
                listType: 'Unknown sources',
                share: 0.00042320247233758627,
                amountDec: 0.00009793687407339022,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 18,
                amount: 9731.019708001668,
                amountCur: 11.460314061278762,
                currency: '',
                tx_hash:
                  '8b38797dbe1be676cab36b2b043490f58037a5405c87b0792947539189cc0883',
                address: '3CW24NViy1rVCRCxXnHx5sHBx3vTh96XJz',
                cluster: 502154,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1qz9klg6jprzxzh606wlh4q6qvu3rq4vx4wppzsy',
                listType: 'Known sources',
                share: 0.00042049449073758104,
                amountDec: 0.00009731019708001668,
              },
              {
                directTx:
                  '8b958dddab75042d8501cdf2b632dc92c182d0ede8aeafa1343795deea710a00',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9462,
                amountCur: 11.14348700359256,
                currency: '',
                tx_hash:
                  '8b958dddab75042d8501cdf2b632dc92c182d0ede8aeafa1343795deea710a00',
                address: null,
                directStamp: 1709397226,
                timestamp: 1709397226,
                listType: 'Unknown sources',
                share: 0.00040886967560936627,
                amountDec: 0.00009462,
              },
              {
                directTx:
                  '15828097106bb48c8a605998274ce9aecb0af159124af083f8ae6fd43b549438',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  '15828097106bb48c8a605998274ce9aecb0af159124af083f8ae6fd43b549438',
                address: null,
                directStamp: 1706910679,
                timestamp: 1706910679,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  '1df17c2eb19139f76a75840ddf6c25f31929551eeddc4a5c0cfe27abe4f6cf9b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  '1df17c2eb19139f76a75840ddf6c25f31929551eeddc4a5c0cfe27abe4f6cf9b',
                address: null,
                directStamp: 1706910067,
                timestamp: 1706910067,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  '1e73785748b83336d94a348f26a35daea5e4e1235565de0dcbfb4041c4d9f4cb',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  '1e73785748b83336d94a348f26a35daea5e4e1235565de0dcbfb4041c4d9f4cb',
                address: null,
                directStamp: 1706906665,
                timestamp: 1706906665,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  '1f5d47ebb39b0264cb417affa8f87c7e9dfc646a71ea66332b1d2ee2434598f9',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  '1f5d47ebb39b0264cb417affa8f87c7e9dfc646a71ea66332b1d2ee2434598f9',
                address: null,
                directStamp: 1706908811,
                timestamp: 1706908811,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  '529122b34de8a57b9d5716162e0600c34a9cdde1be1154ce61a11fc8c79b740d',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  '529122b34de8a57b9d5716162e0600c34a9cdde1be1154ce61a11fc8c79b740d',
                address: null,
                directStamp: 1706908363,
                timestamp: 1706908363,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  '582898a59cfc5f0e16081aee6f427fe42203bb2c9bd6740a75bb378a2762faa8',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  '582898a59cfc5f0e16081aee6f427fe42203bb2c9bd6740a75bb378a2762faa8',
                address: null,
                directStamp: 1706910855,
                timestamp: 1706910855,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  '65c754e732d668489bd991844630ec1634e9c731c735bf2f5732a8d8ab653b75',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  '65c754e732d668489bd991844630ec1634e9c731c735bf2f5732a8d8ab653b75',
                address: null,
                directStamp: 1706907832,
                timestamp: 1706907832,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  'ac26e3ab00d7ef8afdf65d18d85c5433a89b649ea34a4edd779ab6194889b305',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  'ac26e3ab00d7ef8afdf65d18d85c5433a89b649ea34a4edd779ab6194889b305',
                address: null,
                directStamp: 1706907832,
                timestamp: 1706907832,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  'b954868b4a1606c9ee73841cc5860f8bf9bee0bb1441b7be1d7786ec03b36113',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  'b954868b4a1606c9ee73841cc5860f8bf9bee0bb1441b7be1d7786ec03b36113',
                address: null,
                directStamp: 1706902166,
                timestamp: 1706902166,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  'ce51f13b7ef3308125fe1aea253c5777b7374df2e9d9ff4165bfb7f77bf2c504',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  'ce51f13b7ef3308125fe1aea253c5777b7374df2e9d9ff4165bfb7f77bf2c504',
                address: null,
                directStamp: 1706914192,
                timestamp: 1706914192,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  'd2d0ea467bab7c56f240b2ddb322b0a9c088169995c1257ccf95f30abd1a5597',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 9000,
                amountCur: 10.599385228528117,
                currency: '',
                tx_hash:
                  'd2d0ea467bab7c56f240b2ddb322b0a9c088169995c1257ccf95f30abd1a5597',
                address: null,
                directStamp: 1706907832,
                timestamp: 1706907832,
                listType: 'Unknown sources',
                share: 0.0003889058423678183,
                amountDec: 0.00009,
              },
              {
                directTx:
                  '76cbb81853c72beaf7d9f7050eac69c33ab1adee091c6ad6dd4e9d202f91a783',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 8736,
                amountCur: 10.288469928491292,
                currency: '',
                tx_hash:
                  'dc0ea2c396aff4e5366a84f5bfb239d9022adc0afac63bf418a9f7a70c4437be',
                address: null,
                directStamp: 1710798909,
                timestamp: 1710798909,
                listType: 'Unknown sources',
                share: 0.00037749793765836227,
                amountDec: 0.00008736,
              },
              {
                directTx:
                  '21c1ffad4bc9d077fb33a01e8ea9cbb0730fabace5e21a84866ac72f4e249ff1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 8692,
                amountCur: 10.236650711818488,
                currency: '',
                tx_hash:
                  '201e535b4f6cbc53166971a54c083c660fb2b89ac3073b19c933c904e22447f6',
                address: null,
                directStamp: 1726085146,
                timestamp: 1726085146,
                listType: 'Unknown sources',
                share: 0.0003755966202067863,
                amountDec: 0.00008692,
              },
              {
                directTx:
                  '486c5b20dd3a19f2b733476197bf11ab7544fc153eefe4ff3c83a26411a0865a',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 8398.168511991646,
                amountCur: 9.89060258585491,
                currency: '',
                tx_hash:
                  '486c5b20dd3a19f2b733476197bf11ab7544fc153eefe4ff3c83a26411a0865a',
                address:
                  'bc1ptdt9ypvmh9lrah9tvmne2gjcvmp74j2h3txjjcsy8cxph5n7vags3v3xsd',
                cluster: 3310,
                directStamp: 1729863097,
                timestamp: 1729863097,
                listType: 'Risky sources',
                share: 0.00036289964438922196,
                amountDec: 0.00008398168511991645,
              },
              {
                directTx:
                  'bd72f68944183112742ab154d19a92c07ecfe6d8fbec4d974b56d095d811f281',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 8390,
                amountCur: 9.880982451927878,
                currency: '',
                tx_hash:
                  'bd72f68944183112742ab154d19a92c07ecfe6d8fbec4d974b56d095d811f281',
                address: null,
                directStamp: 1712786159,
                timestamp: 1712786159,
                listType: 'Unknown sources',
                share: 0.0003625466686073328,
                amountDec: 0.0000839,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 13,
                amount: 8159.0729598574235,
                amountCur: 9.609017489910661,
                currency: '',
                tx_hash:
                  'fe037fc80d345e7137f5c449513819bb2ac1b2b0819cdd0e130a8b670c0a70e3',
                address: 'bc1qmwusv9pzflms7a6tmzcgzm0jknhyvzvfer0yqv',
                cluster: 130955154,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1':
                  'bc1pp36gn0cchdr2yqssuul4qu43tapqfkukt3ecx68xd9n7ec92lr9qwsd3q3',
                listType: 'Unknown sources',
                share: 0.0003525679047104266,
                amountDec: 0.00008159072959857423,
              },
              {
                directTx:
                  '04f6b8906b0f0ece0f8c06115e3cc6066a26048e6031059915fd8006f35980ba',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 8000,
                amountCur: 9.42167575869166,
                currency: '',
                tx_hash:
                  '04f6b8906b0f0ece0f8c06115e3cc6066a26048e6031059915fd8006f35980ba',
                address: null,
                directStamp: 1706915380,
                timestamp: 1706915380,
                listType: 'Unknown sources',
                share: 0.00034569408210472733,
                amountDec: 0.00008,
              },
              {
                directTx:
                  '6625c8448d07c1a8ac75e39644c77e995ccb73a5e37850cbd1268c79b4723169',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 8000,
                amountCur: 9.42167575869166,
                currency: '',
                tx_hash:
                  '6625c8448d07c1a8ac75e39644c77e995ccb73a5e37850cbd1268c79b4723169',
                address: null,
                directStamp: 1706904820,
                timestamp: 1706904820,
                listType: 'Unknown sources',
                share: 0.00034569408210472733,
                amountDec: 0.00008,
              },
              {
                directTx:
                  '7a80b32a6553371cde6f342197f960711e0c9b9facca2852d2a27c2ac6c94d17',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 8000,
                amountCur: 9.42167575869166,
                currency: '',
                tx_hash:
                  '7a80b32a6553371cde6f342197f960711e0c9b9facca2852d2a27c2ac6c94d17',
                address: null,
                directStamp: 1707010361,
                timestamp: 1707010361,
                listType: 'Unknown sources',
                share: 0.00034569408210472733,
                amountDec: 0.00008,
              },
              {
                directTx:
                  '8e82d912cbd87e496cd41db142b6fbf8a7bc2ad8c12b0cf0a24029e100db230e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 8000,
                amountCur: 9.42167575869166,
                currency: '',
                tx_hash:
                  '8e82d912cbd87e496cd41db142b6fbf8a7bc2ad8c12b0cf0a24029e100db230e',
                address: null,
                directStamp: 1706914192,
                timestamp: 1706914192,
                listType: 'Unknown sources',
                share: 0.00034569408210472733,
                amountDec: 0.00008,
              },
              {
                directTx:
                  '913550fc315bd10dfac8711f39baf194f1a01741bdb2600b2920b86ee949e12c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 8000,
                amountCur: 9.42167575869166,
                currency: '',
                tx_hash:
                  '913550fc315bd10dfac8711f39baf194f1a01741bdb2600b2920b86ee949e12c',
                address: null,
                directStamp: 1706905025,
                timestamp: 1706905025,
                listType: 'Unknown sources',
                share: 0.00034569408210472733,
                amountDec: 0.00008,
              },
              {
                directTx:
                  '92f8a6cddc96c3c285ef1dd15709ac0dc5d60b997a37b74faf8908108050cb8a',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 8000,
                amountCur: 9.42167575869166,
                currency: '',
                tx_hash:
                  '92f8a6cddc96c3c285ef1dd15709ac0dc5d60b997a37b74faf8908108050cb8a',
                address: null,
                directStamp: 1706913351,
                timestamp: 1706913351,
                listType: 'Unknown sources',
                share: 0.00034569408210472733,
                amountDec: 0.00008,
              },
              {
                directTx:
                  'b810f917b3975bcc0eda08c7f8f13bd927965dbcefdb8985720dad516ed22a0d',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 8000,
                amountCur: 9.42167575869166,
                currency: '',
                tx_hash:
                  'b810f917b3975bcc0eda08c7f8f13bd927965dbcefdb8985720dad516ed22a0d',
                address: null,
                directStamp: 1706913351,
                timestamp: 1706913351,
                listType: 'Unknown sources',
                share: 0.00034569408210472733,
                amountDec: 0.00008,
              },
              {
                directTx:
                  'd10e2cdfeda324907b1d9200e37eaf3542e1fc9d0da0a206949e076c9c8cd387',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 8000,
                amountCur: 9.42167575869166,
                currency: '',
                tx_hash:
                  'd10e2cdfeda324907b1d9200e37eaf3542e1fc9d0da0a206949e076c9c8cd387',
                address: null,
                directStamp: 1706903137,
                timestamp: 1706903137,
                listType: 'Unknown sources',
                share: 0.00034569408210472733,
                amountDec: 0.00008,
              },
              {
                directTx:
                  'eeb34355f142408e859bb397cf61195a1dc7d54d5c2cbe36d90d4cd24c3c5f76',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 8000,
                amountCur: 9.42167575869166,
                currency: '',
                tx_hash:
                  'eeb34355f142408e859bb397cf61195a1dc7d54d5c2cbe36d90d4cd24c3c5f76',
                address: null,
                directStamp: 1706911662,
                timestamp: 1706911662,
                listType: 'Unknown sources',
                share: 0.00034569408210472733,
                amountDec: 0.00008,
              },
              {
                directTx:
                  '8fb560012bc7b7589fffa852b9ef832a4de964238d91dba67df02242812917ae',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 7880,
                amountCur: 9.280350622311284,
                currency: '',
                tx_hash:
                  '8fb560012bc7b7589fffa852b9ef832a4de964238d91dba67df02242812917ae',
                address:
                  'bc1p7en40zu9hmf9d3luh8evmfyg655pu5k2gtna6j7zr623f9tz7z0stfnwav',
                cluster: 3310,
                directStamp: 1700692462,
                timestamp: 1700692462,
                listType: 'Risky sources',
                share: 0.0003405086708731564,
                amountDec: 0.0000788,
              },
              {
                directTx:
                  'ec49c7eeb389a19722f88a25dd95bb6e26595efb07883d4e4ae26d7519732b5c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 2,
                amount: 7846.000000000001,
                amountCur: 9.240308500336846,
                currency: '',
                tx_hash:
                  'a1441ba0b51e1b53ffe828c462849cf216ccaf03433b69f2c1f088cdcbd7adfb',
                address:
                  'bc1pkku07lrdlcumywl7dk4plzn8ymmg5q7v4z5q27da6zp5xsysf6nsqs76qd',
                directStamp: 1700650693,
                timestamp: 1700650693,
                'address-1':
                  'bc1pfmu4vy5gxkvu64jkefkezlqzanj2jurxrh4fu98ynxauxusy3zxst5vh9k',
                listType: 'Unknown sources',
                share: 0.0003390394710242114,
                amountDec: 0.00007846,
              },
              {
                directTx:
                  '304fb4833688f7c1a19bb778b5b96ccc528117dec104bb29474b155ca231ede2',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 7352,
                amountCur: 8.658520022237635,
                currency: '',
                tx_hash:
                  '304fb4833688f7c1a19bb778b5b96ccc528117dec104bb29474b155ca231ede2',
                address: null,
                directStamp: 1736370836,
                timestamp: 1736370836,
                listType: 'Unknown sources',
                share: 0.0003176928614542444,
                amountDec: 0.00007352,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 19,
                amount: 7039.829600861721,
                amountCur: 8.290873986969856,
                currency: '',
                tx_hash:
                  '1245f1c061a5866bbdfe55e4d879b89ee02b78d2be3f99e2617f611a0ac46885',
                address: '3JU3Mip4WT3G38SbymyXNGP81Q4TrEkAwC',
                cluster: 502154,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1qn25hqw09zadvtvskz70vkvfh4v8709kpmp0a4w',
                listType: 'Known sources',
                share: 0.0003042034290054477,
                amountDec: 0.00007039829600861721,
              },
              {
                directTx:
                  '0b758207eefe4804331483ff67be10bf3a2456d9a6d54339466f8c950888f5d3',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 7000,
                amountCur: 8.243966288855201,
                currency: '',
                tx_hash:
                  '0b758207eefe4804331483ff67be10bf3a2456d9a6d54339466f8c950888f5d3',
                address: null,
                directStamp: 1709765580,
                timestamp: 1709765580,
                listType: 'Unknown sources',
                share: 0.0003024823218416364,
                amountDec: 0.00007,
              },
              {
                directTx:
                  'ba68a044e216d7bd81d815ad923acce9719f400378da54ae8b83a5748c91014e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 7000,
                amountCur: 8.243966288855201,
                currency: '',
                tx_hash:
                  'ba68a044e216d7bd81d815ad923acce9719f400378da54ae8b83a5748c91014e',
                address: null,
                directStamp: 1727523955,
                timestamp: 1727523955,
                listType: 'Unknown sources',
                share: 0.0003024823218416364,
                amountDec: 0.00007,
              },
              {
                directTx:
                  'c9e677e767bfc4d6678a108c64f39bb0670d79350798344f26f32389153cfe77',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 7000,
                amountCur: 8.243966288855201,
                currency: '',
                tx_hash:
                  'c9e677e767bfc4d6678a108c64f39bb0670d79350798344f26f32389153cfe77',
                address: null,
                directStamp: 1708387563,
                timestamp: 1708387563,
                listType: 'Unknown sources',
                share: 0.0003024823218416364,
                amountDec: 0.00007,
              },
              {
                directTx:
                  'd67a54960546a9f27b709d92f1ee16c1b53e52518837ed6a6d5cac808d641829',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 2,
                amount: 6885,
                amountCur: 8.10852969982401,
                currency: '',
                tx_hash:
                  '8eab62606a86ec084e7688543891d95b7a7c506b7b89e2fa7985bab1ad04d93d',
                address: 'bc1qrapuux9ftpu509xeum509n966ln6sytgh3mswp',
                cluster: 3310,
                directStamp: 1723105790,
                timestamp: 1723105790,
                'address-1':
                  'bc1pjuqwyu3yvd9cc4a52p3e9kxp5umdfhr3rqmqcfhu06f7sxu87xmsru7ga0',
                listType: 'Risky sources',
                share: 0.00029751296941138097,
                amountDec: 0.00006885,
              },
              {
                directTx:
                  '97ee1170f5650a50708156d4356b068bc6a29add2ca82473e9ac7279df289ec6',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 6832,
                amountCur: 8.046111097922676,
                currency: '',
                tx_hash:
                  'cd8675db581ab6b1072e01d7dc344fe498f88d3ed2b4a2a876462d3c74ade0af',
                address: 'bc1qy5juna3p822cvyw585zg6wfcm60ys56jvaa99m',
                cluster: 110126834,
                directStamp: 1706915380,
                timestamp: 1706915380,
                'address-1':
                  'bc1p5vjegyvvp4z70569t3fu7eu0r84k8vpqdrj9ufgedkntjlywlkqswqpp3g',
                listType: 'Unknown sources',
                share: 0.00029522274611743713,
                amountDec: 0.00006832,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 3,
                amount: 6763.4919710773975,
                amountCur: 7.965428543500698,
                currency: '',
                tx_hash:
                  '3bbffe5bc1e7ffd61441e561675b40ca77403048f01eddf1dc2de9e9f91b8e07',
                address: 'bc1qd2nj4anlxpevmfaj6vfe0lm9p635jfzytx7kry',
                cluster: 126727789,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1': 'bc1q8fkwj7gkw0r6jtf75e9x2vpjqccheewcxvfa49',
                listType: 'Unknown sources',
                share: 0.00029226239359553675,
                amountDec: 0.00006763491971077398,
              },
              {
                directTx:
                  'd67a54960546a9f27b709d92f1ee16c1b53e52518837ed6a6d5cac808d641829',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 6,
                amount: 6661.630111994107,
                amountCur: 7.84546486744316,
                currency: '',
                tx_hash:
                  'f6b4a076db345d3e6137ae5f6dab96387b9673d2ea58844e59f2d96113445f35',
                address:
                  'bc1qu0ckrrzqs4eck4u5aflrdyp8qhh4xntnlk34zgf9lfx9p5xqyfuq7v6ruq',
                directStamp: 1723105790,
                timestamp: 1723105790,
                'address-1':
                  'bc1qlu5lku8cas22ya9dzvnf9hsq0pf4plhj8wr4ktqcq0wsrsxwl8us9lumhx',
                listType: 'Unknown sources',
                share: 0.00028786076336087687,
                amountDec: 0.00006661630111994108,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 14,
                amount: 6599.184459767888,
                amountCur: 7.771922031466228,
                currency: '',
                tx_hash:
                  '2a13cfa15ead60ed65fd9a760c71559bc45f3925de98f93f6ff047783ba40e75',
                address: 'bc1qvyhzxqlsv8cuel2tee7ha97xektrfxxupza40s',
                cluster: 106745901,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1':
                  'bc1q3x7qgwqj5jv603j0y8qmty7dy9wvskpjt7ajmjudehtvxxf0zzgq2w5mds',
                listType: 'Unknown sources',
                share: 0.00028516237680740515,
                amountDec: 0.00006599184459767888,
              },
              {
                directTx:
                  'c07761209b5a14f5408be9285aa351a212c67ca5608a9b3836053364d7aebe84',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 6593.098916595013,
                amountCur: 7.764755029642434,
                currency: '',
                tx_hash:
                  'c07761209b5a14f5408be9285aa351a212c67ca5608a9b3836053364d7aebe84',
                address: 'bc1qp4m6yyudh2548hxn5cufzxeqx72f6gld7fxay4',
                cluster: 3310,
                directStamp: 1732558077,
                timestamp: 1732558077,
                listType: 'Risky sources',
                share: 0.0002848994097747482,
                amountDec: 0.00006593098916595013,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 16,
                amount: 6589.467661805296,
                amountCur: 7.760478466489196,
                currency: '',
                tx_hash:
                  'fd90ecc8b39d5770d015057bed471d9795626c03477cec7e64241344a08224e0',
                address: 'bc1qvyhzxqlsv8cuel2tee7ha97xektrfxxupza40s',
                cluster: 106745901,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1':
                  'bc1pjf9wm7zpg8zv79xsezuupgwgp7qh6rqu3d5tjc6nyfgt7qgra3gq58s0f5',
                listType: 'Unknown sources',
                share: 0.0002847424968633207,
                amountDec: 0.00006589467661805296,
              },
              {
                directTx:
                  '31d5f4f620488890f20bf53a4fb94fd14bbdb497637c97ab8f036d02496a0eb2',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 6000,
                amountCur: 7.0662568190187445,
                currency: '',
                tx_hash:
                  '31d5f4f620488890f20bf53a4fb94fd14bbdb497637c97ab8f036d02496a0eb2',
                address: 'bc1qkf4qtc9jryj4wjpzmd2thlgu84g9dcxefkseny',
                cluster: 3310,
                directStamp: 1736510982,
                timestamp: 1736510982,
                listType: 'Risky sources',
                share: 0.0002592705615785455,
                amountDec: 0.00006,
              },
              {
                directTx:
                  '6c1f2234306f8643e28d8b9afcec46564e962de57b388a44d3893d29e7ead237',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 6000,
                amountCur: 7.0662568190187445,
                currency: '',
                tx_hash:
                  '6c1f2234306f8643e28d8b9afcec46564e962de57b388a44d3893d29e7ead237',
                address:
                  'bc1pq0y0w50wdj32jhwr0jkewnda9mny260al4xpqpeswjxc7v9xn40slx4c0e',
                cluster: 3310,
                directStamp: 1735124346,
                timestamp: 1735124346,
                listType: 'Risky sources',
                share: 0.0002592705615785455,
                amountDec: 0.00006,
              },
              {
                directTx:
                  'b520f8c8b8331e7885b0255f02ec977ba03738df045709617ee2a15e6b83fcb8',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 6000,
                amountCur: 7.0662568190187445,
                currency: '',
                tx_hash:
                  'b520f8c8b8331e7885b0255f02ec977ba03738df045709617ee2a15e6b83fcb8',
                address: null,
                directStamp: 1727524605,
                timestamp: 1727524605,
                listType: 'Unknown sources',
                share: 0.0002592705615785455,
                amountDec: 0.00006,
              },
              {
                directTx:
                  '91a427ab462b15911d50299a771ca4bdf35a285a98d5b361714c96be268b1bad',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 3,
                amount: 5929.742518321119,
                amountCur: 6.983513917518665,
                currency: '',
                tx_hash:
                  'c23caf2eed7d7cd47f3b5c74dc35c476625f9e22f12a2ad4f7aefc2abf698a48',
                address: null,
                directStamp: 1753785243,
                timestamp: 1753785243,
                listType: 'Unknown sources',
                share: 0.0002562346121235492,
                amountDec: 0.00005929742518321119,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 12,
                amount: 5827.771854960219,
                amountCur: 6.863422101633027,
                currency: '',
                tx_hash:
                  '00c8b6fdb685d40241ddd6c90acab96f2b5d323262c85ff5cc4a82b01894360f',
                address: 'bc1qmwusv9pzflms7a6tmzcgzm0jknhyvzvfer0yqv',
                cluster: 130955154,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1':
                  'bc1p9mpn0rr3s4vuqm2y8363pd486l8vulmu4a50dfa9xa8plxjywkqqrhsd7v',
                listType: 'Unknown sources',
                share: 0.00025182828026452963,
                amountDec: 0.00005827771854960219,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 19,
                amount: 5807.985955325326,
                amountCur: 6.84012006026378,
                currency: '',
                tx_hash:
                  'd711a8a090def5fdd12046fcc1183c35529d43cd28464f9302aeee22333dfa19',
                address: 'bc1qmwusv9pzflms7a6tmzcgzm0jknhyvzvfer0yqv',
                cluster: 130955154,
                directStamp: 1733602375,
                timestamp: 1733602375,
                'address-1':
                  'bc1pqluf4c78mcducs33vssad2qmm54h25006t7s72gjjmwnzl7lqzmq7agpx2',
                listType: 'Unknown sources',
                share: 0.0002509732967129171,
                amountDec: 0.000058079859553253265,
              },
              {
                directTx:
                  'b4db12c3cb2ac0e9aa689d325af6c061a2aa59dee187f55c985a50cc5f0f6770',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 2,
                amount: 5807,
                amountCur: 6.838958891340308,
                currency: '',
                tx_hash:
                  'be841ea33edf5eeb2f01b9f6e370c6eec4bd6ce24524ffd138d85e4523a34fe0',
                address: 'bc1qmfej587qvax2qj7qxgpttpfs70xh8m3jf0ucj4',
                cluster: 3310,
                directStamp: 1709416989,
                timestamp: 1709416989,
                'address-1':
                  'bc1p8c2u66hx47n9qw3rv66p2gszhxjn2vxv2as6qevkjmaxu2ta2ausrnf42w',
                listType: 'Risky sources',
                share: 0.000250930691847769,
                amountDec: 0.00005807,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 20,
                amount: 5567.693481593721,
                amountCur: 6.557125338419641,
                currency: '',
                tx_hash:
                  '6726ed456616fa9e0c8e59c68101c05ca525a5d7b008c2836e883d4dced64d18',
                address: '3CW24NViy1rVCRCxXnHx5sHBx3vTh96XJz',
                cluster: 502154,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1qpdnhu3tmpvh4z9r3nfh730kcwmc89c5ya4pz52',
                listType: 'Known sources',
                share: 0.00024058983594500187,
                amountDec: 0.00005567693481593721,
              },
              {
                directTx:
                  '9215d0e45bcd3dbac77b4ec99061253917eb9a320d27bd503398730bfd96c4e5',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 5000,
                amountCur: 5.888547349182287,
                currency: '',
                tx_hash:
                  '9215d0e45bcd3dbac77b4ec99061253917eb9a320d27bd503398730bfd96c4e5',
                address: null,
                directStamp: 1739267385,
                timestamp: 1739267385,
                listType: 'Unknown sources',
                share: 0.00021605880131545457,
                amountDec: 0.00005,
              },
              {
                directTx:
                  'b03747e2d5f51a82f6dc25e62de74c4a5f47ee4d8aebc8cea1e964e022aa61a6',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 5000,
                amountCur: 5.888547349182287,
                currency: '',
                tx_hash:
                  'b03747e2d5f51a82f6dc25e62de74c4a5f47ee4d8aebc8cea1e964e022aa61a6',
                address: null,
                directStamp: 1687627128,
                timestamp: 1687627128,
                listType: 'Unknown sources',
                share: 0.00021605880131545457,
                amountDec: 0.00005,
              },
              {
                directTx:
                  'bd658c03c4e85107fec4ea18338745d088eb558d3554104027eb083fc3b8d6bf',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 5000,
                amountCur: 5.888547349182287,
                currency: '',
                tx_hash:
                  'bd658c03c4e85107fec4ea18338745d088eb558d3554104027eb083fc3b8d6bf',
                address: null,
                directStamp: 1739283971,
                timestamp: 1739283971,
                listType: 'Unknown sources',
                share: 0.00021605880131545457,
                amountDec: 0.00005,
              },
              {
                directTx:
                  'eb7795e63914bfd8a558cf79e2111d207e1e7ecda4fa24efe192b3bcd05482f4',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 5000,
                amountCur: 5.888547349182287,
                currency: '',
                tx_hash:
                  'eb7795e63914bfd8a558cf79e2111d207e1e7ecda4fa24efe192b3bcd05482f4',
                address: null,
                directStamp: 1727470429,
                timestamp: 1727470429,
                listType: 'Unknown sources',
                share: 0.00021605880131545457,
                amountDec: 0.00005,
              },
              {
                directTx:
                  'd05419d27f208d576488ae07da5376c4861e222fffad18a6cb5259a87281b514',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 4999,
                amountCur: 5.887369639712451,
                currency: '',
                tx_hash:
                  'd05419d27f208d576488ae07da5376c4861e222fffad18a6cb5259a87281b514',
                address: null,
                directStamp: 1702091173,
                timestamp: 1702091173,
                listType: 'Unknown sources',
                share: 0.00021601558955519152,
                amountDec: 0.00004999,
              },
              {
                directTx:
                  'b3ff5ab6791fdd8c1de97c7ae1c93a5f244890bbe4dc5d1fdb866d5968565256',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 4687,
                amountCur: 5.5199242851234755,
                currency: '',
                tx_hash:
                  'b3ff5ab6791fdd8c1de97c7ae1c93a5f244890bbe4dc5d1fdb866d5968565256',
                address: null,
                directStamp: 1732199525,
                timestamp: 1732199525,
                listType: 'Unknown sources',
                share: 0.0002025335203531071,
                amountDec: 0.00004687,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 17,
                amount: 4487.59885800336,
                amountCur: 5.285087671897829,
                currency: '',
                tx_hash:
                  '89fb446c841d1956bad3b82ce26e426068a367bfbd80bb449125adfb732792e9',
                address: '3CW24NViy1rVCRCxXnHx5sHBx3vTh96XJz',
                cluster: 502154,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1qs98jwtt22sn5h0cenz3pz9fel6yy6ml7pcsf3e',
                listType: 'Known sources',
                share: 0.00019391704600896177,
                amountDec: 0.0000448759885800336,
              },
              {
                directTx:
                  'ccc8d4e79dec7d754c04c38cce2f8d700d6be936d7538512254c2419758eaa3f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 4259,
                amountCur: 5.015864632033472,
                currency: '',
                tx_hash:
                  'a55fe618428a9914721c999d8138e5a1a6d02ffea56fed70046312a6cee78100',
                address: 'bc1qw7amtsc67a44y0c4na7u0awaz2353c73alwhm7',
                cluster: 129707636,
                directStamp: 1713214284,
                timestamp: 1713214284,
                'address-1':
                  'bc1p93w9fcvahuf0rsh6fc7qdvhsuxweqfw4g58en4r754f7yk0zp2lqy68prd',
                listType: 'Unknown sources',
                share: 0.00018403888696050423,
                amountDec: 0.00004259,
              },
              {
                directTx:
                  '5659cb6d65e3dd3256323f436cdd0934b12d64726cb5eb6f4d4d2313f4bf04f4',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 2,
                amount: 4000,
                amountCur: 4.71083787934583,
                currency: '',
                tx_hash:
                  'a714b7fe859880c45e0d0c3994def4655f87d0fc50835f6b2556cdf196e44efd',
                address:
                  'bc1pv4hl0d2nltrp5vpt4wf0s3r8u4vnjcr89lhmukwc2jq689xhe8js9mhajc',
                cluster: 3310,
                directStamp: 1712839750,
                timestamp: 1712839750,
                'address-1':
                  'bc1pnntj639yqd9f9wevhz2htpujz5aw9qaf8mjkqqdpvs3dzhl3yy7qzndwhs',
                listType: 'Risky sources',
                share: 0.00017284704105236366,
                amountDec: 0.00004,
              },
              {
                directTx:
                  'ccc8d4e79dec7d754c04c38cce2f8d700d6be936d7538512254c2419758eaa3f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 2,
                amount: 4000.0000000000005,
                amountCur: 4.71083787934583,
                currency: '',
                tx_hash:
                  'a55fe618428a9914721c999d8138e5a1a6d02ffea56fed70046312a6cee78100',
                address:
                  'bc1pv4hl0d2nltrp5vpt4wf0s3r8u4vnjcr89lhmukwc2jq689xhe8js9mhajc',
                cluster: 3310,
                directStamp: 1713214284,
                timestamp: 1713214284,
                'address-1':
                  'bc1p93w9fcvahuf0rsh6fc7qdvhsuxweqfw4g58en4r754f7yk0zp2lqy68prd',
                listType: 'Risky sources',
                share: 0.00017284704105236366,
                amountDec: 0.00004,
              },
              {
                directTx:
                  '65858512b8e6498d90e186f9950de5bc8f6e3c3b87e38e48e4ad6f24855c028f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 3986.0762417747173,
                amountCur: 4.694439737428201,
                currency: '',
                tx_hash:
                  '65858512b8e6498d90e186f9950de5bc8f6e3c3b87e38e48e4ad6f24855c028f',
                address:
                  'bc1p7en40zu9hmf9d3luh8evmfyg655pu5k2gtna6j7zr623f9tz7z0stfnwav',
                cluster: 3310,
                directStamp: 1690493629,
                timestamp: 1690493629,
                listType: 'Risky sources',
                share: 0.00017224537094997152,
                amountDec: 0.000039860762417747175,
              },
              {
                directTx:
                  'b4db12c3cb2ac0e9aa689d325af6c061a2aa59dee187f55c985a50cc5f0f6770',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 3228,
                amountCur: 3.8016461686320846,
                currency: '',
                tx_hash:
                  'be841ea33edf5eeb2f01b9f6e370c6eec4bd6ce24524ffd138d85e4523a34fe0',
                address: null,
                directStamp: 1709416989,
                timestamp: 1709416989,
                listType: 'Unknown sources',
                share: 0.0001394875621292575,
                amountDec: 0.00003228,
              },
              {
                directTx:
                  '3e1fed61d6acfbc9361d9d02a00f62ca15acb482d0770236abb053268fbd6704',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 3108,
                amountCur: 3.6603210322517095,
                currency: '',
                tx_hash:
                  '3e1fed61d6acfbc9361d9d02a00f62ca15acb482d0770236abb053268fbd6704',
                address: null,
                directStamp: 1722292286,
                timestamp: 1722292286,
                listType: 'Unknown sources',
                share: 0.00013430215089768656,
                amountDec: 0.00003108,
              },
              {
                directTx:
                  '4d67dabd4158328effb660ae5003edce7fdbd5fb4bf3ca4c433363ba45e33545',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 3108,
                amountCur: 3.6603210322517095,
                currency: '',
                tx_hash:
                  '4d67dabd4158328effb660ae5003edce7fdbd5fb4bf3ca4c433363ba45e33545',
                address: null,
                directStamp: 1722292169,
                timestamp: 1722292169,
                listType: 'Unknown sources',
                share: 0.00013430215089768656,
                amountDec: 0.00003108,
              },
              {
                directTx:
                  '973b01b031f9dabf34f5707ad33b02544af864cf692df09b9e9cf2c4a93c37f7',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 3108,
                amountCur: 3.6603210322517095,
                currency: '',
                tx_hash:
                  '973b01b031f9dabf34f5707ad33b02544af864cf692df09b9e9cf2c4a93c37f7',
                address: null,
                directStamp: 1722292169,
                timestamp: 1722292169,
                listType: 'Unknown sources',
                share: 0.00013430215089768656,
                amountDec: 0.00003108,
              },
              {
                directTx:
                  'fd0c8a5632139763bfc4477c1ee858567040154ea5687dc1e092fe550afde00e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 3107.9999999999995,
                amountCur: 3.660321032251709,
                currency: '',
                tx_hash:
                  'fd0c8a5632139763bfc4477c1ee858567040154ea5687dc1e092fe550afde00e',
                address: null,
                directStamp: 1722291806,
                timestamp: 1722291806,
                listType: 'Unknown sources',
                share: 0.00013430215089768656,
                amountDec: 0.000031079999999999994,
              },
              {
                directTx:
                  'a3978002174ad0ac9c306f74a38f5b08574c9475fa1cac3979248acc62ae7183',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 3062.9999999999995,
                amountCur: 3.6073241061090684,
                currency: '',
                tx_hash:
                  '602f12f17d224e86b001e2f02a43c1085b48e2c69fc756a74e6d16c2d870ce31',
                address: 'bc1qspedfu7kp0w2lv5wl0j46209f68u54pjg3e549',
                cluster: 110126834,
                directStamp: 1700654428,
                timestamp: 1700654428,
                'address-1':
                  'bc1p3hpz0q2yn3lsxae3xw7thf0z2kam2wwlscryvljxxntyxxs0a5zq0lpc72',
                listType: 'Unknown sources',
                share: 0.00013235762168584746,
                amountDec: 0.000030629999999999996,
              },
              {
                directTx:
                  '1d8e83e0003b7f2555750096c63bbe3a037e9d30d3d6e2030d71b1ccee9521c4',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 2990,
                amountCur: 3.5213513148110076,
                currency: '',
                tx_hash:
                  '1d8e83e0003b7f2555750096c63bbe3a037e9d30d3d6e2030d71b1ccee9521c4',
                address: null,
                directStamp: 1689622970,
                timestamp: 1689622970,
                listType: 'Unknown sources',
                share: 0.00012920316318664184,
                amountDec: 0.0000299,
              },
              {
                directTx:
                  '8b9e53acca797787e02c4942e7f503102767fee40f5b17999946b3986bb05bde',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 2941.6209280775533,
                amountCur: 3.464374823666043,
                currency: '',
                tx_hash:
                  '8b9e53acca797787e02c4942e7f503102767fee40f5b17999946b3986bb05bde',
                address:
                  'bc1p9vwn3lyd258xhp2fpnzksv2lvlqvlquu75rcs5aeupulrvaghldqd2fuy3',
                directStamp: 1734555799,
                timestamp: 1734555799,
                listType: 'Unknown sources',
                share: 0.00012711261832897824,
                amountDec: 0.000029416209280775534,
              },
              {
                directTx:
                  '5659cb6d65e3dd3256323f436cdd0934b12d64726cb5eb6f4d4d2313f4bf04f4',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 2798,
                amountCur: 3.2952310966024076,
                currency: '',
                tx_hash:
                  'a714b7fe859880c45e0d0c3994def4655f87d0fc50835f6b2556cdf196e44efd',
                address: 'bc1qlf862326umsdzyq4ywhgc39e0jhn3n5d5xmafv',
                cluster: 129707636,
                directStamp: 1712839750,
                timestamp: 1712839750,
                'address-1':
                  'bc1pnntj639yqd9f9wevhz2htpujz5aw9qaf8mjkqqdpvs3dzhl3yy7qzndwhs',
                listType: 'Unknown sources',
                share: 0.00012090650521612838,
                amountDec: 0.00002798,
              },
              {
                directTx:
                  '027c0bfff4ae150029a98a189a7f7e9e1dfeb3d8a0b9194be1d0070fc9a34ce1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 2652,
                amountCur: 3.1232855140062847,
                currency: '',
                tx_hash:
                  'db308ecbc82e5baf816f47aad468aed8f9d8ad6bb20a63abcc4ac245a94f1850',
                address: 'bc1qsurf52mhrv8dkyn6ndvvsp6uskpmvvg6k5upp4',
                cluster: 110126834,
                directStamp: 1701131802,
                timestamp: 1701131802,
                'address-1':
                  'bc1p39kehklzr0zmj938prht6mz6ncz7tr62usz29lqsuqstu5xmcjwq2fr2jh',
                listType: 'Unknown sources',
                share: 0.0001145975882177171,
                amountDec: 0.00002652,
              },
              {
                directTx:
                  'bd72f68944183112742ab154d19a92c07ecfe6d8fbec4d974b56d095d811f281',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 2410,
                amountCur: 2.838279822305862,
                currency: '',
                tx_hash:
                  'bd72f68944183112742ab154d19a92c07ecfe6d8fbec4d974b56d095d811f281',
                address:
                  'bc1p7en40zu9hmf9d3luh8evmfyg655pu5k2gtna6j7zr623f9tz7z0stfnwav',
                cluster: 3310,
                directStamp: 1712786159,
                timestamp: 1712786159,
                listType: 'Risky sources',
                share: 0.0001041403422340491,
                amountDec: 0.0000241,
              },
              {
                directTx:
                  '8698631b5dc2134d5682a94e0cedbbcedacb3d08420583d50e9412626ce66b72',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 2376,
                amountCur: 2.798237700331423,
                currency: '',
                tx_hash:
                  '8698631b5dc2134d5682a94e0cedbbcedacb3d08420583d50e9412626ce66b72',
                address: null,
                directStamp: 1722437694,
                timestamp: 1722437694,
                listType: 'Unknown sources',
                share: 0.00010267114238510403,
                amountDec: 0.00002376,
              },
              {
                directTx:
                  '4da3c27a240e27f27fd5959410b63476b54510bf5a1cfb5a7439f085998a20de',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 6,
                amount: 2150.810535927789,
                amountCur: 2.5330299359861828,
                currency: '',
                tx_hash:
                  'fd923cb9f0c66bccef15006648a006b4660b6447bdf86bfa2a32988cd57397ba',
                address: 'bc1qf2mjw8hdrr0pv6s597jkxzpzx2vnu4e33fslq0',
                cluster: 113020304,
                directStamp: 1735820508,
                timestamp: 1735820508,
                'address-1': 'bc1q4qzhutfrdjk2gl3c4wkcaurlxhat8mzzymqn9w',
                listType: 'Unknown sources',
                share: 0.00009294030924984169,
                amountDec: 0.000021508105359277887,
              },
              {
                directTx:
                  '4cf76698f27c5d0fa5e009d3df30c26a1887b9401e73feb4c3ebbca826d3edc1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 2079,
                amountCur: 2.448457987789995,
                currency: '',
                tx_hash:
                  '4cf76698f27c5d0fa5e009d3df30c26a1887b9401e73feb4c3ebbca826d3edc1',
                address:
                  'bc1p7en40zu9hmf9d3luh8evmfyg655pu5k2gtna6j7zr623f9tz7z0stfnwav',
                cluster: 3310,
                directStamp: 1688671965,
                timestamp: 1688671965,
                listType: 'Risky sources',
                share: 0.00008983724958696602,
                amountDec: 0.00002079,
              },
              {
                directTx:
                  'ec49c7eeb389a19722f88a25dd95bb6e26595efb07883d4e4ae26d7519732b5c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 1795.0000000000002,
                amountCur: 2.1139884983564414,
                currency: '',
                tx_hash:
                  'a1441ba0b51e1b53ffe828c462849cf216ccaf03433b69f2c1f088cdcbd7adfb',
                address: 'bc1qyhnygy87lprmsz09m8jfydyrk6rzchumqlvt0q',
                cluster: 110126834,
                directStamp: 1700650693,
                timestamp: 1700650693,
                'address-1':
                  'bc1pfmu4vy5gxkvu64jkefkezlqzanj2jurxrh4fu98ynxauxusy3zxst5vh9k',
                listType: 'Unknown sources',
                share: 0.00007756510967224822,
                amountDec: 0.000017950000000000003,
              },
              {
                directTx:
                  'c60fb123607d6dee9e084d03bda0009c7080855ba7c79e2c951dc9a2935ea01b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 1671.0000000000002,
                amountCur: 1.9679525240967206,
                currency: '',
                tx_hash:
                  'c60fb123607d6dee9e084d03bda0009c7080855ba7c79e2c951dc9a2935ea01b',
                address:
                  'bc1p7cfdjcgyew5ullrmv7hc4rj8v2tc7lesekkv6dyyyhmj2g2uj45q6mh9wz',
                cluster: 3310,
                directStamp: 1753392941,
                timestamp: 1753392941,
                listType: 'Risky sources',
                share: 0.00007220685139962493,
                amountDec: 0.00001671,
              },
              {
                directTx:
                  '4cf76698f27c5d0fa5e009d3df30c26a1887b9401e73feb4c3ebbca826d3edc1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 1650,
                amountCur: 1.9432206252301547,
                currency: '',
                tx_hash:
                  '4cf76698f27c5d0fa5e009d3df30c26a1887b9401e73feb4c3ebbca826d3edc1',
                address: null,
                directStamp: 1688671965,
                timestamp: 1688671965,
                listType: 'Unknown sources',
                share: 0.00007129940443410002,
                amountDec: 0.0000165,
              },
              {
                directTx:
                  'f1cac543a7d0c3f8db46fe3c94e7ec54e70c166f3543fb418aa75e169fbdb483',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 1463.3177802045072,
                amountCur: 1.7233632071269118,
                currency: '',
                tx_hash:
                  'b96f97af0779b9222f3172e7f735cd49b9f6ff6e56b81912fbcb1c6fa5e79dd9',
                address: null,
                directStamp: 1730992752,
                timestamp: 1730992752,
                listType: 'Unknown sources',
                share: 0.00006323253710691554,
                amountDec: 0.000014633177802045072,
              },
              {
                directTx:
                  '83fd0b57472e7bd670b41dbe7f2efa450ecea278c8268020fb2056b40104b94a',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 2,
                amount: 1235.7874513405761,
                amountCur: 1.4553985841488568,
                currency: '',
                tx_hash:
                  'fd7f009ee0c53b489ef50ccbbbceb0fe554b64f251f18d54755fa09a904c63f0',
                address: null,
                directStamp: 1689963589,
                timestamp: 1689963589,
                listType: 'Unknown sources',
                share: 0.000053400551083465106,
                amountDec: 0.000012357874513405761,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 10,
                amount: 948.617495118671,
                amountCur: 1.1171958072537982,
                currency: '',
                tx_hash:
                  '7854f86aa0401b0857e6590df197807925772e0e325c816b3fd48b48b74b8233',
                address: '1EaqnU3H8znxwbgknhy6AACMCom7oEZsiE',
                cluster: 96199223,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1qra2fvrqy9990dar9fkqyhrh5tm7p75h30essnz',
                listType: 'Known sources',
                share: 0.000040991431780441826,
                amountDec: 0.00000948617495118671,
              },
              {
                directTx:
                  'b60dda866d9e957979c3a1725f0cf0da8a868fcee639ffefd1eb300fbfeb3b16',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 857.9999999999999,
                amountCur: 1.0104747251196804,
                currency: '',
                tx_hash:
                  'b60dda866d9e957979c3a1725f0cf0da8a868fcee639ffefd1eb300fbfeb3b16',
                address: null,
                directStamp: 1738415551,
                timestamp: 1738415551,
                listType: 'Unknown sources',
                share: 0.000037075690305732,
                amountDec: 0.00000858,
              },
              {
                directTx:
                  '4b826bdd7314927411ea4fc9677d43669912e9372effb1560a404c54bdb01006',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                },
                owner: 'OKX',
                depth: 3,
                amount: 790.3392758863655,
                amountCur: 0.9307900495950612,
                currency: '',
                tx_hash:
                  'f20dc8a2e93a4b1f18b20e69bf0a621b01ea83613a4cf85bacfcb63b5d73f5df',
                address: '3A3Z58i4PzSFm5Uk77DAsS2R719cexD3LH',
                cluster: 42345622,
                directStamp: 1688055893,
                timestamp: 1688055893,
                'address-1':
                  'bc1q8055u038hjjtz0nhptllc9xm9sy9u0mrx78c09jqxtjqhn58zh0qqw6gzm',
                listType: 'Known sources',
                share: 0.0000341519513161065,
                amountDec: 0.000007903392758863656,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Binance',
                depth: 12,
                amount: 594.368896990234,
                amountCur: 0.6999938785616484,
                currency: '',
                tx_hash:
                  '7861e7a8bc848d9b848f0dd803130b13b791158384d148ccccb18ff0942863ef',
                address: '1EaqnU3H8znxwbgknhy6AACMCom7oEZsiE',
                cluster: 96199223,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1qmrmccfqt6lt987juzsck974q29gpx4s0gjf4tv',
                listType: 'Known sources',
                share: 0.00002568372628457977,
                amountDec: 0.0000059436889699023404,
              },
              {
                directTx:
                  'a8e214e6d39166c8e52f14b1ba0d8bf9c524b8fe77f5a553ada13bac2f1eccc7',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 578.2874015748032,
                amountCur: 0.681054549121764,
                currency: '',
                tx_hash:
                  'a8e214e6d39166c8e52f14b1ba0d8bf9c524b8fe77f5a553ada13bac2f1eccc7',
                address: 'bc1qcq2uv5nk6hec6kvag3wyevp6574qmsm9scjxc2',
                directStamp: 1723110185,
                timestamp: 1723110185,
                listType: 'Unknown sources',
                share: 0.00002498881656001618,
                amountDec: 0.000005782874015748032,
              },
              {
                directTx:
                  'df06ce2d6b39d711f0c52df89f09f3c272d5df9e273c25e4d2bff9a9d3f9268e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 578.2081009994739,
                amountCur: 0.6809611560832353,
                currency: '',
                tx_hash:
                  'df06ce2d6b39d711f0c52df89f09f3c272d5df9e273c25e4d2bff9a9d3f9268e',
                address: 'bc1qcq2uv5nk6hec6kvag3wyevp6574qmsm9scjxc2',
                directStamp: 1688155292,
                timestamp: 1688155292,
                listType: 'Unknown sources',
                share: 0.00002498538984256633,
                amountDec: 0.0000057820810099947395,
              },
              {
                directTx:
                  'c71532f59c552615242a13d9e0876545a1a1bde163f5340712a204fa9b963caf',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 576.8869884301498,
                amountCur: 0.6794052692996223,
                currency: '',
                tx_hash:
                  'c71532f59c552615242a13d9e0876545a1a1bde163f5340712a204fa9b963caf',
                address: 'bc1qp8j9sx6609h7llqufurxjgrwsqwt020tqzn0gs',
                directStamp: 1738861309,
                timestamp: 1738861309,
                listType: 'Unknown sources',
                share: 0.00002492830224294014,
                amountDec: 0.000005768869884301498,
              },
              {
                directTx:
                  '6969004b76384b994117e509a3d084149775675e20dc6baa2f4414349a433d40',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 1,
                amount: 576.8279444299396,
                amountCur: 0.6793357326214376,
                currency: '',
                tx_hash:
                  '6969004b76384b994117e509a3d084149775675e20dc6baa2f4414349a433d40',
                address: '3P4WqXDbSLRhzo2H6MT6YFbvBKBDPLbVtQ',
                cluster: 85980607,
                directStamp: 1711998239,
                timestamp: 1711998239,
                listType: 'Known sources',
                share: 0.00002492575084775808,
                amountDec: 0.000005768279444299396,
              },
              {
                directTx:
                  '15647244c22f471bb0a0c4a9c7360a3c5e25276f9c5e4b2eca00542cdd2a053e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 1,
                amount: 575.8558271835776,
                amountCur: 0.6781908609346058,
                currency: '',
                tx_hash:
                  '15647244c22f471bb0a0c4a9c7360a3c5e25276f9c5e4b2eca00542cdd2a053e',
                address: '3P4WqXDbSLRhzo2H6MT6YFbvBKBDPLbVtQ',
                cluster: 85980607,
                directStamp: 1713567412,
                timestamp: 1713567412,
                listType: 'Known sources',
                share: 0.000024883743950360668,
                amountDec: 0.000005758558271835776,
              },
              {
                directTx:
                  '1be84f86a42476b265b1bd70c887da3d3de9916faeecc005fb2520db9056ba4b',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 546,
                amountCur: 0.6430293705307057,
                currency: '',
                tx_hash:
                  '1be84f86a42476b265b1bd70c887da3d3de9916faeecc005fb2520db9056ba4b',
                address: null,
                directStamp: 1727524902,
                timestamp: 1727524902,
                listType: 'Unknown sources',
                share: 0.000023593621103647642,
                amountDec: 0.00000546,
              },
              {
                directTx:
                  '22b707c6258a8477c8f14c896885ed0132a8c5ec003a1e851d3cb9bcabf3e56c',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 546,
                amountCur: 0.6430293705307057,
                currency: '',
                tx_hash:
                  '22b707c6258a8477c8f14c896885ed0132a8c5ec003a1e851d3cb9bcabf3e56c',
                address:
                  'bc1p6zgg8j70qdxjly75mrk7clsqfaydvfskf27e6cfnhwmd2w4vn55shycuxr',
                cluster: 3310,
                directStamp: 1731092446,
                timestamp: 1731092446,
                listType: 'Risky sources',
                share: 0.000023593621103647642,
                amountDec: 0.00000546,
              },
              {
                directTx:
                  '6604e583823010c2096d732c72a50ef00acd6a653448b428775ef7dd40dad8a5',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 546,
                amountCur: 0.6430293705307057,
                currency: '',
                tx_hash:
                  '6604e583823010c2096d732c72a50ef00acd6a653448b428775ef7dd40dad8a5',
                address: null,
                directStamp: 1739281536,
                timestamp: 1739281536,
                listType: 'Unknown sources',
                share: 0.000023593621103647642,
                amountDec: 0.00000546,
              },
              {
                directTx:
                  '73fe023779cff85f5794deb5fd34a87f3978f873c55a9c0e2477f8fdcffdad11',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 546,
                amountCur: 0.6430293705307057,
                currency: '',
                tx_hash:
                  '73fe023779cff85f5794deb5fd34a87f3978f873c55a9c0e2477f8fdcffdad11',
                address: 'bc1qcmj5lkumeycyn35lxc3yr32k3fzue87yrjrna6',
                cluster: 122276901,
                directStamp: 1711181462,
                timestamp: 1711181462,
                listType: 'Unknown sources',
                share: 0.000023593621103647642,
                amountDec: 0.00000546,
              },
              {
                directTx:
                  '83ff1998c6a69c66ab3bd2924cf30cfd382a78efb4686aab7af78ff45ceb91c8',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 1,
                amount: 546,
                amountCur: 0.6430293705307057,
                currency: '',
                tx_hash:
                  '83ff1998c6a69c66ab3bd2924cf30cfd382a78efb4686aab7af78ff45ceb91c8',
                address:
                  'bc1pt69lzr8eha4w3mx6man3h7unk0rzs6f8kxg9nmf9476rk26yxc3sqra8dg',
                directStamp: 1739491461,
                timestamp: 1739491461,
                listType: 'Unknown sources',
                share: 0.000023593621103647642,
                amountDec: 0.00000546,
              },
              {
                directTx:
                  '934b4adea27c3a4d3d18334200e68eda9ea6f6835e1149400e6d36f37a29e56f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 546,
                amountCur: 0.6430293705307057,
                currency: '',
                tx_hash:
                  '934b4adea27c3a4d3d18334200e68eda9ea6f6835e1149400e6d36f37a29e56f',
                address: 'bc1qptgujmlkez7e6744yctzjgztu0st372mxs6702',
                cluster: 122276901,
                directStamp: 1708457382,
                timestamp: 1708457382,
                listType: 'Unknown sources',
                share: 0.000023593621103647642,
                amountDec: 0.00000546,
              },
              {
                directTx:
                  'a4b56d3ab5cfd90f9b7032caa5530aae75a27dbc9bf7d5d3dbbc3ca6bf5b77e5',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                },
                owner: 'small transactions',
                depth: 1,
                amount: 546,
                amountCur: 0.6430293705307057,
                currency: '',
                tx_hash:
                  'a4b56d3ab5cfd90f9b7032caa5530aae75a27dbc9bf7d5d3dbbc3ca6bf5b77e5',
                address: null,
                directStamp: 1727524308,
                timestamp: 1727524308,
                listType: 'Unknown sources',
                share: 0.000023593621103647642,
                amountDec: 0.00000546,
              },
              {
                directTx:
                  '15647244c22f471bb0a0c4a9c7360a3c5e25276f9c5e4b2eca00542cdd2a053e',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 544.0295983927755,
                amountCur: 0.6407088098984964,
                currency: '',
                tx_hash:
                  '15647244c22f471bb0a0c4a9c7360a3c5e25276f9c5e4b2eca00542cdd2a053e',
                address:
                  'bc1pq5z0hvxnewyz2kr40j4d32nx9tn0jx0vvdsvjnlckjekyhdm0j6qh7w6hf',
                cluster: 3310,
                directStamp: 1713567412,
                timestamp: 1713567412,
                listType: 'Risky sources',
                share: 0.000023508476581774247,
                amountDec: 0.000005440295983927755,
              },
              {
                directTx:
                  '8b9e53acca797787e02c4942e7f503102767fee40f5b17999946b3986bb05bde',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 535.3750089101147,
                amountCur: 0.6305162179072199,
                currency: '',
                tx_hash:
                  '8b9e53acca797787e02c4942e7f503102767fee40f5b17999946b3986bb05bde',
                address:
                  'bc1p5a648pn4crxa94t2xhk856pqnjel0d0e5s0h08f090l755zemu2sznsa3v',
                cluster: 3310,
                directStamp: 1734555799,
                timestamp: 1734555799,
                listType: 'Risky sources',
                share: 0.00002313449653587404,
                amountDec: 0.000005353750089101148,
              },
              {
                directTx:
                  'c07761209b5a14f5408be9285aa351a212c67ca5608a9b3836053364d7aebe84',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                },
                owner: 'unhosted wallet',
                depth: 2,
                amount: 405.1708171338818,
                amountCur: 0.4771735082399482,
                currency: '',
                tx_hash:
                  '51c6b268a651335b9e23d8df8cfa96531c6d15fd496e276acb2c4a1da7034c8e',
                address:
                  'bc1pznks2qgzh5444qa6qvk6alr7uypedgpdmakpzttehc2zn9n4twrq5ejuf6',
                directStamp: 1732558077,
                timestamp: 1732558077,
                'address-1':
                  'bc1pznks2qgzh5444qa6qvk6alr7uypedgpdmakpzttehc2zn9n4twrq5ejuf6',
                listType: 'Unknown sources',
                share: 0.000017508144215589953,
                amountDec: 0.000004051708171338818,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 6,
                amount: 276.60760849888493,
                amountCur: 0.3257633999579521,
                currency: '',
                tx_hash:
                  '2008fcd73f4548e0ef15c3a632045cf2069c29b519329f578e923f50645722c2',
                address: '33qg4GjkxT8A7gMsZbzzkC8wgc1SWby79g',
                cluster: 3310,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1q8qalytdpe4jmkefmlv6w33vt3gjzheeeeuzzln',
                listType: 'Risky sources',
                share: 0.000011952701665400724,
                amountDec: 0.0000027660760849888493,
              },
              {
                directTx:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 123.32810903216047,
                amountCur: 0.1452446819041985,
                currency: '',
                tx_hash:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                address: 'bc1qcq2uv5nk6hec6kvag3wyevp6574qmsm9scjxc2',
                directStamp: 1700648582,
                timestamp: 1700648582,
                listType: 'Unknown sources',
                share: 0.000005329224681198056,
                amountDec: 0.0000012332810903216048,
              },
              {
                directTx:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 64.25158548540891,
                amountCur: 0.07566970067817275,
                currency: '',
                tx_hash:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                address:
                  'bc1pc6plmlxyg2qjfe6wfv3jqgvdcsx47jh7j0p3tjkeg9ec6232lfeqe6cn6t',
                cluster: 3310,
                directStamp: 1700648582,
                timestamp: 1700648582,
                listType: 'Risky sources',
                share: 0.0000027764241085189817,
                amountDec: 6.425158548540891e-7,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                },
                owner: 'Coinbase',
                depth: 14,
                amount: 51.23326124616348,
                amountCur: 0.06033789694021191,
                currency: '',
                tx_hash:
                  'bd4405e035e488d84d92c9d903dcf877d19e36664b1e04f9beb1dd740e916e78',
                address: '3CW24NViy1rVCRCxXnHx5sHBx3vTh96XJz',
                cluster: 502154,
                directStamp: 1687958689,
                timestamp: 1687958689,
                'address-1': 'bc1q2fzcqk9aj8dpksn72hxq54kltjcxp7mld95dgg',
                listType: 'Known sources',
                share: 0.000002213879402465523,
                amountDec: 5.123326124616348e-7,
              },
            ],
            currencies: {},
          },
        },
        {
          type: 'risks',
          status: 'Calculated',
          data: {
            totalScore: 51,
            score: {
              sof: [
                {
                  name: 'High-risk exchange',
                  amount: 154530,
                  price: 181.99144437382776,
                  score: 70,
                  share: 0.006231454503824571,
                  generalShare: 0.006231454503824571,
                  deepDepthShare: 0,
                  depth: 1,
                },
              ],
              uof: [
                {
                  name: 'Suspended exchange',
                  amount: 4577399.324048064,
                  price: 5390.846531154403,
                  score: 60,
                  share: 0.19779748221919935,
                  generalShare: 0.17988911006132913,
                  deepDepthShare: 0.017908372157870164,
                  depth: 1,
                },
                {
                  name: 'Gambling',
                  amount: 20737.50813178421,
                  price: 24.422759707612805,
                  score: 60,
                  share: 0.0008961042298445577,
                  generalShare: 0,
                  deepDepthShare: 0.0008961042298445577,
                  depth: 7,
                },
                {
                  name: 'unknown single wallet service',
                  amount: 755291.2283815858,
                  price: 889.5136321494042,
                  score: 50,
                  share: 0.03263746348964054,
                  generalShare: 0.001483695178141898,
                  deepDepthShare: 0.031153768311498638,
                  depth: 4,
                },
                {
                  name: 'small transactions',
                  amount: 1691032.8588494877,
                  price: 1991.5454116716592,
                  score: 50,
                  share: 0.07307250649361334,
                  generalShare: 0.0315060273622663,
                  deepDepthShare: 0.041566479131347034,
                  depth: {
                    minimum: 4,
                    maximum: 18,
                  },
                },
                {
                  name: 'Exchange',
                  amount: 3994025.4355759826,
                  price: 4703.801578245517,
                  score: 50,
                  share: 0.17258886960679665,
                  generalShare: 0.09540141189724291,
                  deepDepthShare: 0.07718745770955374,
                  depth: 1,
                },
              ],
            },
            owner: {
              status: 'Not Identified',
              type: {},
              tags: [],
              meta: [],
              clusterData: {
                _id: '666616289c432e2e9bd1c7c3',
                cluster: 3310,
                address:
                  '003f2a607d1cf5a4ca03526f9f1b25ddb75a77728bec5bbac123b8a1efea659f1',
                addressCount: 16362147,
                updatedAt: '2025-02-25T11:40:05.932Z',
                description: '',
                entity: '6603e868a6a313bd816dba0a',
                owner: 'MtGox',
                prevAddress: '13BYwF1V1gHSgNHCpmTnTAesWAjNgng15G',
                entityData: {
                  id: '6603e868a6a313bd816dba0a',
                  name: 'MtGox',
                  owner: 'MtGox',
                },
                tags: [],
                type: {
                  _id: '6176710e820e13d3f25ded60',
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                },
                meta: [],
                clusterSize: 16362147,
                conflict: true,
              },
            },
          },
        },
        {
          type: 'tier2',
          status: 'TIER2 Found',
          data: {
            labelBarsSof: [
              {
                directTx:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                  type: 'Suspended exchange',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 19277593.01064663,
                amountCur: 22703.403844291628,
                currency: '',
                tx_hash:
                  '9caf62aac639f2f12904c982094bf292f6fb17e9f9ba2ece7dfe0250d4532341',
                address:
                  'bc1pc6plmlxyg2qjfe6wfv3jqgvdcsx47jh7j0p3tjkeg9ec6232lfeqe6cn6t',
                cluster: 3310,
                directStamp: 1700648582,
                timestamp: 1700648582,
                listType: 'Risky sources',
                share: 0.7773,
                amountDec: 0.11442705346663631,
                deepDepthShare: 0.005839533800254578,
                generalShare: 0.7715334280135744,
                price: null,
                originalShare: 0.777372961813829,
              },
              {
                directTx:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Binance',
                entity: '65a8e2c98bc257cd15e58c41',
                depth: 1,
                amount: 4778913.285909507,
                amountCur: 5628.17143234289,
                currency: '',
                tx_hash:
                  'b505a2c03afe36c2264fcb1e98c16eb29602c0c0e8ebf7dfcad869414ff3ba3b',
                address: 'bc1qm34lsc65zpw79lxes69zkqmk6ee3ewf0j77s3h',
                directStamp: 1688055567,
                timestamp: 1688055567,
                listType: 'Known sources',
                share: 0.1927,
                amountDec: 0.03779283,
                deepDepthShare: 0.00741521253522209,
                generalShare: 0.1852954631838479,
                price: null,
                originalShare: 0.19271067571906997,
              },
              {
                directTx:
                  '4e2d99e9dbb7e10777eea046908c7f6c32110004efafbd777b0b93cb581646ee',
                directionUp: false,
                token: '',
                funds: {
                  name: 'maximum depth reached',
                  score: 50,
                  id: '61e08b592536c394af97d392',
                  default: true,
                  type: 'maximum depth reached',
                },
                owner: 'maximum depth reached',
                depth: 20,
                amount: 246433.15057320998,
                amountCur: 290.226655111703,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1706898546,
                timestamp: 1706898546,
                listType: 'Unknown sources',
                share: 0.0099,
                amountDec: 0.002252637786560397,
                deepDepthShare: 0.00993746823290693,
                generalShare: 0,
                price: null,
                originalShare: 0.00993746823290693,
              },
              {
                directTx:
                  'bbe5e6b98f5bad1a37ca2d64564de9c584990e1f6fb18be09439100deab71517',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Online wallet',
                  score: 60,
                  id: '61767102820e13ff395ded5f',
                  type: 'Online wallet',
                },
                owner: 'Cash App',
                depth: 7,
                amount: 206059.86111385567,
                amountCur: 242.678649786973,
                currency: '',
                tx_hash:
                  '5be8f1b8c47989c0287cc106777f666a6bba6ef62e00098dfce2983a3e9bea81',
                address: 'bc1qxj0h49u5n7hmhl2cql3qytnukmrlhtz4xejqf9',
                cluster: 39540539,
                directStamp: 1708096725,
                timestamp: 1708096725,
                listType: 'Risky sources',
                share: 0.0083,
                amountDec: 0.00165685,
                deepDepthShare: 0.008309406908661112,
                generalShare: 0,
                price: null,
                originalShare: 0.008309406908661112,
              },
              {
                directTx:
                  '595b785ab319eadbce739cde1702f0384ee93dc427157283f06071ae7a0f5972',
                directionUp: false,
                token: '',
                funds: {
                  name: 'High-risk exchange',
                  score: 70,
                  id: '61766f47820e1372d85ded59',
                  type: 'High-risk exchange',
                },
                owner: 'ChangeNOW',
                entity: '6603e884a6a313bd816dba8e',
                depth: 1,
                amount: 154530,
                amountCur: 181.99144437382776,
                currency: '',
                tx_hash:
                  '595b785ab319eadbce739cde1702f0384ee93dc427157283f06071ae7a0f5972',
                address: '37jAAWEdJ9D9mXybRobcveioxSkt7Lkwog',
                directStamp: 1709390007,
                timestamp: 1709390007,
                listType: 'Risky sources',
                share: 0.0062,
                amountDec: 0.0015453,
                deepDepthShare: 0,
                generalShare: 0.006231454503824571,
                price: null,
                originalShare: 0.006231454503824571,
              },
              {
                directTx:
                  '4e2d99e9dbb7e10777eea046908c7f6c32110004efafbd777b0b93cb581646ee',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                  type: 'unidentified service / exchange',
                },
                owner: 'unidentified service / exchange',
                depth: 3,
                amount: 50193.36023010462,
                amountCur: 59.11319566590684,
                currency: '',
                tx_hash:
                  '3efbc3e64d0fc1ab46581dac14b7446415eb782a645f494cbac10c93c51e66b9',
                address: null,
                cluster: 112109219,
                directStamp: 1706898546,
                timestamp: 1706898546,
                listType: 'Unknown sources',
                share: 0.002,
                amountDec: 0.0005019336023010461,
                deepDepthShare: 0.0020240577277420213,
                generalShare: 0,
                price: null,
                originalShare: 0.0020240577277420213,
              },
              {
                directTx:
                  '133cc96b54817ca8d5e0163702bb21635144272ed9f7316bb9ab9d469bbacacf',
                directionUp: false,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'KuCoin.com',
                depth: 9,
                amount: 45749.3078875402,
                amountCur: 53.87939313761983,
                currency: '',
                tx_hash:
                  'a4615286e5add9ef63ac9faff77543a4417c06f7ef679cc219332a1163a4f7c2',
                address: 'bc1qrt7rkpswpgmcag7txzf6ps9mvepwgndshqdx6d',
                cluster: 96386194,
                directStamp: 1709385674,
                timestamp: 1709385674,
                listType: 'Known sources',
                share: 0.0018,
                amountDec: 0.00038095,
                deepDepthShare: 0.0018448503894562176,
                generalShare: 0,
                price: null,
                originalShare: 0.0018448503894562176,
              },
              {
                directTx:
                  '964ef300e90d91dd3f464ce2b6d98ad243ed1b4e469f12744b1d4c46c07fce86',
                directionUp: false,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                  type: 'unknown single wallet service',
                },
                owner: 'unknown single wallet service',
                depth: 1,
                amount: 11214.564435146414,
                amountCur: 13.207498735363075,
                currency: '',
                tx_hash:
                  '964ef300e90d91dd3f464ce2b6d98ad243ed1b4e469f12744b1d4c46c07fce86',
                address: null,
                cluster: 122276901,
                directStamp: 1715149594,
                timestamp: 1715149594,
                listType: 'Unknown sources',
                share: 0.0004,
                amountDec: 0.0001109199999999997,
                deepDepthShare: 0,
                generalShare: 0.0004522296515746067,
                price: null,
                originalShare: 0.0004522296515746067,
              },
              {
                directTx:
                  '3f89e829f8e155efa2c15638a875d680257bdeb8630031dadf577de7866e3a8a',
                directionUp: false,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                  type: 'small transactions',
                },
                owner: 'small transactions',
                depth: 2,
                amount: 27697.192112086494,
                amountCur: 32.61924543828389,
                currency: '',
                tx_hash:
                  '13352bcd5e38e56f238a401fbae9ec60ce628ac25096550886e17a8d64f74099',
                address: null,
                directStamp: 1691659833,
                timestamp: 1691659833,
                listType: 'Unknown sources',
                share: 0.0011,
                amountDec: 0.00007784429527976934,
                deepDepthShare: 0.00044269640807523085,
                generalShare: 0.0006741986448604823,
                price: null,
                originalShare: 0.0011168950529357132,
              },
            ],
            labelBarsUof: [
              {
                directTx:
                  'a0a004812174dac9081e6e54a954affc9046d0ae4e981126bcc86bffec120561',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Low-risk exchange',
                  score: 33,
                  id: '61766e49820e13d2b95ded4e',
                  type: 'Low-risk exchange',
                },
                owner: 'Binance',
                depth: 1,
                amount: 8688716.415230285,
                amountCur: 10232.783602940182,
                currency: '',
                tx_hash:
                  'a0a004812174dac9081e6e54a954affc9046d0ae4e981126bcc86bffec120561',
                address: '1HoQLPurLCJXHHxz3wDkUCVo52xZttwPCB',
                cluster: 34203831,
                directStamp: 1701273376,
                timestamp: 1701273376,
                listType: 'Known sources',
                share: 0.3754,
                amountDec: 0.023000000000000003,
                deepDepthShare: 0.0815649514450974,
                generalShare: 0.29388977928381643,
                price: null,
                originalShare: 0.3754547307289138,
              },
              {
                directTx:
                  '5fa09ef15e14007e97f16bf103cb5359ab56d708b00a82e52208953f8d9d358f',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Exchange',
                  score: 50,
                  id: '617665da820e136f1f5ded4c',
                  type: 'Exchange',
                },
                owner: 'KuCoin',
                depth: 1,
                amount: 3994025.4355759826,
                amountCur: 4703.801578245516,
                currency: '',
                tx_hash:
                  '5fa09ef15e14007e97f16bf103cb5359ab56d708b00a82e52208953f8d9d358f',
                address: '3ETwyvEscCiMCqZhy4cyFmMc9Kj45LwB9o',
                cluster: 36804785,
                directStamp: 1701593763,
                timestamp: 1701593763,
                listType: 'Known sources',
                share: 0.1725,
                amountDec: 0.0204,
                deepDepthShare: 0.07718745770955372,
                generalShare: 0.09540141189724291,
                price: null,
                originalShare: 0.17258886960679665,
              },
              {
                directTx:
                  '4b826bdd7314927411ea4fc9677d43669912e9372effb1560a404c54bdb01006',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unhosted wallet',
                  score: 0,
                  default: true,
                  unhosted: true,
                  type: 'unhosted wallet',
                },
                owner: 'unhosted wallet',
                depth: 4,
                amount: 2098813.2248243396,
                amountCur: 2471.792210293618,
                currency: '',
                tx_hash:
                  '4c5681183acab6c1075d3a98e2b431f723cee4fadf35346989c67da31447032d',
                address:
                  'bc1qclndu0gqyjtpk3d5f0akqjwuzq73n2j9lxh9ph5wgfjghj8w4s7sl07pgs',
                directStamp: 1688055893,
                timestamp: 1688055893,
                'address-1':
                  'bc1quamzl2kh29h4gex0vucfk0re2sq576a5mwmgy5wzm0s7hltzcgwqmy29rz',
                listType: 'Unknown sources',
                share: 0.0906,
                amountDec: 0.01586012551545688,
                deepDepthShare: 0.07509629054559942,
                generalShare: 0.015597123362514658,
                price: null,
                originalShare: 0.09069341390811411,
              },
              {
                directTx:
                  '05eb2b6ac6ff199d63dadcb3fe5c9d615afff73122ce648fbea90ecbc51943ea',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Suspended exchange',
                  score: 60,
                  id: '6176710e820e13d3f25ded60',
                  type: 'Suspended exchange',
                },
                owner: 'MtGox',
                depth: 1,
                amount: 4577399.324048062,
                amountCur: 5390.846531154402,
                currency: '',
                tx_hash:
                  '05eb2b6ac6ff199d63dadcb3fe5c9d615afff73122ce648fbea90ecbc51943ea',
                address: '38JsEZeMVD2H4roq5HkfjKM64dsQB11ysS',
                cluster: 3310,
                directStamp: 1685911803,
                timestamp: 1685911803,
                listType: 'Risky sources',
                share: 0.1977,
                amountDec: 0.008393904029445254,
                deepDepthShare: 0.017908372157870167,
                generalShare: 0.17988911006132907,
                price: null,
                originalShare: 0.19779748221919918,
              },
              {
                directTx:
                  'f1cac543a7d0c3f8db46fe3c94e7ec54e70c166f3543fb418aa75e169fbdb483',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unidentified service / exchange',
                  score: 50,
                  id: '61e08b592536c394af97d390',
                  default: true,
                  type: 'unidentified service / exchange',
                },
                owner: 'unidentified service / exchange',
                depth: 2,
                amount: 1232622.8539733589,
                amountCur: 1451.6716078612658,
                currency: '',
                tx_hash:
                  'b96f97af0779b9222f3172e7f735cd49b9f6ff6e56b81912fbcb1c6fa5e79dd9',
                address: 'bc1qfhdpevk5vzda5rlkqruc7vh042v6xmac8guqnr',
                cluster: 113020304,
                directStamp: 1730992752,
                timestamp: 1730992752,
                'address-1': '31h5r2TK9d3VwsUskzQ5vgL6nhnVenpVKE',
                listType: 'Unknown sources',
                share: 0.0532,
                amountDec: 0.005168142559316986,
                deepDepthShare: 0.052661560957917,
                generalShare: 0.0006022423027866982,
                price: null,
                originalShare: 0.0532638032607037,
              },
              {
                directTx:
                  '783184ab59b56e18d81aa9e42c3d4f36ca7e4c68cb2e19aa1fb81effcdce5ae1',
                directionUp: true,
                token: '',
                funds: {
                  name: 'small transactions',
                  score: 50,
                  id: '61e08b592536c394af97d393',
                  default: true,
                  type: 'small transactions',
                },
                owner: 'small transactions',
                depth: {
                  minimum: 4,
                  maximum: 18,
                },
                amount: 1691032.8588494882,
                amountCur: 1991.5454116716592,
                currency: '',
                tx_hash: null,
                address: null,
                directStamp: 1733602375,
                timestamp: 1733602375,
                listType: 'Unknown sources',
                share: 0.073,
                amountDec: 0.0033323542873096666,
                deepDepthShare: 0.04156647913134705,
                generalShare: 0.03150602736226632,
                price: null,
                originalShare: 0.07307250649361333,
              },
              {
                directTx:
                  '5339dfa1bda0b414f0a6d2ca77eadd0f941d4615780a7375d4776588a7e14305',
                directionUp: true,
                token: '',
                funds: {
                  name: 'unknown single wallet service',
                  score: 50,
                  id: '61e08b592536c394af97d391',
                  default: true,
                  type: 'unknown single wallet service',
                },
                owner: 'unknown single wallet service',
                depth: 4,
                amount: 755291.2283815859,
                amountCur: 889.513632149404,
                currency: '',
                tx_hash:
                  '0a8f2720ab61c16a1c41b0caa8644c631806f93b83dfc4d7a38716e95433c0bc',
                address: '1JaLcWmap1HnLMTpwWkG1f7Qg1RsQipf5Q',
                cluster: 63419260,
                directStamp: 1732442617,
                timestamp: 1732442617,
                'address-1': '12q6fkqwieR61nEZHP7DK9mP5UVXvkHPfG',
                listType: 'Unknown sources',
                share: 0.0326,
                amountDec: 0.002556958843018847,
                deepDepthShare: 0.03115376831149864,
                generalShare: 0.0014836951781418977,
                price: null,
                originalShare: 0.03263746348964054,
              },
              {
                directTx:
                  '771ed2ad5719a31265ee4d0c71c12181a4bcb7b2cc4b9cb3aabdfc9594b4e326',
                directionUp: true,
                token: '',
                funds: {
                  name: 'maximum depth reached',
                  score: 50,
                  id: '61e08b592536c394af97d392',
                  default: true,
                  type: 'maximum depth reached',
                },
                owner: 'maximum depth reached',
                depth: 20,
                amount: 83209.43283224056,
                amountCur: 97.99653702625037,
                currency: '',
                tx_hash:
                  '6726ed456616fa9e0c8e59c68101c05ca525a5d7b008c2836e883d4dced64d18',
                address: null,
                directStamp: 1687958689,
                timestamp: 1687958689,
                listType: 'Unknown sources',
                share: 0.0035,
                amountDec: 0.0004752089116996734,
                deepDepthShare: 0.003595626063174546,
                generalShare: 0,
                price: null,
                originalShare: 0.003595626063174546,
              },
              {
                directTx:
                  '4da3c27a240e27f27fd5959410b63476b54510bf5a1cfb5a7439f085998a20de',
                directionUp: true,
                token: '',
                funds: {
                  name: 'Gambling',
                  score: 60,
                  id: '61766e55820e134d585ded4f',
                  type: 'Gambling',
                },
                owner: 'Betplay',
                depth: 7,
                amount: 20737.50813178421,
                amountCur: 24.422759707612805,
                currency: '',
                tx_hash:
                  '88d3d3d3e39158304801fcb81500153539989f425d41bb16cf49b3390808a06c',
                address: 'bc1qa7yuxdlktc3f4d5ftq4jzsfgw2e0wmj0jd399k',
                cluster: 84776286,
                directStamp: 1735820508,
                timestamp: 1735820508,
                'address-1': '3CqTUuTd7pjeQ5zKy6GJVD1wNoox3Yunxk',
                listType: 'Risky sources',
                share: 0.0008,
                amountDec: 0.0002073750813178421,
                deepDepthShare: 0.0008961042298445577,
                generalShare: 0,
                price: null,
                originalShare: 0.0008961042298445577,
              },
            ],
            evaluatedSofTxs: 72,
            evaluatedUofTxs: 170,
            currencies: {},
            sources: [],
          },
        },
      ],
      createdAt: '2025-07-30T17:39:01.014Z',
    },
  },
}

const startAddressCheckExampleMap = {
  risks: {
    success: true,
    data: [
      {
        title: 'Address Info',
        description: 'General address info.',
        reportPartName: 'address',
        price: 0,
        purchased: true,
        includes: [],
        status: 'Identified',
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: true,
          isNewDataAvailable: false,
        },
      },
      {
        title: 'Risk Score',
        description:
          'Shows the risk level of where the funds came from and owner info.',
        reportPartName: 'risks',
        price: 5,
        reloadInfo: {
          reloadPrice: 5,
          reloadAvailable: true,
          isNewDataAvailable: false,
        },
        purchased: true,
        includes: [],
        status: 'Calculated',
      },
      {
        title: 'Use of Funds',
        description: 'Shows where the funds were sent to.',
        reportPartName: 'uof',
        price: 30,
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: false,
        includes: [],
      },
      {
        title: 'Source of Funds',
        description: 'A list of specific, named sources that sent crypto.',
        reportPartName: 'sof',
        price: 0,
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: false,
        includes: [],
      },
      {
        title: 'All Details Report',
        description:
          'Information about the address owner, risk score, source of funds, use of funds in a single report.',
        reportPartName: 'full',
        price: 75,
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: false,
        includes: ['sof', 'uof', 'risks', 'tier2'],
      },
      {
        title: 'Money Trial',
        description: 'Shows risk exposure.',
        reportPartName: 'tier2',
        price: 30,
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: false,
        includes: ['risks'],
      },
    ],
  },
  tier2: {
    success: true,
    data: [
      {
        title: 'Address Info',
        description: 'General address info.',
        reportPartName: 'address',
        price: 0,
        purchased: true,
        includes: [],
        status: 'Identified',
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: true,
          isNewDataAvailable: false,
        },
      },
      {
        title: 'Risk Score',
        description:
          'Shows the risk level of where the funds came from and owner info.',
        reportPartName: 'risks',
        price: 5,
        reloadInfo: {
          reloadPrice: 5,
          reloadAvailable: true,
          isNewDataAvailable: false,
        },
        purchased: true,
        includes: [],
        status: 'Calculated',
        tierWithMaxPrice: false,
      },
      {
        title: 'Use of Funds',
        description: 'Shows where the funds were sent to.',
        reportPartName: 'uof',
        price: 30,
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: false,
        includes: [],
        tierWithMaxPrice: false,
      },
      {
        title: 'Source of Funds',
        description: 'A list of specific, named sources that sent crypto.',
        reportPartName: 'sof',
        price: 0,
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: false,
        includes: [],
        tierWithMaxPrice: false,
      },
      {
        title: 'All Details Report',
        description:
          'Information about the address owner, risk score, source of funds, use of funds in a single report.',
        reportPartName: 'full',
        price: 50,
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: false,
        includes: ['sof', 'uof', 'risks', 'tier2'],
        tierWithMaxPrice: false,
      },
      {
        title: 'Money Trial',
        description: 'Shows risk exposure.',
        reportPartName: 'tier2',
        price: 30,
        reloadInfo: {
          reloadPrice: 30,
          reloadAvailable: true,
          isNewDataAvailable: false,
        },
        purchased: true,
        includes: ['risks'],
        status: 'TIER2 Found',
        tierWithMaxPrice: true,
      },
    ],
  },
  full: {
    success: true,
    data: [
      {
        title: 'Address Info',
        description: 'General address info.',
        reportPartName: 'address',
        price: 0,
        purchased: true,
        includes: [],
        status: 'Identified',
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: true,
          isNewDataAvailable: false,
        },
      },
      {
        title: 'Risk Score',
        description:
          'Shows the risk level of where the funds came from and owner info.',
        reportPartName: 'risks',
        price: 5,
        reloadInfo: {
          reloadPrice: 5,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: true,
        includes: [],
        status: 'Calculated',
      },
      {
        title: 'Use of Funds',
        description: 'Shows where the funds were sent to.',
        reportPartName: 'uof',
        price: 30,
        reloadInfo: {
          reloadPrice: 30,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: true,
        includes: [],
        status: 'UOF Found',
      },
      {
        title: 'Source of Funds',
        description: 'A list of specific, named sources that sent crypto.',
        reportPartName: 'sof',
        price: 0,
        reloadInfo: {
          reloadPrice: 0,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: true,
        includes: [],
        status: 'SOF Found',
      },
      {
        title: 'All Details Report',
        description:
          'Information about the address owner, risk score, source of funds, use of funds in a single report.',
        reportPartName: 'full',
        price: 75,
        reloadInfo: {
          reloadPrice: 25,
          freeReloadCount: 3,
          reloadAvailable: true,
          isNewDataAvailable: false,
        },
        purchased: true,
        includes: ['sof', 'uof', 'risks', 'tier2'],
        status: 'All information',
      },
      {
        title: 'Money Trial',
        description: 'Shows risk exposure.',
        reportPartName: 'tier2',
        price: 30,
        reloadInfo: {
          reloadPrice: 30,
          reloadAvailable: false,
          isNewDataAvailable: false,
        },
        purchased: true,
        includes: ['risks'],
        status: 'TIER2 Found',
      },
    ],
  },
}

const exampleList = [
  {
    createdAt: '2025-07-30T16:55:08.308Z',
    coin: 'btc',
    address: '1NE2NiGhhbkFPSEyNWwj7hKGhGDedBtSrQ',
    purchased: ['risks'],
    includes: ['risks'],
    exampleId: 'risks',
    planLabel: 'Starter Plan', 
  },
  {
    createdAt: '2025-07-31T08:28:52.017Z',
    coin: 'eth',
    address: '0x44473b3356906d6ae34299ddf53020f131fa0835',
    purchased: ['risks', 'tier2'],
    includes: ['risks', 'tier2'],
    exampleId: 'tier2',
    planLabel: 'Standard Plan', 
  },
  {
    createdAt: '2025-07-30T17:39:01.014Z',
    coin: 'btc',
    address: 'bc1psvfdgmx94c4qq98ee6vvqqxhl2rnhac45tz4f9pg3jppr6aatgfqagzzqt',
    purchased: ['full'],
    includes: ['full', 'sof', 'uof', 'risks', 'tier2'],
    exampleId: 'full',
    planLabel: 'Pro Plan', 
  },
]

const getReportPartsExample = ({ exampleId, token } = {}) => {
  return reportPartsExampleMap[`${exampleId}_${token || 'default'}`]
}
const getStartAddressCheckExample = ({ exampleId } = {}) => {
  return startAddressCheckExampleMap[exampleId]
}

export { getReportPartsExample, getStartAddressCheckExample, exampleList }
